<template>

<v-container fluid>
      
    <ComponenteLoading :is-loading="loading" :message="mensaje_loading"></ComponenteLoading>


    <!-- Toolbar -->
    <v-toolbar  dark flat>

      <v-col cols="4" class="d-flex justify-begin mb-2">
   
    <v-toolbar-title v-if="!id && !caso_base">
      <div class="d-flex align-center">
        <span>{{$t('simulacion.label_nueva_simulacion')}}</span>
        <v-text-field 
          v-model="datos_generales.nombre" 
          dense 
          solo
          hide-details
          class="ml-2"
          style="max-width: 500px;"
          
        
        ></v-text-field>
      </div>
    </v-toolbar-title>   

      <v-toolbar-title v-else-if="id">{{$t('simulacion.label_simulacion_existente')}} {{id}} {{datos_generales.nombre}}</v-toolbar-title>
      <v-toolbar-title v-if="this.caso_base">Caso base simulación</v-toolbar-title>
    </v-col>

        <v-divider class="mx-4" inset vertical></v-divider>



        <v-spacer></v-spacer>





        <div>
          <!-- Información del horizonte -->
          <v-tooltip location="top" width="320px" variant="outlined">
            <template v-slot:activator="{ props }">
              <v-chip color="main" v-bind="props" class="ma-2">{{$t('comun.horizonte')}}</v-chip>
            </template>
            <!-- <span>The horizon of events goes from {{dates.first_year}} to {{dates.last_year}}</span> -->
            <span>
              {{$t('comun.texto_horizonte').replace('anio_inicio',this.datos_generales.anio_inicio).replace('anio_fin',this.datos_generales.anio_fin)}}
            
            </span>
            
          </v-tooltip>
          <v-btn
            v-if="!id && !caso_base && !datosCasoBaseCargados"
            color="primary"
            class="ma-2"
            :loading="loading"
            @click="cargarDatosCasoBaseManual"
          >
            <v-icon left>mdi-database-import</v-icon>
            {{$t('comun.cargar_datos')}}
          </v-btn>

          <!-- Botón Guardar -->
          <v-btn v-if="!id && !caso_base"
            color="primary"
            class="ma-2"
            
            
            @click="saveData"
          >
            <v-icon left>mdi-cloud</v-icon>
            {{$t('comun.guardar_datos')}}
          </v-btn>

          <v-btn v-if="!id && caso_base"
            color="primary"
            class="ma-2"
            
            
            @click="guardarCasoBase"
          >
            <v-icon left>mdi-cloud</v-icon>
            {{$t('comun.guardar_caso_base')}}
          </v-btn>

          <!-- Botón Importar -->
          <v-btn v-if="!id"
            color="primary"
            class="ma-2"
            
            
            @click="importData"
          >
            <v-icon left>mdi-file-import</v-icon>
            {{$t('comun.boton_importar')}}
          </v-btn>

          <!-- Botón Exportar -->
          <v-btn
            color="primary"
            class="ma-2"
            
            
            @click="exportData"
          >
            <v-icon left>mdi-file-export</v-icon>
            {{$t('comun.boton_exportar')}}
          </v-btn>
        </div>
        <!-- <v-btn v-if="!id && !vista_operador" 
            color="primary"         
            @click="guardar_caso_base()"                
          >
          <v-icon left>mdi-content-save</v-icon>        
            {{$t('comun.guardar_datos')}}
          </v-btn> -->

  
        <v-btn v-if="!id && !caso_base" 
          color="primary"         
          @click="lanzar_simulacion()"                
        >
        <v-icon left>mdi-rocket-launch</v-icon>        
        {{$t('simulacion.boton_lanzar')}}
      </v-btn>


      <v-btn v-if="!id && this.showDescargarIn"      
          color="primary"         
          @click="descargar_in()"                
        >      
          <v-icon left>mdi-download</v-icon>        
          {{$t('simulacion.boton_descargar_in')}}
      </v-btn>
      


    </v-toolbar>

    <!--
    <div class="d-flex">

      
      <v-tabs
        v-model="tab"
        color="primary"
        direction="vertical"
        show-arrows
        class="elevation-2"
      >
        <v-tab value="1" prepend-icon="mdi-cogs">{{$t('simulacion.tab.configuracion')}}</v-tab>
        <v-tab value="0" prepend-icon="mdi-factory">{{$t('simulacion.tab.planta')}}</v-tab>
        <v-tab value="2" prepend-icon="mdi-handshake-outline">{{$t('simulacion.tab.ppas')}}</v-tab>
        <v-tab value="3" prepend-icon="mdi-currency-usd" v-if="ejecucion.OPC_MCDO!=3">{{$t('simulacion.tab.mercado')}}</v-tab>
        <v-tab v-if="id" value="5" prepend-icon="mdi-chart-bar">{{$t('simulacion.tab.resultado')}}</v-tab>

      </v-tabs>

      
      <v-tabs-window v-model="tab" >
        

          
          <v-tabs-window-item value="0">
          
              
              <v-tabs
                v-model="tab2"
                bg-color="primary"
              >
                <v-tab value="3">{{$t('simulacion.tab.electrolizador')}}</v-tab>
                <v-tab value="1">{{$t('simulacion.tab.almacenamiento')}}</v-tab>
                <v-tab value="2">{{$t('simulacion.tab.bateria')}}</v-tab>
                <v-tab value="5" v-if="ejecucion.OPC_PV!=0">{{$t('simulacion.tab.fotovoltaica')}}</v-tab>             
                <v-tab value="6">{{$t('simulacion.tab.eolica')}}</v-tab>
                <v-tab value="4">{{$t('simulacion.tab.demanda')}}</v-tab>
                
              </v-tabs>

              <v-card-text>



              </v-card-text>


              
          </v-tabs-window-item>

        

      </v-tabs-window>


    </div>
    -->



    <div class="d-flex" style="width: 100%;">

      <!-- Barra de tabs vertical -->
      <v-tabs
        v-model="tab"
        color="primary"
        direction="vertical"
        show-arrows
        class="elevation-2"
      >
        <!-- v-tab value="1" prepend-icon="mdi-cogs">{{$t('simulacion.tab.configuracion')}}</v-tab>
        <v-tab value="0" prepend-icon="mdi-factory">{{$t('simulacion.tab.planta')}}</v-tab>
        <v-tab value="4" prepend-icon="mdi-fire">{{$t('simulacion.tab.hidrogeno')}}</v-tab>
        <v-tab value="2" prepend-icon="mdi-handshake-outline" v-if="ejecucion.OPC_MCDO!=3 & ejecucion.OPC_PPA!=0">{{$t('simulacion.tab.ppas')}}</v-tab>
        <v-tab value="3" prepend-icon="mdi-currency-usd" v-if="ejecucion.OPC_MCDO!=3">{{$t('simulacion.tab.mercado')}}</v-tab> -->
       
        <!-- <v-tab value="6" prepend-icon="mdi-chart-line">{{$t('simulacion.tab.curvas')}}</v-tab> -->

       

        <v-tab value="1">
          <template #prepend>
            <div class="v-tab__prepend d-inline-flex align-center">
              <v-img
                :src="require('@/assets/ajustes.png')"
                alt="icono ajustes"
                width="20"
                height="20"
                class="me-2"
                cover
                />
              {{ $t('simulacion.tab.configuracion') }}
            </div>
            </template>
          <!-- {{$t('simulacion.tab.configuracion')}} -->
        
        </v-tab>
        <v-tab value="0">

          <template #prepend>
            <div class="v-tab__prepend d-inline-flex align-center">
              <v-img
                :src="require('@/assets/industria.png')"
                alt="icono fabrica"
                width="20"
                height="20"
                class="me-2"
                cover
                />
              {{ $t('simulacion.tab.planta') }}
            </div>
            </template>

          <!-- {{$t('simulacion.tab.planta')}} -->

        </v-tab>
        <v-tab value="4">
          <template #prepend>
            <div class="v-tab__prepend d-inline-flex align-center">
              <v-img
                :src="require('@/assets/combustible.png')"
                alt="icono fuego"
                width="20"
                height="20"
                class="me-2"
                cover
                />
              {{ $t('simulacion.tab.hidrogeno') }}
            </div>
            </template>
          <!-- {{$t('simulacion.tab.hidrogeno')}} -->
        </v-tab>

        <!-- Tarea148 
        <v-tab value="2"
  v-if="ejecucion.OPC_MCDO != 3 && (ejecucion.OPC_PPA != 0 || ejecucion.OPC_PCPPAPV === 1 || ejecucion.OPC_PCPPAEOL === 1)">
        -->
        <v-tab value="2" v-if="mostrarTabPPAs">


          <template #prepend>
            <div class="v-tab__prepend d-inline-flex align-center">
              <v-img
                :src="require('@/assets/ahorro-de-energia.png')"
                alt="icono fuego"
                width="20"
                height="20"
                class="me-2"
                cover
                />
              {{ $t('simulacion.tab.ppas') }}
            </div>
            </template>
          <!-- {{$t('simulacion.tab.ppas')}} -->
        </v-tab>
        
        
        
        <v-tab value="3"  v-if="ejecucion.OPC_MCDO!=3">
          <template #prepend>
            <div class="v-tab__prepend d-inline-flex align-center">
              <v-img
                :src="require('@/assets/destello.png')"
                alt="icono euro"
                width="20"
                height="20"
                class="me-2"
                cover
                />
              {{ $t('simulacion.tab.mercado') }}
            </div>
            </template>
        <!--  {{$t('simulacion.tab.mercado')}} -->
        
        </v-tab>

       <!-- <v-tab value="7" >
          <template #prepend>
            <div class="v-tab__prepend d-inline-flex align-center">
              <v-img
                :src="require('@/assets/convenio.png')"
                alt="icono inversion"
                width="20"
                height="20"
                class="me-2"
                cover
                />
              {{ $t('simulacion.tab.economicos') }}
            </div>                 
            </template>

           {{$t('simulacion.tab.economicos')}} 
        </v-tab> -->


        <v-tab value="6" prepend-icon="mdi-chart-line">
          <template #prepend>
            <div class="v-tab__prepend d-inline-flex align-center">
              <v-img
                :src="require('@/assets/entorno.png')"
                alt="icono inversion"
                width="20"
                height="20"
                class="me-2"
                cover
                />
              {{ $t('simulacion.tab.config') }}
            </div>
            </template>
          <!-- {{$t('simulacion.tab.curvas')}} -->

        </v-tab>

        <v-tab v-if="id" value="5" >
          <template #prepend>
            <div class="v-tab__prepend d-inline-flex align-center">
              <v-img
                :src="require('@/assets/estado-de-resultados2.png')"
                alt="icono resultados"
                width="20"
                height="20"
                class="me-2"
                cover
                />
              {{ $t('simulacion.tab.resultado') }}
            </div>
            </template>
         <!--  {{$t('simulacion.tab.resultado')}} -->
        
        </v-tab>

        <v-tab v-if="id && !esHijo" value="8" > 
          <template #prepend>
            <div class="v-tab__prepend d-inline-flex align-center">
              <v-img
                :src="require('@/assets/escoba.png')"
                alt="icono resultados"
                width="20"
                height="20"
                class="me-2"
                cover
                />
              {{ $t('simulacion.tab.barridos') }}
            </div>
            </template>
         <!--  {{$t('simulacion.tab.resultado')}} -->
        
        </v-tab>

      </v-tabs>

      <!-- Contenido de los tabs -->
      <v-tabs-window v-model="tab" class="flex-grow-1">

        <!-- PLANTA -->
        <v-tabs-window-item value="0">
          <v-container class="pa-0" fluid>
            <v-tabs
              v-model="tab2"
              bg-color="primary"
              @update:modelValue="handleTabChange"
            >
              <v-tab value="7">{{$t('simulacion.tab.electrolizador')}}</v-tab>
              <v-tab value="3">{{$t('simulacion.tab.planta_electrolisis')}}</v-tab>
              
              <v-tab value="1" v-if="ejecucion.OPC_ALM!=0">{{$t('simulacion.tab.almacenamiento')}}</v-tab>
              <v-tab value="2" v-if="ejecucion.OPC_BAT>0">{{$t('simulacion.tab.bateria')}}</v-tab>
              <!--<v-tab value="2"  v-if="ejecucion.OPC_MCDO==3">{{$t('simulacion.tab.bateria')}}</v-tab>-->
              <v-tab value="5" v-if="ejecucion.OPC_PV!=0">{{$t('simulacion.tab.fotovoltaica')}}</v-tab>
              <v-tab value="6" v-if="ejecucion.OPC_EOL!=0">{{$t('simulacion.tab.eolica')}}</v-tab>
              <v-tab value="8">{{$t('simulacion.modulo.datos_economicos.titulo')}}</v-tab>

            
            </v-tabs>
            <v-card-text>
              


              <v-tabs-window v-model="tab2">              
<v-tabs-window-item value="7">
                  <ComponenteInputElectrolizador 
                  :disabled="this.id"
                  v-model:electrolizador="electrolizador"
                  v-model:gen="gen"
                  v-model:rendimientoElectrolizador="electrolizador_rend"
                  v-model:degradacionElectrolizador="electrolizador_degrad"
                  v-model:HoraFinal="HoraFinal"
                  :id_simulacion="id_simulacion"
                  @update:electrolizador="electrolizador = $event"
                  :years="yearsSim"
                  /></v-tabs-window-item>
              <v-tabs-window-item value="3">
                  <ComponenteInputPlantaElectrolisis
                  ref="hijoPlantaElectrolisis"
                  :disabled="this.id"
                  v-model:planta_electrolisis="planta_electrolisis"
                  v-model:gen="gen"
                  :tablas="curvas"
                  :usarDucto="usarDucto"
                  @update:usarDucto="usarDucto = $event"
                  :usarConexion="usarConexion"
                  @update:usarConexion="usarConexion = $event"
                  :usarTube="usarTube"
                  @update:usarTube="usarTube = $event"
                  />
                  </v-tabs-window-item>
                
                  <!--
                  <ComponenteInputElectrolizadorRend v-model="electrolizador_rend"/>
                  -->
                

                
                  <!--
                  <ComponenteInputElectrolizadorRend v-model="electrolizador_rend"/>
                  -->
                

                <v-tabs-window-item value="1">
                  <ComponenteInputAlmacenamiento ref="hijoInputAlmacenamiento" :disabled="this.id" v-model="almacenamiento"/>
                </v-tabs-window-item>

                <v-tabs-window-item value="2">
                  <ComponenteInputBateria ref="hijoInputBateria" :disabled="this.id" v-model="bateria"/>
                </v-tabs-window-item>

                

                <v-tabs-window-item v-if="ejecucion.OPC_PV!=0" value="5">
                  <ComponenteInputFotovoltaica ref="hijoInputFotovoltaica" :disabled="this.id" v-model="fotovoltaica" :years="yearsPV"/>
                  <ComponenteInputPerfilFotovoltaica ref="hijoInputPerfilFotovoltaica" :disabled="this.id" v-model="series.gpv" :years="yearsPV"/>
                </v-tabs-window-item>

                <v-tabs-window-item value="6">
                  <ComponenteInputEolica ref="hijoInputEolica" :disabled="this.id" v-model="eolica" :years="yearsEol"/>
                  <ComponenteInputPerfilEolica ref="hijoInputPerfilEolica" :disabled="this.id" v-model="series.geol" :years="yearsEol"/>
                </v-tabs-window-item>
              <v-tabs-window-item value="8">
                <ComponenteDatosEconomicos 
                :disabled="this.id"
                v-model:datos_generales="datos_generales"
                v-model:datos_economicos="datos_economicos"
                v-model:ejecucion="ejecucion"
                :id_simulacion="id"
                @subv-edit-manual="guardarCacheSubvencionesManual"
                
                />
              </v-tabs-window-item>

              </v-tabs-window>




            </v-card-text>
          </v-container>
        </v-tabs-window-item>

        <!-- Hidrógeno -->
        <v-tabs-window-item value="4">
          <v-container class="pa-0" fluid>
            <v-tabs
              v-model="tabHidrogeno"
              bg-color="primary"
            >
              <v-tab value="2">{{$t('simulacion.tab.demanda')}}</v-tab>
              <v-tab value="1">{{$t('simulacion.tab.datos_anuales')}}</v-tab>
              
              
            </v-tabs>
            <v-card-text>
              
              <v-tabs-window v-model="tabHidrogeno">              

              <v-tabs-window-item value="1">
                  <ComponenteDatosAnuales
                  :disabled="this.id"
                  :datos_generales="datos_generales"
                  v-model="datos_anuales"
                  />
                  </v-tabs-window-item>

                  

                <v-tabs-window-item value="2">
                  
                    <v-tabs
                        v-model="tab4"
                        bg-color="primary"
                      >
                        <v-tab value="1" v-if="ejecucion.OPCDEM_A==1">{{$t('simulacion.tab.anual')}}</v-tab>
                        <v-tab value="2" v-if="ejecucion.OPCDEM_M==1">{{$t('simulacion.tab.mensual')}}</v-tab>
                        <v-tab value="3" v-if="ejecucion.OPCDEM_D==1">{{$t('simulacion.tab.diaria')}}</v-tab>
                      </v-tabs>

                      <v-card-text>                  
                        <v-tabs-window v-model="tab4">
                          <v-tabs-window-item v-if="ejecucion.OPCDEM_A==1" value="1">
                            <ComponenteInputDemanda v-model="demanda.d1" 
                           :disabled="this.id"
                            v-model:demanda_lc="demandaLCActual.d1"
                            v-model:opc_mcdo="ejecucion.OPC_MCDO"
                            v-model:infl="demanda_inflaciones"
                            :datos_generales="this.datos_generales"
                            
                            v-model:ejecucion="ejecucion"
                            @inflacion="calcular_inflacion"
                            ref="DemandaAnual"
                            name="Anual"
                            />
                          </v-tabs-window-item>

                          <v-tabs-window-item v-if="ejecucion.OPCDEM_M==1" value="2">
                            <ComponenteInputDemanda v-model="demanda.d2" 
                            :disabled="this.id"
                            v-model:demanda_lc="demandaLCActual.d2"
                            v-model:opc_mcdo="ejecucion.OPC_MCDO" 
                            v-model:infl="demanda_inflaciones"
                            :datos_generales="this.datos_generales"
                            v-model:opc_lcohlc="ejecucion.OPC_LCOHLC"
                            v-model:ejecucion="ejecucion"
                            @inflacion="calcular_inflacion"
                            ref="DemandaMensual"
                            />
                          </v-tabs-window-item>

                          <v-tabs-window-item v-if="ejecucion.OPCDEM_D==1" value="3">
                            <ComponenteInputDemanda v-model="demanda.d4"
                            :disabled="this.id" 
                            v-model:demanda_lc="demandaLCActual.d4"
                            v-model:opc_mcdo="ejecucion.OPC_MCDO"
                            v-model:infl="demanda_inflaciones"
                            :datos_generales="this.datos_generales"
                            v-model:opc_lcohlc="ejecucion.OPC_LCOHLC"
                            v-model:ejecucion="ejecucion"
                            @inflacion="calcular_inflacion"
                            ref="DemandaDiaria"
                            />
                          </v-tabs-window-item>              
                        </v-tabs-window>

                      </v-card-text>
                  
                </v-tabs-window-item>

                <!-- <v-tabs-window-item v-if="ejecucion.OPC_PV!=0" value="5">
                  <ComponenteInputFotovoltaica ref="hijoInputFotovoltaica" :disabled="this.id" v-model="fotovoltaica"/>
                  <ComponenteInputPerfilFotovoltaica ref="hijoInputPerfilFotovoltaica" :disabled="this.id" v-model="series.gpv"/>
                </v-tabs-window-item>

                <v-tabs-window-item value="6">
                  <ComponenteInputEolica ref="hijoInputEolica" :disabled="this.id" v-model="eolica"/>
                  <ComponenteInputPerfilEolica ref="hijoInputPerfilEolica" :disabled="this.id" v-model="series.geol"/>
                </v-tabs-window-item> -->

              </v-tabs-window>




            </v-card-text>
          </v-container>
        </v-tabs-window-item>

        <!-- PPA -->
        <v-tabs-window-item value="2">
          <v-container class="pa-0" fluid>

        <v-tabs
            v-model="tab3"
            bg-color="primary"
          >
            <v-tab v-if="ejecucion.OPC_PPA != 0" value="1">{{$t('simulacion.tab.configuracion_ppa')}}</v-tab>
            <v-tab v-if="ejecucion.OPC_PPA != 0" value="2">{{$t('simulacion.tab.perfiles')}}</v-tab>
            <v-tab v-if="ejecucion.OPC_PCPPAPV !== 0 || ejecucion.OPC_PCPPAEOL !== 0" value="3">{{$t('simulacion.tab.ppa_venta')}}</v-tab>
          </v-tabs>

          
          <v-card-text>
            <v-tabs-window v-model="tab3">
              <v-tabs-window-item value="1" v-if="ejecucion.OPC_PPA != 0">
                <ComponenteInputPPAConfiguracion
                  ref="hijoPPAConf"
                  :disabled="this.id" 
                  v-model:configuracion="ppa_configuracion"
                  v-model:ppa_precio_compra_matrix="ppa_precio_compra_matrix"
                  v-model:perfiles="perfiles"
                  v-model:venta_excedente="ppa_venta_excedente"
                  :datos_generales="this.datos_generales"
                  
                  :ejecucion="ejecucion"
                  @update:modoPcvppa="actualizarModoPcvppa"
                  />
              </v-tabs-window-item>

              <v-tabs-window-item value="2" v-if="ejecucion.OPC_PPA != 0">
                <!-- {{ this.perfiles }} -->
                <!-- {{ typeof this.perfiles }}
                Array: {{ Array.isArray(this.perfiles)  }}
                perfiles: {{ this.perfiles?.length>0 }} -->        
                <!-- Para retrocompatibilidad -->
                    <div v-if="
                    Array.isArray(this.perfiles) &&
                  this.perfiles?.length > 0 &&
                  'periodo' in this.perfiles[0] &&
                  'ppa1' in this.perfiles[0] &&
                  'ppa2' in this.perfiles[0] &&
                  'ppa3' in this.perfiles[0]">
                 <!-- Modo de perfiles anuales por PPA -->
                  <ComponenteInputPPAPerfiles ref="hijoPPAPerf" :disabled="this.id" v-model="perfiles"/>
                   <!-- <ComponenteInputPPAPerfiles ref="hijoPPAPerf" :disabled="this.id" v-model="perfiles"/> -->
                </div>
                <div v-else>
                  <!-- Modo nuevo, valores anuales diferentes para cada PPA -->
                  <v-tabs
                    v-model="tabPPA"
                    bg-color="primary"
                  >
                    <v-tab value="1">{{$t('simulacion.modulo.ppa_perfiles.titulo1')}}</v-tab>
                    <v-tab value="2">{{$t('simulacion.modulo.ppa_perfiles.titulo2')}}</v-tab>
                    <v-tab  value="3">{{$t('simulacion.modulo.ppa_perfiles.titulo3')}}</v-tab>
                  </v-tabs>
                  <v-tabs-window v-model="tabPPA">
                    <v-tabs-window-item value="1" >
                       <ComponentePerfilesPPA :disabled="this.id"  v-model:perfil="perfiles.PPA1" nombre_descarga="PPA1"  ref="hijoPPA1" :desdeSim="true" :years="yearsSim" :years_no_active="this.YearsPPA1NoActive"  />
                     
                      <!-- <ComponentePerfilesPPA :disabled="this.id"  v-model:costes="costes"  ref="hijoPPA1" :desdeSim="true" :years="yearsSim" :years_no_active="yearsPPA1NoActive"  />
                       <ComponenteCostes :disabled="this.id"  v-model:costes="costes"  ref="hijoCostes" :desdeSim="true" :years="yearsSim" /> -->
                    </v-tabs-window-item>
                    <v-tabs-window-item value="2" >
                       <ComponentePerfilesPPA :disabled="this.id"  v-model:perfil="perfiles.PPA2" nombre_descarga="PPA2"  ref="hijoPPA2" :desdeSim="true" :years="yearsSim" :years_no_active="this.YearsPPA2NoActive"  />
                     
                    </v-tabs-window-item>
                    <v-tabs-window-item value="3" >
                     <ComponentePerfilesPPA :disabled="this.id"  v-model:perfil="perfiles.PPA3" nombre_descarga="PPA3"  ref="hijoPPA3" :desdeSim="true" :years="yearsSim" :years_no_active="this.YearsPPA3NoActive"  />
                     
                    </v-tabs-window-item>
                  </v-tabs-window>
                  
                </div>
                
              </v-tabs-window-item>
              <v-tabs-window-item value="3" v-if="ejecucion.OPC_PCPPAPV !== 0 || ejecucion.OPC_PCPPAEOL !== 0">
                <ComponentePPAventa 
                ref="hijoPPAVenta"
                :disabled="id"
                :datos_generales="datos_generales"
                :modelValue="ppa_venta"
                :ejecucion="ejecucion"
                @update:modelValue="actualizarFragmento"
                @update:modoPpaVenta="actualizarModoPpaVenta"
              />
              </v-tabs-window-item>
            </v-tabs-window>

          </v-card-text>
          


           </v-container> 
        </v-tabs-window-item>
      
        <!-- PRECIOS -->
        <v-tabs-window-item v-if="ejecucion.OPC_MCDO!=3" value="3">
          <v-tabs
            v-model="tab4"
            bg-color="primary"
          >
            <v-tab value="1">{{$t('simulacion.tab.precios')}}</v-tab>
            <v-tab value="2">{{$t('simulacion.tab.peajes')}}</v-tab>
            <v-tab value="3" >{{$t('pestana_configuracion_general.tab_coste')}}</v-tab>
            <v-tab value="4">{{$t('simulacion.tab.economicosh')}}</v-tab>
          </v-tabs>
          <v-card-text>
            <v-tabs-window v-model="tab4">
              <v-tabs-window-item value="1">
                <ComponenteInputPrecios :disabled="this.id" v-model="series.pcmd" :datos_generales="datos_generales"/>
              </v-tabs-window-item>

              <v-tabs-window-item value="2">
               <ComponentePeajes
               :disabled="this.id"
               v-model:peajes="peajes"
               v-model:conf_costes="conf_costes"
               />
              </v-tabs-window-item>
              <v-tabs-window-item value="3">
                <!-- Coste passthrough -->
              <ComponenteCostes :disabled="this.id"  v-model:costes="costes"  ref="hijoCostes" :desdeSim="true" :years="yearsSim" />
        </v-tabs-window-item>

        <v-tabs-window-item value="4">
                  <ComponenteHidrogenoEconomico
                  ref="hijoOtrosCostes"
                  :disabled="this.id"
                  v-model:datos_generales="datos_generales"
                  v-model="datos_econ_hidrog"
                  />
                  </v-tabs-window-item>
            </v-tabs-window>
          </v-card-text>
          
            
        </v-tabs-window-item>

        <!-- DATOS ECONÓMICOS 
        <v-tabs-window-item value="7">
          <v-tabs
            v-model="tab7"
            bg-color="primary"
          >
            <v-tab value="1">{{$t('simulacion.modulo.datos_economicos.titulo')}}</v-tab>
            <v-tab value="2">{{$t('simulacion.tab.economicosh')}}</v-tab>
          </v-tabs>
          <v-card-text>
            <v-tabs-window v-model="tab7">
              <v-tabs-window-item value="1">
                <ComponenteDatosEconomicos 
                :disabled="this.id"
                v-model:datos_generales="datos_generales"
                v-model:datos_economicos="datos_economicos"
                :id_simulacion="id"
                />
              </v-tabs-window-item>
              <v-tabs-window-item value="2">
                  <ComponenteHidrogenoEconomico
                  :disabled="this.id"
                  v-model:datos_generales="datos_generales"
                  v-model="datos_econ_hidrog"
                  />
                  </v-tabs-window-item>
            </v-tabs-window>
          </v-card-text>
        </v-tabs-window-item>-->

        <!-- CONFIGURACION -->
        <v-tabs-window-item value="1">
            <v-row>
              <v-col cols="7" sm="7">
                <!--
                <ComponenteInputEjecucion v-model="ejecucion"/>
                -->
                <!--  -->
                <ComponenteInputEjecucion
                ref="hijoInEjec"
                :disabled="this.id"
                  v-model:ejecucion="ejecucion"
                  v-model:planta_electrolisis="planta_electrolisis"
                  v-model:datos_generales="datos_generales"
                  v-model:electrolizador="electrolizador"
                  v-model:almacenamiento="almacenamiento"
                  v-model:bateria="bateria"
                  v-model:ppa_configuracion="ppa_configuracion"
                  v-model:gen="gen"
                  v-model:eolica="eolica"
                  v-model:fotovoltaica="fotovoltaica"

                  v-model:datos_economicos="datos_economicos"
                  :usarDucto="usarDucto"
                  @update:usarDucto="usarDucto = $event"
                  :usarConexion="usarConexion"
                  @update:usarConexion="usarConexion = $event"
                  :usarTube="usarTube"
                  @update:usarTube="usarTube = $event"
                  :id_simulacion="id"
                  :usarFVfija="usarFVfija"
                  @update:usarFVfija="usarFVfija = $event"
                  :usarEOfija="usarEOfija"
                  @update:usarEOfija="usarEOfija = $event"

                  @calcular_anios="debouncedObtenerPrecios();debouncedObtenerPerfiles()"
                  @calcular_hora_final="calcularHoraFinal"
                  @actualizar-an-tot="ejecucion.AN_TOT = $event"
                
                  @descargar_precios="debouncedObtenerPrecios"
                />


              </v-col>
              <v-col cols="5" sm="5">
                <!--
                <ComponenteGame v-model:ejecucion="ejecucion"/>
                -->
                
                <ComponenteDiagrama
                  :diagram="diagramaSinResultados"
                  :mostrar-resultados="false"
                  @module-click="irAModuloDesdeDiagrama"
                />
                
                
              </v-col>


            </v-row>
        </v-tabs-window-item>

        <!-- CURVAS -->
        <v-tabs-window-item value="6">

          <v-tabs
                        v-model="tab_conf"
                        bg-color="primary"
                      >
                      
      <v-tab value="0" > {{ $t('simulacion.tab.curvas') }}</v-tab>
    <!-- <v-tab value="1" >{{$t('pestana_configuracion_general.tab_coste')}}</v-tab>-->

        </v-tabs>
        <v-tabs-window v-model="tab_conf">              
<!-- Curvas -->
          <v-tabs-window-item value="0">
              <ComponenteConfiguracion :disabled="this.id" :caso_base="false" v-model:curvas="curvas" :id_simulacion="id"   />
          </v-tabs-window-item>
 <!-- Costes 
          <v-tabs-window-item value="1">
              <ComponenteCostes :disabled="this.id"  v-model:costes="costes"  ref="hijoCostes" :desdeSim="true" />
          </v-tabs-window-item>-->
        </v-tabs-window>

        </v-tabs-window-item>

       



        <!-- RESULTADO -->
        <v-tabs-window-item v-if="id" value="5">

          <v-container v-if="resultado.resultado=='ok'" class="pa-0" fluid>

            <v-tabs
                v-model="tab5"
                bg-color="primary"
              >                
                <v-tab value="1">{{this.$t('simulacion.modulo.resultado.titulo_resumen')}}</v-tab>                
               <!--   <v-tab value="2">{{this.$t('simulacion.modulo.resultado.titulo_economico')}}</v-tab>-->
               <v-tab value="3">{{this.$t('simulacion.modulo.resultado.titulo_temporalidad')}}</v-tab>
                 <v-tab value="5">{{ $t('simulacion.modulo.resultado.titulo_diseno') }}</v-tab>

                <v-tab value="4">{{this.$t('simulacion.modulo.resultado.flujos-caja.tab')}}</v-tab>
                <v-tab value="6">{{this.$t('simulacion.modulo.resultado.periodo-tarifario.tab')}}</v-tab>
                <!--            
                <v-tab value="3">Resultado producciones</v-tab>                
                <v-tab value="4">Resultado operativo</v-tab>
                -->

                <v-spacer></v-spacer>
                <!-- Con horarios -->
              <v-tooltip location="top" width="320px" variant="outlined">
                <template #activator="{ props }">
                  <v-btn
                    v-bind="props"
                    color="#D2D2D2"
                    density="compact"
                    class="mt-3 ml-2 mr-2"
                    @click="descargar_resultados(false)"  
                  >
                    {{$t('comun.descargar_resultados_completos')}}
                    <v-icon size="20" class="ml-1">mdi-download</v-icon>
                  </v-btn>
                </template>
                <span>
                  {{$t('comun.tooltip_descargar_con_horarios')}}
                </span>
              </v-tooltip>

              <!-- Sin horarios -->
              <v-tooltip location="top" width="320px" variant="outlined">
                <template #activator="{ props }">
                  <v-btn
                    v-bind="props"
                    color="#D2D2D2"
                    density="compact"
                    class="mt-3 ml-2 mr-2"
                    @click="descargar_resultados(true)"   
                  >
                    {{$t('comun.descargar_resultados_incompletos')}}
                    <v-icon size="20" class="ml-1">mdi-download</v-icon>
                  </v-btn>
                </template>
                <span>
                  {{$t('comun.tooltip_descargar_sin_horarios')}}
                </span>
              </v-tooltip>

              </v-tabs>

              
              <v-card-text>
                <v-tabs-window v-model="tab5">

                  <v-tabs-window-item value="5">
                    <v-row>
                      <v-col cols="12" sm="12">                        
                        <ComponenteDiagrama :diagram="diagramaConResultados" :mostrar-resultados="true" /> 
                      </v-col>
                    </v-row>
                  </v-tabs-window-item>

                  <v-tabs-window-item value="1">
                    <!--<ComponenteResultadoVariables v-model:resultado_variables="resultado_variables"/>-->                                        
                    <ComponenteResultadoResumen v-model:resultado_variables="resultado.resumen"/>
                    
                  </v-tabs-window-item>

                  <v-tabs-window-item value="2">
                    <ComponenteResultadoEconomico
                      v-model:resultado_economico="resultado.economico"
                    />
                    <!--
                    <ComponenteResultadoSimulacion v-model="resultado"/>
                    -->
                  </v-tabs-window-item>
                  <v-tabs-window-item value="3">
                    <ComponenteResultadoTemporal
                    :datos_temporales="datos_temporales"
                    
                    :datos_generales="datos_generales"
                    :datos_anuales="datos_anuales_graf" 
                    />
                  </v-tabs-window-item>
                  <v-tabs-window-item value="4">
                    <ComponenteResultadoFlujosCaja
                      :resumen_flujos_caja="resumenFlujosCaja"
                      :datos_sal_an2="datosSalAn2"
                      :datos_sal_an2_total="datosSalAn2Total"
                      :datos_sal_an="datosSalAn"     
                      :diagrama="valores_diagrama"
                    />
                  </v-tabs-window-item>
                  <v-tabs-window-item value="6">
                    <ComponenteResultadoPeriodosTarifarios
                     
                      :datos_sal_an="datosSalAn"
                      :anio_inicio="datos_generales.anio_inicio"
                      :anio_fin="datos_generales.anio_fin"
                        prefix="PCONT_t"
                        :titulo="this.$t('simulacion.modulo.resultado.periodo-tarifario.titulo')"
                                      />
                      <ComponenteResultadoPeriodosTarifarios
                     
                      :datos_sal_an="datosSalAn"
                      :anio_inicio="datos_generales.anio_inicio"
                      :anio_fin="datos_generales.anio_fin"
                        prefix="HOR_t"
                        :titulo="this.$t('simulacion.modulo.resultado.periodo-tarifario.titulo_utilizacion')"

                                      />
                                    
                  </v-tabs-window-item>

                </v-tabs-window>
                
              </v-card-text>

          </v-container>

          <v-container v-else class="pa-0" fluid>
            <!-- Contenido cuando resultado NO es 'ok' -->
            <p>{{resultado.resultado}}</p>
          </v-container>


        </v-tabs-window-item>


        <!-- BARRIDOS -->
        <v-tabs-window-item v-if="id" value="8">

          <v-container v-if="resultado.resultado=='ok'" class="pa-0" fluid>
            <ComponenteBarridos
              :datos_modelo="datosModeloParaBarrido"
              :id="id"
              :resultado_variables="resultado.resumen"
            />
          </v-container>

          <v-container v-else class="pa-0" fluid>
            <!-- Contenido cuando resultado NO es 'ok' -->
            <p>{{resultado.resultado}}</p>
          </v-container>


        </v-tabs-window-item>





      </v-tabs-window>



      <!--
      <ComponenteConfiguracion v-if=false v-model:tablas="tablas" />
      -->






    </div>







  
</v-container>
</template>

<script>
import ComponenteConfiguracion from '../components/ComponenteConfiguracion.vue';

import ComponenteInputEjecucion from '../components/ComponenteInputEjecucion.vue';

import ComponenteInputAlmacenamiento from '../components/ComponenteInputAlmacenamiento.vue';
import ComponenteInputBateria from '../components/ComponenteInputBateria.vue';
import ComponenteInputElectrolizador from '../components/ComponenteInputElectrolizador.vue';
import ComponenteInputPlantaElectrolisis from '../components/ComponenteInputPlantaElectrolisis.vue';
//import ComponenteInputElectrolizadorRend from '../components/ComponenteInputElectrolizadorRend.vue';

import ComponenteInputDemanda from '../components/ComponenteInputDemanda.vue';
import ComponenteDatosAnuales from '../components/ComponenteDatosAnuales.vue';
import ComponenteHidrogenoEconomico from '../components/ComponenteHidrogenoEconomico.vue';

import ComponenteInputPerfilFotovoltaica from '../components/ComponenteInputPerfilFotovoltaica.vue';
import ComponenteInputPerfilEolica from '../components/ComponenteInputPerfilEolica.vue';
import ComponenteInputFotovoltaica from './ComponenteInputFotovoltaica.vue';
import ComponenteInputEolica from './ComponenteInputEolica.vue';

import ComponenteInputPPAPerfiles from '../components/ComponenteInputPPAPerfiles.vue';
import ComponenteInputPPAConfiguracion from '../components/ComponenteInputPPAConfiguracion.vue';

import ComponenteInputPrecios from '../components/ComponenteInputPrecios.vue';
import ComponenteDatosEconomicos from '../components/ComponenteDatosEconomicos.vue';
import ComponentePeajes from '../components/ComponentePeajes.vue';


import ComponenteResultadoEconomico from '../components/ComponenteResultadoEconomico.vue';
//import ComponenteResultadoProduccion from '../components/ComponenteResultadoProduccion.vue';
//import ComponenteResultadoOperativo from '../components/ComponenteResultadoOperativo.vue';
import ComponenteResultadoResumen from '../components/ComponenteResultadoResumen.vue';
import ComponenteResultadoTemporal from '../components/ComponenteResultadoTemporal.vue';
import ComponenteResultadoFlujosCaja from '../components/ComponenteResultadoFlujosCaja.vue';
import ComponenteResultadoPeriodosTarifarios from './ComponenteResultadoPeriodosTarifarios.vue';
//import ComponenteGame from '../components/ComponenteGame.vue';
import ComponenteDiagrama from '../components/ComponenteDiagrama.vue';
import ComponenteLoading from './ComponenteLoading.vue';
import ComponenteCostes from './ComponenteCostes.vue';
import ComponentePerfilesPPA from './ComponentePerfilesPPA.vue';
import ComponenteBarridos from './ComponenteBarridos.vue';
import ComponentePPAventa from './ComponentePPAventa.vue';



//import ComponentePadre from './ComponentePadre.vue';
import { v4 as uuidv4 } from 'uuid';
import JSZip from 'jszip';
import axios from 'axios';
import store from '../store';
import Swal from "sweetalert2";
import * as yup from "yup";
import lottie from "lottie-web";
//import ExcelJS from 'exceljs';
//import { saveAs } from 'file-saver';

import imgSolar from '@/assets/solar.svg'
import imgEolica from '@/assets/eolica.svg'
import imgbateria from '@/assets/bateria.svg'
import imgGrid from '@/assets/grid.svg'
import imgGrid1 from '@/assets/grid_1.svg'
import imgElectrolizador from '@/assets/electrolizador.svg'
import imgAgua from '@/assets/agua.svg'
import imgAlmacen from '@/assets/almacen.svg'
import imgCamion from '@/assets/camion.svg'
import imgTubo from '@/assets/tubo.svg'
import imgDemanda1 from '@/assets/demanda1.svg'
import imgDemanda2 from '@/assets/demanda2.svg'
import imgConexion from '@/assets/conexion.svg'
import imgPPA from '@/assets/ppa.svg'

//import ComponenteInputPlantaElectrolisis from './ComponenteInputPlantaElectrolisis.vue';
//import { Structs } from 'phaser';
export default {
  props: {
      id: {
        type: String,
        default: null
      },
      uuid: {
        type: String,
        default: null
      },  
      
      esHijo: {
        type: Boolean,
        default: false
      },  
      caso_base:{
        default:false,
      }
      

    },
  components: { 
      ComponenteInputAlmacenamiento,
      ComponenteInputBateria,
      ComponenteInputElectrolizador,
      ComponenteInputPlantaElectrolisis,
      //ComponenteInputElectrolizadorRend,
      ComponenteDatosEconomicos,
      ComponenteInputDemanda,
      ComponenteDatosAnuales,
      ComponenteHidrogenoEconomico,

      ComponenteInputPerfilFotovoltaica,
      ComponenteInputPerfilEolica,      
      ComponenteInputFotovoltaica, 
      ComponenteInputEolica, 

      ComponenteInputPrecios,
      /* Antigua implementacion */
      ComponenteInputPPAPerfiles,
      ComponenteInputPPAConfiguracion,
      /* Nueva implementación */
      ComponentePerfilesPPA,
      ComponentePPAventa,

      ComponentePeajes,

      ComponenteDiagrama,
      //ComponenteResultadoOperativo,
      
      
      ComponenteResultadoResumen,
      
      ComponenteResultadoEconomico,
      //ComponenteResultadoProduccion,
      ComponenteResultadoTemporal,
      ComponenteResultadoFlujosCaja,
      ComponenteResultadoPeriodosTarifarios,
      ComponenteLoading,

      ComponenteInputEjecucion,
      ComponenteConfiguracion,
      ComponenteCostes,
      

      ComponenteBarridos

      },
  data() {
    return {
      nameTouched: false,
      timeoutPrecios: null,
      capexEditadoManualmente: false,
      subvEditadoManualmente: false,
      importandoDatos: false,
      anioInicioSubvActual: null,
      mountedReady: false,
      datosCasoBaseCargados: false,
      mensaje_loading: "",
      mostrar_boton_descargar_in: "",
      loading: false,
      tab: "1", // Controla la pestaña seleccionada
      tab2: "7", //Electrolizador
      prevTab2: "7",
      tab3: "1",
      tab4: "1", //Demanda anual, mensual o diaria 
      tab5: "1", //Resultados
      tabPPA:"1", //Tab de Perfiles de PPA
      tabHidrogeno:"2",
      //tab7:"1", //Tab Datos económicos
      tab_conf:"0", //Tab de configuración, curvas y precios

      deshabilitar_subcapex: 0, //Flag para poder controlar cuando se crea de nuevo el subvcapex
      HoraFinal:122712,
      YearsPPA1NoActive:[],
      YearsPPA2NoActive:[],
      YearsPPA3NoActive:[],
      datos_generales: {
        "id": 0,
        "nombre": this.$t('simulacion.nombre_defecto'),
        "anio_inicio": 2025,
        "anio_fin": 2039,
        "anio_inicio_capex": 2022,
        "mes_inicio":1,
        "anio_inicio_solar":2025,
        "mes_inicio_solar":1,
        "anio_inicio_eolica":2025,
        "mes_inicio_eolica":1,
        "uuid": uuidv4(),
        "last_update": "",
        "username": store.state.usuarioNombre,
      },
      electrolizador: { //Electrolizador            
          "pmin": 0.1,
          //"degrad": 0.0014, LEGACY, ahora es una tabla
          "cnag": 10.1,            
          "pcag": 1,                  
          "capexf": 6646300,
          "capexv": 438326,
          "opexf": 0,
          "opexv": 0,
          "capexr": 200,
          "vutil": 10,
          "pelfija": 180,
          "curvas": {
          "capex": 0,  // usar curva por defecto
          "opex": 0 ,  // usar valor específico por defecto
          "opex_anual":0,
        },      //En pestaña ejecucion (depende de OPC_EL)
   
        },
        planta_electrolisis: {
          "cauxmn": 0.05,
          "cauxmx": 0.1,
          "capexduc": 0,
          "opexduc": 0,
          //"capexele": 0,
          //"opexele": 0,
          "capextra": 0,
          "opextra": 0,
          "curvas": {
            "capex": 0,  // usar curva por defecto
            "opex": 0   // usar valor específico por defecto
          },
          "opex_anual":0,
          "capexv":0,
          "capexf":0,
          "opexv":0,
          "opexf":0,
          "h_ini":0,
          "h_fin":23,
          "sabado_l":1,
          "domingo_l":1,
          "capexfcel": 0,
          "capexvcel": 0,
          "opexfcel": 0,
          "opexvcel": 0,
          "curvas_conexion": {
            "capex": 0,
            "opex": 0
          },
         
        },
      curvas: [],
      costes:[],
      peajes_raw: { PeajeTene:[], PeajeTpot:[], CargoTene:[], CargoTpot:[] },
    
      electrolizador_degrad: [
/*         { "id": 1, "tramo": 10, "degradacion": 43.67 },
        { "id": 2, "tramo": 20, "degradacion": 45.44 },
        { "id": 3, "tramo": 40, "degradacion": 47.8 },
        { "id": 4, "tramo": 60, "degradacion": 50.16 },
        { "id": 5, "tramo": 80, "degradacion": 52.64 },
        { "id": 6, "tramo": 122712, "degradacion": 55.0 } */
      ],  
    
      electrolizador_rend: [
        { "id": 1, "uso": 10, "eficiencia": 43.67 },
        { "id": 2, "uso": 20, "eficiencia": 45.44 },
        { "id": 3, "uso": 40, "eficiencia": 47.8 },
        { "id": 4, "uso": 60, "eficiencia": 50.16 },
        { "id": 5, "uso": 80, "eficiencia": 52.64 },
        { "id": 6, "uso": 100, "eficiencia": 55.0 }
      ],
      "almacenamiento": { //Almacenamiento            
          "pdia":             0.005,
          "piny":             0.005,            
          "pext":             0,                
          "cele":             1.0812,           
          "capexf":           0,           
          "capexv":           6000,
          "opexv":0,
          "opexf":0,     
          "calmfija":         0,    //En pestaña ejecucion (depende de OPT_ALM)
          "cmax":             99,
          "curvas": {
          "capex": 1,  // usar curva por defecto
          "opex": 1   // usar valor específico por defecto
        },
      },

      "bateria": { //baterias
          "pmax": 200,
          "capac": 4,
          "rend": 85, // %
          "capexf": 0,
          "capexv": 240000,
          "opexf": 0.02,
          "opexv":0,
          "degrad": 2,// %
          "vutil": 15,
          "reempu": 50, // %
          "pbatfija": 0,
          "emax":1,
          "emin":0,
          "poiv":0,
          "curvas": {
          "capex": 0,  // usar curva por defecto
          "opex": 0   // usar valor específico por defecto
        }, 
      },
      ppa_venta: [],

      "fotovoltaica": { //Planta fotovoltaica                       
          "capexf":          0,              
          "capexv":          750000,          
          "opexf":            0,
          "opexv":            0,             
          "degrad":          0.01,           
          "pmax":             0,   
          "ppvfija":          0,   
          "pcppapv":        [],
          "poiv": 150,
          "senda_pcpv": [],
          "curvas": {
          "capex": 0,  // usar curva por defecto
          "opex": 0,   // usar valor específico por defecto
          
        },  
        "opex_anual":0, 
          "capexfcel": 0,
          "capexvcel": 0,
          "opexfcel": 0,
          "opexvcel": 0,
          "curvas_conexion": {
            "capex": 0,
            "opex": 0
          },
          

      },

      "eolica": { //Planta eolica          
          "capexf":          0,              
          "capexv":          10000,          
          "opexf":            0.015, 
          "opexv":            0,           
          "pmax":             0,   
          "peolfija":         99, 
          "pcppaeol":       [],
          "poiv": 150,
          "senda_pceol": [],
          "curvas": {
          "capex": 0,  // usar curva por defecto
          "opex": 0   // usar valor específico por defecto
        }, 
        "opex_anual":0,
         "capexfcel": 0,
          "capexvcel": 0,
          "opexfcel": 0,
          "opexvcel": 0,
          "curvas_conexion": {
            "capex": 0,
            "opex": 0
          },
         /* "senda_opex":[
{"anio":2100,"fijo":0,"variable":0}
] */
      },


      "ppa_configuracion": [ //Configuracion PPAs //cppfiaja depende de OPT_PPA
          {"ppa": "PPA1", "capmax": 1000, "pcio": 40, "horas": 2443, "cppafija": 100},
          {"ppa": "PPA2", "capmax": 1000, "pcio": 60, "horas": 3050, "cppafija": 50},
          {"ppa": "PPA3", "capmax": 0, "pcio": 10000, "horas": 8760, "cppafija": 0}                
        ],
       
        "ppa_precio_compra_matrix":  //Configuracion PPAs //cppfiaja depende de OPT_PPA
        [
    //       {"anio": 2025, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2026, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2027, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2028, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2029, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2030, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2031, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2032, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2033, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2034, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2035, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2036, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2037, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2038, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2039, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2040, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2041, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2042, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2043, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2044, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2045, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2046, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2047, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2048, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2049, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2050, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2051, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2052, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2053, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2054, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2055, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2056, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2057, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2058, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2059, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2060, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2061, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2062, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2063, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2064, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2065, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2066, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2067, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2068, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2069, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2070, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2071, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2072, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2073, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2074, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2075, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2076, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2077, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2078, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2079, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2080, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2081, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2082, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2083, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2084, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2085, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2086, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2087, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2088, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2089, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2090, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2091, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2092, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2093, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2094, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2095, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2096, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2097, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2098, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2099, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1},
    // {"anio": 2100, "ppa1": 40, "ppa2": 60, "ppa3": 1000, "activo1": 1, "activo2": 1, "activo3": 1}
    ],
        
                  
        
        "ppa_venta_excedente": [ //Configuracion PPAs //cppfiaja depende de OPT_PPA
         /*  {"anio":2025, "ppa1":40, "ppa2":60, "ppa3":150}, */               
        ],
        // Primer diccionario del peaje es de Potencia, el segundo de Energia
        "peajes":{
          'usar_cargos':0,
          'pais':1,
          'tarifa':3,
          'energia_p':{"t1": 0.027104, "t2": 0.011894, "t3": 0.004726, "t4": 0.002739, "t5": 0.000122, "t6": 0.000029},
          'potencia_p':{"t1": 23.669055,"t2": 12.513915,"t3": 4.69633,"t4": 3.309245,"t5": 0.069965,"t6": 0.062286},
          'energia_c':{"t1": 0.017674, "t2": 0.013092, "t3": 0.007069, "t4": 0.003535, "t5": 0.002266, "t6": 0.001414},
          'potencia_c':{"t1":  5.122811,"t2": 2.563728,"t3":1.86284,"t4": 1.86284,"t5": 1.86284,"t6": 0.853802},
          "inflacion_inicial": 1, 
          "subida_anual":0,
          anio_tarifario: new Date().getFullYear(),
        },
        "conf_costes":{
          usar_passthrough:1,
          valor_passthrough:0,
        },
        
        "datos_economicos":{
          "anio_inicio_capex": 2022,
          reparto_capex: [],
          subvcapex:[],
          subvh2v: [],

        },

      "perfiles": {
        
        "PPA1":[],
        "PPA2":[],
        "PPA3":[],
        // LEGACY, y antes era directamente un array
          //{"periodo": 1, "ppa1": 0, "ppa2": 0, "ppa3": 0}
      }, //Perfiles PPAs. Por defecto, lo cargadoi en el servidor
      
      "demanda": {
        "d1": [],
        "d2": [],
        "d4": [],
      },
      demanda_lc:{
        d1:[],
        d2:[],
        d4:[],
      },
      demanda_lc_zero:{
        d1:[],
        d2:[],
        d4:[],
      },
      demanda_inflaciones:{
        inflacion:0,
        pr_H2VOb:4,
        pr_H2VOp:4,
        pr_H2LOb:4,
        pr_H2LOp:4,
      },
      
      "series": { 
          "pcmd": [{"periodo":1,"perfil":1}], // Por defecto, lo cargado en el servior
          "gpv": [{"periodo":1,"perfil":1}],  // Por defecto, lo cargado en el servior
          "geol": [{"periodo":1,"perfil":1}],  // Por defecto, lo cargado en el servior
      }, 

      "gen": {
        //"poiv": 50,
        //"poic": 1000
        poicmin: 0, // cuando OPC_POIC = 1 (optimizar)
        poicmax: 150, // cuando OPC_POIC = 1 (optimizar)
        poicfij: 0,    //  cuando OPC_POIC = 0 (fija)
        pcpoic: 3000,     
    
      },

      ejecucion:{
          "Set p":          "/p17545*p149016/",
          "Set d":		      "/d1*d5478/",
          "Set a":          "/2025*2039/;",                     
          "Set m":          "/m25*m204/;",    
          "OPC_EJEC":       1,            
          "OPC_MIP":        0,
          "OPC_MCDO":       0,            
          "OPC_PV":         1,
          "OPC_EOL":        1,
          "OPCDEM_A":       1,
          "OPCDEM_M":       1,
          "OPCDEM_D":       1,
          "TASA_DCTO":      0.07,
          "TASA_INFL":      0.03,
          "INFL_COD":      2025,
          
          "OPC_AMORT": 0,
          
          //"LIMIT_MCDO":     20,
          "OPC_PPA":        1,
          "OPC_EL":         1,
          "OPC_ALM":        1,    
          "OPC_BAT":        0,
          "OPC_VBAT":       0,
          "OPC_UE":          1,
          "IMPTO_SOC":      0,
          "OPC_PCPPAPV":    0, 
          "OPC_PCPPAEOL":   0,
          "OPC_POIC": 0,
          "AN_TOT": 0,     

          "OPC_PCPPA": 0,
          "OPC_PPA_VENTA_MIN_POOL": 0,
          "OPC_PCVPPA_MIN_POOL": 0,
          //"OPC_LCOHLC" :1, //  Considerar demanda opcional de low carbon en cálculo de LCOH, por defecto activado
      },
      usarDucto: true,
      usarConexion: true,
      usarTube: true,
      //usarEOfija:0,
      //usarFVfija: 0,

      old_resultado: [],
      resultado: {},
      arrayDeObjetosSalAn2: [],
      urlDelArchivoSalAn2: '',

      valores_diagrama: {
          'PI_EL': 0,
          'CAP_ALM': 0,
          'POI_C': 0,
          'PC_PPA1': 0,
          'PC_PPA2': 0,
          'PC_PPA3': 0,
          'PI_BAT': 0,
          'PI_PV': 0,
          'PI_EOL': 0,
          'LCOH': 0,
          'HFUN': 0,
          'NPV': 0
      },

      tablas: [],
      
      nextId: 1, 
      datos_anuales:[
  /* { anio: 2025, emi: 25, ghg: 50,preciol: 20,res:90, corr: 1 }, */
],
datos_anuales_graf: [],
datos_econ_hidrog:[
  /* { anio: 2025, impcomc: 2, ccomv: 0.02,pgdoe: 0.5 }, */
],
     
datos_temporales: [],

resumenFlujosCaja: null,

      
    };
    
  },

  created() {
    //Genero aqui los datos anuales porque el componente se crea antes de que se puedan generar los datos,
    // por lo que luego se complica el que el componente ComponenteDatosAnuales reciba bien los datos del padre
    
     this.generar_datos_anuales(this.datos_generales.anio_inicio,2100);
    //this.generar_venta_ppa(this.datos_generales.anio_inicio,2100)
     this.generar_datos_economicos(this.datos_generales.anio_inicio,2100);
    console.log("created:")
          // Cargar configuración proporcionada desde `main.js`
         /*  fetch('/config.json')
            .then((response) => response.json())
            .then((config) => {
              this.mostrar_boton_descargar_in = config.mostrar_boton_descargar_in;  
                      
            })
            .catch((error) => {
              console.error('Error al cargar la configuración:', error);
              
            }); */
            /*
            //Inicializar tablas componente Configuración
            if (!this.$store.getters.getTablasConfiguracion?.length) {
              console.warn('[Simulacion] Tablas vacías, cargando por defecto...');
            }
            console.log(this.electrolizador.capexr)
            */
  },    


watch: {    
 
  ppa_precio_compra_matrix: {
    handler(newVal) {
      console.log("CAMBIÓ MATRIX");
       // Filtrar años donde activo1 es 0
      const aniosNoActivos = (Array.isArray(newVal) ? newVal : [])
        .filter(item => item.activo1 === 0)
        .map(item => item.anio);
      const aniosNoActivos2 = (Array.isArray(newVal) ? newVal : [])
      .filter(item => item.activo2 === 0)
      .map(item => item.anio);
      const aniosNoActivos3 = (Array.isArray(newVal) ? newVal : [])
      .filter(item => item.activo3 === 0)
      .map(item => item.anio);

      console.log("Años no activos PPA1:", aniosNoActivos);

      // Guardar en un data o computed si quieres
      this.YearsPPA1NoActive = aniosNoActivos;
      this.YearsPPA2NoActive = aniosNoActivos2;
      this.YearsPPA3NoActive = aniosNoActivos3;
    },
    deep: true
  },

    'series.gpv':{
       handler(newValue){
        console.log("watch: fotovoltaica->", newValue)
      },
      deep:true,
    },
  'datos_generales.nombre'() {
    if (!this.mountedReady) return;
    this.nameTouched = true;
  },
  '$i18n.locale'() {
  if (!this.mountedReady) return;

  // Si es simulación existente, no tocar
  if (this.id != null) return;

  // Si el usuario ya puso nombre, no tocar
  if (this.nameTouched && this.datos_generales.nombre) return;

  this.datos_generales.nombre = this.$t('simulacion.nombre_defecto');
},
  'ejecucion.OPCDEM_A':{
   handler(){
    this.check_ventanas_dem();
   },
  },
  'ejecucion.OPCDEM_M':{
    handler(){
    this.check_ventanas_dem();
   },
  },

  'ejecucion.OPCDEM_D':{
    handler(){
    this.check_ventanas_dem();
   },

  },
  'datos_generales.anio_inicio_solar': {
    async handler(newValue) {
      if (this.id==null){
         this.RepartoConsistente();
         await this.obtener_perfil_fotovoltaica();
         //this.obtener_precios();
      }
      console.log("Nuevo anio solar: ", newValue)

      
    }
  },
    'datos_generales.anio_inicio_eolica': {
    async handler(newValue) {
      if (this.id==null){
         this.RepartoConsistente();
         //this.obtener_precios();
         await this.obtener_perfil_eolica();
      }
      console.log("Nuevo anio eolica: ", newValue)

      
    }
  },
  'datos_generales.anio_inicio': {
    async handler(newValue) {
      if (this.id==null){
        this.actualizarSubvCapex();
         this.RepartoConsistente();
        this.filtradoPPA();
        //this.obtener_precios();
      }
      console.log("Nuevo anio: ", newValue)
     /*  if (this.mountedReady && (newValue >= 2025) && (newValue <= 2100)) {
        this.loading = true;
        //this.mensaje_loading = this.$t('mensajes.obteniendo_demanda');
        //await this.actualizar_demandas();
        this.mensaje_loading = this.$t('mensajes.obteniendo_precios');
        this.debouncedObtenerPrecios();
        this.loading = false;
      } */
      
    }
  },

  'datos_generales.anio_fin': {
    async handler() {
      if (this.id==null){
        this.actualizarSubvCapex();
         this.RepartoConsistente();
        this.filtradoPPA();
        await this.obtener_perfil_eolica();
        await this.obtener_perfil_fotovoltaica();
        //this.obtener_precios();
      }
      
      /* if (this.mountedReady && (newValue >= 2025) && (newValue <= 2100)) {
        this.loading = true;
        //this.mensaje_loading = this.$t('mensajes.obteniendo_demanda');
        //await this.actualizar_demandas();
        this.mensaje_loading = this.$t('mensajes.obteniendo_precios');
        this.debouncedObtenerPrecios();
        this.loading = false;
      } 
      if (newValue > 2050) {

      Swal.fire({
            title: "¡AVISO!",
            html: `
              <div style="text-align: center;">
                <p style="margin-bottom: 20px;"> ` + this.$t('mensajes.warning_anios') +
                `</p> <!-- Mensaje personalizado -->
                <div 
                  id="lottie-container" 
                  style="
                    width: 250px; 
                    height: 20px; 
                    margin: auto; 
                    overflow: hidden;">
                </div>
              </div>
            `,
            confirmButtonText: this.$t('comun.boton_ok'),
  
          });
        }*/
    }
  },
  'ejecucion.LIMIT_MCDO':{
    handler(){
      
    },
    deep:true,
  },
  'datos_economicos.anio_inicio_capex':{
    handler(){
      console.log("Actualizado anio inicio")
    this.actualizarSubvCapex();
     this.RepartoConsistente();
    }
  },
   
  'datos_economicos.reparto_capex': {
  deep: true,
  handler(val) {
    if (!Array.isArray(val)) return;
    const sum = (k) => (val||[]).reduce((a,r)=>a+(parseFloat(r[k] ?? r.valor) || 0),0);
    const tol = 0.005;
    this.capexSumaInvalida =
      Math.abs(sum('capexh2')-1)>tol || Math.abs(sum('capexpv')-1)>tol || Math.abs(sum('capexeol')-1)>tol;
  }
},
  ppa_venta: {
    handler(val) {
      this.fotovoltaica.pcppapv = val.map(item => item.pcppapv ?? 0)
      this.eolica.pcppaeol = val.map(item => item.pcppaeol ?? 0)
    },
    immediate: true,
    deep: true
  },

},



  methods: {
    irAModuloDesdeDiagrama(destino) {
  const rutas = {
    solar: {
      tab: '0',
      tab2: '5'
    },

    eolica: {
      tab: '0',
      tab2: '6'
    },

    bateria: {
      tab: '0',
      tab2: '2'
    },

    electrolizador: {
      tab: '0',
      tab2: '7'
    },

    planta_electrolisis: {
      tab: '0',
      tab2: '3'
    },

    almacenamiento: {
      tab: '0',
      tab2: '1'
    },

    datos_economicos: {
      tab: '0',
      tab2: '8'
    },

    demanda: {
      tab: '4',
      tabHidrogeno: '2'
    },

    datos_anuales: {
      tab: '4',
      tabHidrogeno: '1'
    },

    ppa_compra: {
      tab: '2',
      tab3: '1'
    },

    ppa_venta: {
      tab: '2',
      tab3: '3'
    },

    mercado: {
      tab: '3',
      tab4: '1'
    },

    precios: {
      tab: '3',
      tab4: '1'
    },

    peajes: {
      tab: '3',
      tab4: '2'
    },

    costes: {
      tab: '3',
      tab4: '3'
    },

    economicos_hidrogeno: {
      tab: '3',
      tab4: '4'
    }
  }

  const ruta = rutas[destino]

  if (!ruta) return

  this.tab = ruta.tab

  this.$nextTick(() => {
    if (ruta.tab2) this.tab2 = ruta.tab2
    if (ruta.tab3) this.tab3 = ruta.tab3
    if (ruta.tab4) this.tab4 = ruta.tab4
    if (ruta.tabHidrogeno) this.tabHidrogeno = ruta.tabHidrogeno
  })
},
  async cargarDatosCasoBaseManual() {
  const result = await Swal.fire({
    title: this.$t("mensajes.cargar_caso_base_titulo"),
    html: `
      <p>${this.$t("mensajes.cargar_caso_base_texto")}</p>
    `,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: this.$t("mensajes.cargar_caso_base_confirmar"),
    cancelButtonText: this.$t("comun.boton_cancelar"),
  });
  if (!result.isConfirmed) return;

  try {
    this.loading = true;

    this.mensaje_loading = this.$t('mensajes.obteniendo_perfil_fv');
    await this.obtener_perfil_fotovoltaica(true);

    this.mensaje_loading = this.$t('mensajes.obteniendo_perfil_eolica');
    await this.obtener_perfil_eolica(true);

    this.mensaje_loading = this.$t('mensajes.obteniendo_demanda');
    await this.actualizar_demandas();

    await this.generar_datos_anuales(this.datos_generales.anio_inicio, 2100);
    await this.generar_datos_economicos(this.datos_generales.anio_inicio, 2100);

    this.mensaje_loading = this.$t('mensajes.obteniendo_caso_base');
    await this.obtener_caso_base();

    // Mantener la lógica actual: el caso base no guarda precios de mercado
    this.series.pcmd = [];

    this.mensaje_loading = this.$t('mensajes.obteniendo_precios');
    await this.obtener_precios(true);

    await this.init_datos_economicos();
    await this.obtener_cargos_peajes();

    this.datos_generales.nombre = this.$t('simulacion.nombre_defecto');
    this.datos_generales.uuid = uuidv4();
    this.datos_generales.username = store.state.usuarioNombre;

    this.datosCasoBaseCargados = true;

    await Swal.fire({
      icon: "success",
      title: "Datos cargados",
      text: "Los datos del caso base se han cargado correctamente.",
    });

  } catch (error) {
    console.error("Error cargando datos de caso base:", error);

    await Swal.fire({
      icon: "error",
      title: "Error",
      text: "No se pudieron cargar los datos del caso base.",
    });
  } finally {
    this.loading = false;
    this.mensaje_loading = "";
  }
},
  aplicarSubvencionesPorAnio(subvcapexOrigen, subvh2vOrigen, anioInicioOrigen) {
  const inicioDestino = Number(this.datos_economicos.anio_inicio_capex);
  const finDestino = Number(this.datos_generales.anio_fin);
  const cod = Number(this.datos_generales.anio_inicio);

  if (!inicioDestino || !finDestino || inicioDestino > finDestino) {
    this.datos_economicos.subvcapex = [];
    this.datos_economicos.subvh2v = [];
    return;
  }

  const aniosDestino = Array.from(
    { length: finDestino - inicioDestino + 1 },
    (_, i) => inicioDestino + i
  );

  const inicioOrigen = Number(anioInicioOrigen || inicioDestino);

  const mapCapex = new Map();
  const mapH2v = new Map();

  if (Array.isArray(subvcapexOrigen)) {
    subvcapexOrigen.forEach((valor, idx) => {
      mapCapex.set(inicioOrigen + idx, Number(valor) || 0);
    });
  }

  if (Array.isArray(subvh2vOrigen)) {
    subvh2vOrigen.forEach((valor, idx) => {
      mapH2v.set(inicioOrigen + idx, Number(valor) || 0);
    });
  }

  this.datos_economicos.subvcapex = aniosDestino.map((anio) => {
    return mapCapex.has(anio) ? mapCapex.get(anio) : 0;
  });

  this.datos_economicos.subvh2v = aniosDestino.map((anio) => {
    if (anio < cod) return 0;
    return mapH2v.has(anio) ? mapH2v.get(anio) : 0;
  });

  this.anioInicioSubvActual = inicioDestino;
},
   guardarCacheSubvencionesManual(datosEconomicosActualizados) {
  this.subvEditadoManualmente = true;

  this.datos_economicos = {
    ...this.datos_economicos,
    ...datosEconomicosActualizados,
  };

  this.guardarCacheSubvencionesSiProcede(true);
},
    guardarCacheSubvencionesSiProcede(forzar = false) {
  const inicio = Number(this.datos_economicos?.anio_inicio_capex);
  if (!inicio) return;

  const subvcapex = Array.isArray(this.datos_economicos?.subvcapex)
    ? this.datos_economicos.subvcapex
    : [];

  const subvh2v = Array.isArray(this.datos_economicos?.subvh2v)
    ? this.datos_economicos.subvh2v
    : [];

  const lenActual = Math.max(subvcapex.length, subvh2v.length);
  const lenCache = this._cacheSubvencionesLen || 0;


  if (forzar || !this._cacheSubvenciones || lenActual > lenCache) {
    const subvcapexPorAnio = {};
    const subvh2vPorAnio = {};

    subvcapex.forEach((valor, i) => {
      subvcapexPorAnio[inicio + i] = valor;
    });

    subvh2v.forEach((valor, i) => {
      subvh2vPorAnio[inicio + i] = valor;
    });

    this._cacheSubvenciones = {
      subvcapexPorAnio,
      subvh2vPorAnio,
    };

    this._cacheSubvencionesLen = lenActual;

    console.log("Cache subvenciones guardada", {
      inicio,
      lenActual,
      subvcapexPorAnio,
      subvh2vPorAnio,
    });
  }
},

obtenerSubvencionPorAnio(tipo, anio, fallback = 0) {
  const cache = this._cacheSubvenciones;

  if (!cache) return fallback;

  const mapa =
    tipo === "subvcapex"
      ? cache.subvcapexPorAnio
      : cache.subvh2vPorAnio;

  if (Object.prototype.hasOwnProperty.call(mapa, anio)) {
    return mapa[anio];
  }

  return fallback;
},
     normalizarSendaPrecioTransferencia(senda, years) {
    const yearsNumericos = Array.isArray(years) ? years.map(Number) : [];
    const base = Array.isArray(senda) ? senda : [];

    return yearsNumericos.map(anio => {
      const existente = base.find(x => Number(x?.anio) === anio);

      return {
        anio,
        precio: Number(existente?.precio ?? 0),
      };
    });
  },
    normalizarSendaPrecioTransferenciaCasoBase(senda, anioInicio = 2025, anioFin = 2100) {
  const base = Array.isArray(senda) ? senda : [];

  return Array.from(
    { length: anioFin - anioInicio + 1 },
    (_, i) => {
      const anio = anioInicio + i;

      const existente = base.find(x => Number(x?.anio) === anio);

      return {
        anio,
        precio: Number(existente?.precio ?? 0),
      };
    }
  );
},
    onActivar(){
      console.log("demandaLCActual.d1: ",this.demandaLCActual.d2)
      if(this.ejecucion.OPCDEM_A==1){
        console.log("Activar anual")
          this.demandaLCActual.d1.forEach(item => {
            item.dH2VOp = 100000;
          });
      }
      if(this.ejecucion.OPCDEM_M==1){
        console.log("Activar mensual")
        this.demandaLCActual.d2.forEach(item => {
            item.dH2VOp = 100000;
          });
      }
      if(this.ejecucion.OPCDEM_D==1){
        console.log("Activar mensual")
        this.demandaLCActual.d4.forEach(item => {
            item.dH2VOp = 100000;
          });
      }
      
    },
    onDesactivar(){
      
      if(this.ejecucion.OPCDEM_A==1){
        console.log("Desactivar anual")
       this.demandaLCActual.d1.forEach(item => {
            item.dH2VOp = 0;
          });
      }
      if(this.ejecucion.OPCDEM_M==1){
        console.log("Desactivar mensual")
        this.demandaLCActual.d2.forEach(item => {
            item.dH2VOp = 0;
          });
      }
      if(this.ejecucion.OPCDEM_D==1){
        console.log("Desactivar diario")
        this.demandaLCActual.d4.forEach(item => {
            item.dH2VOp = 0;
          });
      }
      
    },
    nuevosCostes(nuevosCostes) {
      //Retrocompatibilidad
    // nuevosCostes: [{Hora, Valor}] 
    const years = this.yearsSim.map(String);
    const maxRows = 8760;

    const rows = Array.isArray(nuevosCostes) ? nuevosCostes : [];

    // Si ya viene en formato anual (tiene "periodo" y algún año), no tocar
    if (rows.length && (rows[0].periodo !== undefined) && Object.keys(rows[0]).some(k => /^\d{4}$/.test(k))) {
      return rows;
    }

    // Si viene antiguo Hora/Valor, replica Valor a todos los años
    if (rows.length && (rows[0].Hora !== undefined || rows[0].Valor !== undefined)) {
      return Array.from({ length: Math.min(rows.length, maxRows) }, (_, i) => {
        const r = rows[i] || {};
        const periodo = Number(r.periodo ?? r.Hora ?? (i + 1)) || (i + 1);
        const n = Number(String(r.Valor ?? 0).replace(",", "."));
        const val = Number.isFinite(n) ? n : 0;

        const out = { periodo };
        years.forEach(y => (out[y] = val));
        return out;
      });
    }

    // Si está vacío: crea plantilla
    return Array.from({ length: maxRows }, (_, i) => {
      const out = { periodo: i + 1 };
      years.forEach(y => (out[y] = 0));
      return out;
    });
  },
 nuevaSerieEolica(nuevaSerie, anioInicio = null, anioFin = null) {
  const maxRows = 8760;

  const ini = Number(anioInicio ?? this.datos_generales?.anio_inicio_eolica);
  const fin = Number(anioFin ?? this.datos_generales?.anio_fin);

  const years =
    Number.isFinite(ini) && Number.isFinite(fin) && fin >= ini
      ? Array.from({ length: fin - ini + 1 }, (_, i) => String(ini + i))
      : [];

  const rows = Array.isArray(nuevaSerie) ? nuevaSerie : [];

  // CASO 1: si ya viene anual 
  if (
    rows.length &&
    rows[0].periodo !== undefined &&
    Object.keys(rows[0]).some(k => /^\d{4}$/.test(k))
  ) {
    return rows;
  }

  // CASO 2: formato antiguo perfil
  if (rows.length && rows[0].perfil !== undefined) {
    return Array.from({ length: Math.min(rows.length, maxRows) }, (_, i) => {
      const r = rows[i] || {};
      const periodo = Number(r.periodo ?? (i + 1)) || (i + 1);
      const n = Number(String(r.perfil ?? 0).replace(",", "."));
      const val = Number.isFinite(n) ? n : 0;

      const out = { periodo };
      years.forEach(y => (out[y] = val));
      return out;
    });
  }

  //  CASO 3: formato antiguo valor
  if (rows.length && rows[0].valor !== undefined) {
    return Array.from({ length: Math.min(rows.length, maxRows) }, (_, i) => {
      const r = rows[i] || {};
      const periodo = Number(r.periodo ?? (i + 1)) || (i + 1);
      const n = Number(String(r.valor ?? 0).replace(",", "."));
      const val = Number.isFinite(n) ? n : 0;

      const out = { periodo };
      years.forEach(y => (out[y] = val));
      return out;
    });
  }

  //  CASO 4: fallback 
  return rows;
},
nuevaSerieFotovoltaica(nuevaSerie, anioInicio = null, anioFin = null) {
  const maxRows = 8760;

  const ini = Number(anioInicio ?? this.datos_generales?.anio_inicio_solar);
  const fin = Number(anioFin ?? this.datos_generales?.anio_fin);

  const years =
    Number.isFinite(ini) && Number.isFinite(fin) && fin >= ini
      ? Array.from({ length: fin - ini + 1 }, (_, i) => String(ini + i))
      : [];

  const rows = Array.isArray(nuevaSerie) ? nuevaSerie : [];

  // CASO 1: si ya viene anual
  if (
    rows.length &&
    rows[0].periodo !== undefined &&
    Object.keys(rows[0]).some(k => /^\d{4}$/.test(k))
  ) {
    return rows;
  }

  // CASO 2: formato antiguo perfil
  if (rows.length && rows[0].perfil !== undefined) {
    return Array.from({ length: Math.min(rows.length, maxRows) }, (_, i) => {
      const r = rows[i] || {};
      const periodo = Number(r.periodo ?? (i + 1)) || (i + 1);
      const n = Number(String(r.perfil ?? 0).replace(",", "."));
      const val = Number.isFinite(n) ? n : 0;

      const out = { periodo };
      years.forEach(y => (out[y] = val));
      return out;
    });
  }

  // CASO 3: formato antiguo valor
  if (rows.length && rows[0].valor !== undefined) {
    return Array.from({ length: Math.min(rows.length, maxRows) }, (_, i) => {
      const r = rows[i] || {};
      const periodo = Number(r.periodo ?? (i + 1)) || (i + 1);
      const n = Number(String(r.valor ?? 0).replace(",", "."));
      const val = Number.isFinite(n) ? n : 0;

      const out = { periodo };
      years.forEach(y => (out[y] = val));
      return out;
    });
  }

  // fallback
  return rows;
},
    actualizarModoPcvppa(valor) {
  this.ejecucion.OPC_PCVPPA_MIN_POOL = valor;
},
    actualizarModoPpaVenta(valor) {
  this.ejecucion.OPC_PPA_VENTA_MIN_POOL = valor;
},
    isEmpty(v) {
    return v === null || v === undefined || v === '' || Number.isNaN(v);
  },
  // comprueba que TODOS esos campos estén rellenados
  needFieldsFilled(obj, keys) {
    if (!obj) return false;
    return keys.every(k => {
      const val = obj?.[k];
      return !this.isEmpty(val) || val === 0;
    });
  },
  
  usaCurvas(obj) {
    
    const cap = obj?.curvas?.capex, op = obj?.curvas?.opex;
    if (cap === 1 && op === 1) return true;
    return false;
  },

  // valida la pestaña
  isTabValid(tabValue) {
    const t = String(tabValue);
    // campos obligatorios base
    const req = ['capexv','capexf','opexv','opexf'];

    switch (t) {
      case '7': { // Electrolizador
        const obj = this.electrolizador;
        if (this.usaCurvas(obj)) return true;
        return this.needFieldsFilled(obj, req);
      }
      case '3': { // Planta electrólisis
        const obj = this.planta_electrolisis;
        if (this.usaCurvas(obj)) return true;
        return this.needFieldsFilled(obj, req);
      }
      case '1': { // Almacenamiento
        const obj = this.almacenamiento;
        if (this.usaCurvas(obj)) return true;
        return this.needFieldsFilled(obj, req);
      }
      case '2': { // Batería
        const obj = this.bateria;
        if (this.usaCurvas(obj)) return true;
        return this.needFieldsFilled(obj, req);
      }
      case '5': { // Fotovoltaica (si está activa)
        if (this.ejecucion?.OPC_PV == 0) return true;
        const obj = this.fotovoltaica;
        if (this.usaCurvas(obj)) return true;
        return this.needFieldsFilled(obj, req);
      }
      case '6': { // Eólica (si está activa)
        if (this.ejecucion?.OPC_EOL == 0) return true;
        const obj = this.eolica;
        if (this.usaCurvas(obj)) return true;
        return this.needFieldsFilled(obj, req);
      }
      case '8': // Datos económicos 
      default:
        return true;
    }
  },

  handleTabChange(nextTab) {
    const current = String(this.prevTab2);
    if (String(nextTab) === current) return; // mismo tab, no hacer nada

    // ¿está completa la pestaña que dejo?
    const ok = this.isTabValid(current);

    if (!ok) {
      Swal.fire({
        icon: 'warning',
        title: this.$t('mensajes.campo_requerido'),
        text: this.$t('mensajes.campo_requerido_opexcapex'),
      });
      // volver al tab actual
      this.$nextTick(() => { this.tab2 = current; });
      return;
    }

    // permitir cambio
    this.prevTab2 = String(nextTab);
    this.tab2 = String(nextTab);
  },
   filtradoPPA() {
    const { anio_inicio, anio_fin } = this.datos_generales;
    const n = anio_fin - anio_inicio + 1;

    const actual = this.ppa_venta ?? [];
    const idxPorAnio = new Map(actual.map(r => [r.anio, r]));

    this.ppa_venta = Array.from({ length: n }, (_, i) => {
      const anio = anio_inicio + i;
      return idxPorAnio.get(anio) ?? {
        anio,
        pcppapv: this.fotovoltaica.pcppapv?.[i] ?? 0,
        pcppaeol: this.eolica.pcppaeol?.[i] ?? 0,
      };
    });
  },
   actualizarFragmento(fragmento) {
  this.ppa_venta = fragmento;
},
    //Revisar si solo hay un modo de demanda, y si lo hay marcar ese tab para que aparezca directamente en el front
    check_ventanas_dem(){
    
      //Solo está activo el modo anual
      if(this.ejecucion.OPCDEM_A && !this.ejecucion.OPCDEM_M && !this.ejecucion.OPCDEM_D ){
        this.tab4="1";
      }
      //Solo activo el mensual
      else if(!this.ejecucion.OPCDEM_A && this.ejecucion.OPCDEM_M && !this.ejecucion.OPCDEM_D ){
        this.tab4="2";
      }
      //Solo activo el diario
      else if(!this.ejecucion.OPCDEM_A && !this.ejecucion.OPCDEM_M && this.ejecucion.OPCDEM_D ){
        this.tab4="3";
      }

      //Casos donde se ha desactivado donde nos encontramos pero quedan las otras 2 activas
      // Si donde estabamos se acaba de desactivar, y las otras dos siguen activas, se procede a cambiar el tab
     else if(this.tab4=="1" && !this.ejecucion.OPCDEM_A && (this.ejecucion.OPCDEM_M || this.ejecucion.OPCDEM_D ) ){
        this.tab4="2"
      }
      else if( this.tab4=="2" && !this.ejecucion.OPCDEM_M && (this.ejecucion.OPCDEM_A || this.ejecucion.OPCDEM_D )){
        this.tab4="1"
      }
      else if(this.tab4=="3" && !this.ejecucion.OPCDEM_D && (this.ejecucion.OPCDEM_A || this.ejecucion.OPCDEM_M )){
          this.tab4="1"
      }
    },
    calcular_inflacion(mensaje){
      console.log(mensaje)
      const inflacion= this.demanda_inflaciones.inflacion;
      if(this.ejecucion.OPCDEM_A==1){
        this.demanda.d1=this.aplicarInflacion(inflacion,this.demanda_inflaciones.pr_H2VOb,this.demanda_inflaciones.pr_H2VOp,  this.demanda.d1)
        this.demanda_lc.d1=this.aplicarInflacion(inflacion,this.demanda_inflaciones.pr_H2LOb,this.demanda_inflaciones.pr_H2LOp,  this.demanda_lc.d1)
    
      } 
      if (this.ejecucion.OPCDEM_M==1)
      {
        this.demanda.d2=this.aplicarInflacion(inflacion,this.demanda_inflaciones.pr_H2VOb,this.demanda_inflaciones.pr_H2VOp, this.demanda.d2)
        this.demanda_lc.d2=this.aplicarInflacion(inflacion,this.demanda_inflaciones.pr_H2LOb,this.demanda_inflaciones.pr_H2LOp, this.demanda_lc.d2)
    
      }
      if (this.ejecucion.OPCDEM_D==1){
        this.demanda.d4=this.aplicarInflacion(inflacion,this.demanda_inflaciones.pr_H2VOb,this.demanda_inflaciones.pr_H2VOp, this.demanda.d4)
        this.demanda_lc.d4=this.aplicarInflacion(inflacion,this.demanda_inflaciones.pr_H2LOb,this.demanda_inflaciones.pr_H2LOp, this.demanda_lc.d4)
      }
    },
    aplicarInflacion(inflacion,valor_inicial_ob,valor_inicial_op,data){
      let valor_op=valor_inicial_op
      let valor_ob=valor_inicial_ob
      console.log("Valor ob: ", valor_inicial_ob)
      const anio_inicio=this.datos_generales.anio_inicio;
      const anio_fin=this.datos_generales.anio_fin;

      for (let anio = anio_inicio; anio <= anio_fin; anio++) {
        const filas = data.filter(f => parseInt(f.id.split('-')[0]) === anio);
        console.log("filas para año", anio, ":", filas);

        if (filas.length > 0) {
          if (anio === anio_inicio) {
            filas.forEach(fila => {
              fila.pcH2VOp = valor_op; // valor base
              fila.pcH2VOb = valor_ob;
            });
          } else {
            valor_ob = valor_ob * (1 + inflacion); 
            valor_op = valor_op * (1 + inflacion);
            filas.forEach(fila => {
              fila.pcH2VOp = parseFloat(valor_op.toFixed(3));
              fila.pcH2VOb = parseFloat(valor_ob.toFixed(3));
            });
          }
        }
      }
      console.log("Datos: ", data)
      return data
    },
  
    async lanzar_simulacion() {

      const nombre_existe= await this.comprobar_nombre()
      console.log("Existe nombre: ", nombre_existe)
      if (!nombre_existe){
        console.log("Existe:")
        return 
      }
      let datos_agregados = {}
      datos_agregados = this.agregar_datos(true)

    //const schema = this.validar_datos();
      try {
        
        /* De momento no los validamos
        await schema.validate(datos_agregados, { 
            context: { anio_inicio: datos_agregados.anio_inicio, anio_fin: datos_agregados.anio_fin },
            abortEarly: false }
            );
        */
        

        this.errorMessage = null;
                
        try {
          const result = await Swal.fire({
            title: this.$t('mensajes.estas_seguro'),
            html: `
              <div style="text-align: center;">
                <p style="margin-bottom: 20px;"> ` + this.$t('mensajes.lanzar_simulacion') +
                `</p> <!-- Mensaje personalizado -->
                <div 
                  id="lottie-container" 
                  style="
                    width: 250px; 
                    height: 250px; 
                    margin: auto; 
                    overflow: hidden;">
                </div>
              </div>
            `,            
            //icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: this.$t('comun.boton_ok'),
            cancelButtonText: this.$t('comun.boton_cancelar'),
            didOpen: () => {
              // Renderizar la animación Lottie
              lottie.loadAnimation({
                container: document.getElementById("lottie-container"), // ID del contenedor
                renderer: "svg",
                loop: true,
                autoplay: true,
                path: "/cohete-preparado.json", // Ruta del archivo JSON
              });
            },            
          });

          if (result.isConfirmed) {
            this.loading = true;

            // Crear un archivo ZIP con JSZip
            const zip = new JSZip();
            zip.file("data.json", JSON.stringify(datos_agregados));

            // Generar el archivo ZIP en formato blob
            // Nuevo algoritmo Deflate nivel 9
             const zipBlob = await zip.generateAsync({ 
            type: "blob",
              compression: "DEFLATE",
              compressionOptions: { level: 9 }

          });
            // Crear un objeto FormData para enviar el archivo ZIP
            const formData = new FormData();
            formData.append("file", zipBlob, "data.zip");

            // Enviar los datos al servidor            
            await axios({
              method: "post",
              url: process.env.VUE_APP_API_BASE_URL + "/api/lanzar-simulacion/",
              data: formData,
              withCredentials: true,
              headers: {
                Authorization: "Bearer " + store.state.token,
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "multipart/form-data",
              },
            });
                      
            this.loading = false;

            // Mostrar mensaje de éxito
            //Swal.fire(
            //  this.$t('mensajes.lanzar_simulacion_ok_titulo'), 
            //  this.$t('mensajes.lanzar_simulacion_ok_subtitulo'), 
            //  "success");

            Swal.fire({
              title: this.$t('mensajes.lanzar_simulacion_ok_titulo'),
              html: `
                <div style="text-align: center;">
                  <p style="margin-bottom: 20px;"> ` + this.$t('mensajes.lanzar_simulacion_ok_subtitulo') +
                  `</p> <!-- Mensaje personalizado -->
                  <div 
                    id="lottie-container" 
                    style="
                      width: 250px; 
                      height: 250px; 
                      margin: auto; 
                      overflow: hidden;">
                  </div>
                </div>
              `,
              confirmButtonText: this.$t('comun.boton_ok'),
              didOpen: () => {
                // Renderizar la animación Lottie
                lottie.loadAnimation({
                  container: document.getElementById("lottie-container"), // ID del contenedor
                  renderer: "svg",
                  loop: true,
                  autoplay: true,
                  path: "/cohete-lanzado.json", // Ruta del archivo JSON
                });
              },            
            });


            this.$router.push('/'); //Nos vamos a la pagina de home
          }
        } catch (error) {
          console.error("Error al lanzar la simulación:", error);
          this.loading = false;

          // Mostrar mensaje de error
          //Swal.fire("Error", this.$t('mensajes.lanzar_simulacion_error'), "error");

          Swal.fire({
            title: this.$t('mensajes.lanzar_simulacion_error'),
            html: `
              <div style="text-align: center;">
                <p style="margin-bottom: 20px;"> ` + "" +
                `</p> <!-- Mensaje personalizado -->
                <div 
                  id="lottie-container" 
                  style="
                    width: 250px; 
                    height: 250px; 
                    margin: auto; 
                    overflow: hidden;">
                </div>
              </div>
            `,
            confirmButtonText: this.$t('comun.boton_ok'),
            didOpen: () => {
              // Renderizar la animación Lottie
              lottie.loadAnimation({
                container: document.getElementById("lottie-container"), // ID del contenedor
                renderer: "svg",
                loop: true,
                autoplay: true,
                path: "/cohete-error.json", // Ruta del archivo JSON
              });
            },            
          });


        }
        



      } catch (error) {
        // Maneja errores de validación
        this.errorMessage = error.inner.map((e) => e.message).join(", ");
        console.error("Errores de validación:", this.errorMessage);
        Swal.fire("Errores de validacion", this.errorMessage, "error");
      }








    },


    async descargar_in() {

      
        let datos_agregados = {}
        

        datos_agregados = this.agregar_datos(true)
         this.loading = true;
         this.mensaje_loading = "Generando fichero IN..."
        console.log("Datos agregados: ", datos_agregados)
          /* const schema = this.validar_datos();
          console.log("electrlizador: ",datos_agregados['electrolizador'])
          try{
              let validatedData= await schema.validate(datos_agregados, { 
            abortEarly: false }
            );
            console.log("Datos validos: ", validatedData)
          }
          catch(error){
            console.error("Error : ", error.errors)
            this.loading = false;
            return
          } */
        /* De momento no los validamos */
       
          // Crear un archivo ZIP con JSZip
          const zip = new JSZip();
          zip.file("data.json", JSON.stringify(datos_agregados));
          const jsonString = JSON.stringify(datos_agregados);
          console.log((jsonString.length / 1024 / 1024).toFixed(2) + " MB");
          // Generar el archivo ZIP en formato blob
          const zipBlob = await zip.generateAsync({ 
            type: "blob",
              compression: "DEFLATE",
              compressionOptions: { level: 9 }

          });
        
          console.log((zipBlob.size / 1024 / 1024).toFixed(2) + " MB");

          // Crear un objeto FormData para enviar el archivo ZIP
          const formData = new FormData();
          formData.append("file", zipBlob, "data.zip");

          // Enviar los datos al servidor            
          await axios({
            method: "post",
            url: process.env.VUE_APP_API_BASE_URL + "/api/descargar-in/",
            data: formData,
            withCredentials: true,
            headers: {
              Authorization: "Bearer " + store.state.token,
              "Access-Control-Allow-Origin": "*",
              "Content-Type": "multipart/form-data",
            },
            responseType: 'blob' // Asegura que recibimos un archivo binario
          })
            .then((response) => {    
              this.loading = false;

              // Crear un enlace para descargar el archivo ZIP
              const blob = new Blob([response.data], { type: 'application/zip' });
              const url = window.URL.createObjectURL(blob);

              // Crear un elemento <a> para simular la descarga
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', 'IN.zip'); // Nombre del archivo
              document.body.appendChild(link);
              link.click();

              // Limpiar el DOM
              link.remove();
              window.URL.revokeObjectURL(url);
            })
            .catch((error) => {
              this.loading = false;
              console.error('Error al descargar el archivo:', error);
            });                    


    },

    async obtener_curvas_elec_generales(){
     
          
      this.loading = true;
      this.mensaje_loading = "Cargando curvas elec generales...";

          await axios({
              method: 'get',
              url: process.env.VUE_APP_API_BASE_URL + "/api/descargar-curvas_elec-generales/",
              withCredentials: true,
              headers: {
                  Authorization: "Bearer " + store.state.token,
                  'Access-Control-Allow-Origin': '*',
                  'Content-Type': 'application/json'
              },
              responseType: 'blob' 
          })
          .then((response) => {
              this.loading = false;

              // Crear un objeto FileReader para leer el blob
              const fileReader = new FileReader();

              fileReader.onload = (event) => {
                  const arrayBuffer = event.target.result;

                  // Usar JSZip para descomprimir el archivo
                  JSZip.loadAsync(arrayBuffer).then((zip) => {
                      // Asumimos que el archivo JSON está en la raíz del ZIP
                      const fileName = Object.keys(zip.files).find(file => file.endsWith('.json'));

                      if (fileName) {
                          zip.file(fileName).async("string").then((jsonContent) => {
                              
                              //console.log(JSON.stringify(jsonContent))
                              //this.datos = JSON.parse(jsonContent);
                              //console.log("Datos rend",JSON.parse(jsonContent)['electrolizador_rend'])
                              this.electrolizador_rend = JSON.parse(jsonContent);
                              
                              console.log(this.rows);
                          }).catch((err) => {
                              console.error("Error leyendo el archivo JSON del ZIP:", err);
                          });
                      } else {
                          console.error("No se encontró un archivo JSON en el ZIP.");
                      }
                  }).catch((err) => {
                      console.error("Error descomprimiendo el archivo ZIP:", err);
                  });
              };

              // Leer el blob como ArrayBuffer
              fileReader.readAsArrayBuffer(response.data);
          })
          .catch((error) => {
              this.loading = false;
              console.error("Error al obtener las curvas:", error);
          });
    this.loading = false;
    },
    /* Para cuando cambie la HoraFinal de senda de degradación, que esta oblique a los valores mayores de esas horas a reducirse */
    ajustarDegradacion(HoraFinal){
      this.electrolizador_degrad.forEach(item => {
        console.log("ajustando Hora Final", HoraFinal)
        if (item.tramo >= HoraFinal) {
          item.tramo = HoraFinal-1
        }
      })
      const ultimo =  this.electrolizador_degrad.pop();
      
      ultimo.id = ultimo.id+1
      ultimo.tramo=HoraFinal
      this.electrolizador_degrad.push(ultimo)
    },
    calcularHoraFinal(){
      this.datos_generales.anio_fin
      this.datos_generales.anio_inicio
       let horas = 0;

      for (let anio = this.datos_generales.anio_inicio; anio <= this.datos_generales.anio_fin; anio++) {
        const esBisiesto = (anio % 4 === 0 && anio % 100 !== 0) || (anio % 400 === 0);
        horas += esBisiesto ? 366 * 24 : 365 * 24;
      }

      this.HoraFinal = horas;
      console.log("Hora final -> ",this.HoraFinal)
      //Ahus
      this.ajustarDegradacion(this.HoraFinal);
    },

 debouncedObtenerPrecios(reset = false) {
  if (this.timeoutPrecios) clearTimeout(this.timeoutPrecios);
  this.timeoutPrecios = setTimeout(async () => {
    this.loading = true;
    this.mensaje_loading = this.$t('mensajes.obteniendo_precios');
    await this.obtener_precios(reset);
    this.loading = false;
  }, 500);
},

 debouncedObtenerPerfiles() {
  console.log("Llamando a debounced obtener perfiles")
  if (this.timeoutPrecios) clearTimeout(this.timeoutPrecios);
  this.timeoutPrecios = setTimeout(async () => {
    this.loading = true;
    this.mensaje_loading = this.$t('mensajes.obteniendo_perfiles');
    await this.obtener_perfiles();
    this.loading = false;
  }, 500);
},

   async obtener_precios(reset = false) {
  try {
   
    if (reset) {
      this.series.pcmd = [];                // limpia memoria local
     
      this.base_pcmd_snapshot = undefined;  
    }
    //Se selecciona el mínimo de los años de las tecnologías que estén presentes y H2
    const valores = [
      this.datos_generales.anio_inicio,
    ]
    if(this.ejecucion.OPC_PV!==0){
       valores.push(this.datos_generales.anio_inicio_solar)
    }
    if(this.ejecucion.OPC_EOL!==0){
       valores.push(this.datos_generales.anio_inicio_eolica)
    }
    const start_year = Math.min(
      ...valores
    );
    const end_year = this.datos_generales.anio_fin;

    const response = await axios({
      method: 'get',
      url: `${process.env.VUE_APP_API_BASE_URL}/api/precios?start_year=${start_year}&end_year=${end_year}`,
      withCredentials: true,
      headers: {
        Authorization: "Bearer " + store.state.token,
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json'
      },
      responseType: 'blob'
    });

    const arrayBuffer = await new Promise((resolve, reject) => {
      const fr = new FileReader();
      fr.onload = e => resolve(e.target.result);
      fr.onerror = err => reject(err);
      fr.readAsArrayBuffer(response.data);
    });

    const zip = await JSZip.loadAsync(arrayBuffer);
    const fileName = Object.keys(zip.files).find(f => f.endsWith('.json'));
    if (!fileName) {
      console.error("No se encontró un archivo JSON en el ZIP.");
      return;
    }

    const jsonContent = await zip.file(fileName).async("string");
    let nuevosDatos = JSON.parse(jsonContent); 

   
    nuevosDatos = nuevosDatos.map(fila => {
      const out = { periodo: fila.periodo };
      Object.keys(fila).forEach(k => {
        if (k === 'periodo') return;
        out[String(k)] = fila[k];
      });
      return out;
    });

    // NUEVA SIMULACIÓN -> sobrescribe 
    if (reset || !(Array.isArray(this.series.pcmd) && this.series.pcmd.length)) {
      this.series.pcmd = nuevosDatos;
      return; // no hacemos merge
    }

    // Simulación en curso -> fusión
    const existentes = this.series.pcmd || [];
    const mapaExist = new Map(existentes.map(f => [f.periodo, { ...f }]));
    const isEmpty = v => v === null || v === undefined || v === "" || (typeof v === "number" && Number.isNaN(v));

    for (const filaNueva of nuevosDatos) {
      const periodo = filaNueva.periodo;
      if (!mapaExist.has(periodo)) {
        mapaExist.set(periodo, { ...filaNueva });
        continue;
      }
      const filaExist = mapaExist.get(periodo);
      for (const key of Object.keys(filaNueva)) {
        if (key === "periodo") continue;
        if (!(key in filaExist) || isEmpty(filaExist[key])) {
          filaExist[key] = filaNueva[key];
        }
      }
    }

    // recorta a rango de años
    const aniosValidos = [];
    for (let y = parseInt(start_year); y <= parseInt(end_year); y++) aniosValidos.push(String(y));

    this.series.pcmd = Array.from(mapaExist.values()).map(f => {
      const out = { periodo: f.periodo };
      for (const k of Object.keys(f)) {
        if (k === "periodo" || aniosValidos.includes(k)) out[k] = f[k];
      }
      return out;
    });

  } catch (error) {
    console.error("Error al obtener los precios:", error);
  } finally {
    this.loading = false;
  }
},





    async obtener_perfiles() {
        try {
          const start_year=this.datos_generales.anio_inicio
          const end_year =this.datos_generales.anio_fin
            const response = await axios({
                method: 'get',
                url: `${process.env.VUE_APP_API_BASE_URL}/api/perfil_ppa_years?start_year=${start_year}&end_year=${end_year}`,
                withCredentials: true,
                headers: {
                    Authorization: "Bearer " + store.state.token,
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json'
                },
                responseType: 'blob'
            });

            const arrayBuffer = await new Promise((resolve, reject) => {
                const fileReader = new FileReader();
                fileReader.onload = e => resolve(e.target.result);
                fileReader.onerror = err => reject(err);
                fileReader.readAsArrayBuffer(response.data);
            });

            const zip = await JSZip.loadAsync(arrayBuffer);
            const fileName = Object.keys(zip.files).find(file => file.endsWith('.json'));

            if (fileName) {
                const jsonContent = await zip.file(fileName).async("string");
                this.perfiles = JSON.parse(jsonContent);
                console.log(this.rows);
            } else {
                console.error("No se encontró un archivo JSON en el ZIP.");
            }

        } catch (error) {
            console.error("Error al obtener los perfiles:", error);
        }
    },


    async obtener_perfil_fotovoltaica(reset = false) {
  try {
    if (reset) {
      this.series.gpv = [];
    }

    const response = await axios({
      method: 'get',
      url: `${process.env.VUE_APP_API_BASE_URL}/api/perfil?tipo=fotovoltaica`,
      withCredentials: true,
      headers: {
        Authorization: "Bearer " + store.state.token,
        'Content-Type': 'application/json'
      },
      responseType: 'blob'
    });

    const arrayBuffer = await new Promise((resolve, reject) => {
      const fr = new FileReader();
      fr.onload = e => resolve(e.target.result);
      fr.onerror = err => reject(err);
      fr.readAsArrayBuffer(response.data);
    });

    const zip = await JSZip.loadAsync(arrayBuffer);
    const fileName = Object.keys(zip.files).find(f => f.endsWith('.json'));

    if (!fileName) return;

    const jsonContent = await zip.file(fileName).async("string");
    let nuevosDatos = JSON.parse(jsonContent);

    // normalizar como eólica/precios
    nuevosDatos = nuevosDatos.map(fila => {
      const out = { periodo: fila.periodo };
      Object.keys(fila).forEach(k => {
        if (k === 'periodo') return;
        out[String(k)] = fila[k];
      });
      return out;
    });

    // primera carga
    if (reset || !this.series.gpv?.length) {
      this.series.gpv = this.nuevaSerieFotovoltaica(
        nuevosDatos,
        this.datos_generales?.anio_inicio_solar,
        this.datos_generales?.anio_fin
      );
      return this.series.gpv;
    }

    // merge inteligente
    const existentes = this.series.gpv;
    const mapaExist = new Map(existentes.map(f => [f.periodo, { ...f }]));

    const isEmpty = v =>
      v === null || v === undefined || v === "" || Number.isNaN(v);

    for (const filaNueva of nuevosDatos) {
      const periodo = filaNueva.periodo;

      if (!mapaExist.has(periodo)) {
        mapaExist.set(periodo, { ...filaNueva });
        continue;
      }

      const filaExist = mapaExist.get(periodo);

      for (const key of Object.keys(filaNueva)) {
        if (key === "periodo") continue;

        if (!(key in filaExist) || isEmpty(filaExist[key])) {
          filaExist[key] = filaNueva[key];
        }
      }
    }

    const years = this.yearsPV.map(String);

    this.series.gpv = Array.from(mapaExist.values()).map(f => {
      const out = { periodo: f.periodo };
      for (const k of Object.keys(f)) {
        if (k === "periodo" || years.includes(k)) out[k] = f[k];
      }
      return out;
    });

    this.series.gpv = this.nuevaSerieFotovoltaica(
      this.series.gpv,
      this.datos_generales?.anio_inicio_solar,
      this.datos_generales?.anio_fin
    );

    return this.series.gpv;

  } catch (error) {
    console.error("Error al obtener perfil fotovoltaica:", error);
  }
},

   async obtener_perfil_eolica(reset = false) {
  try {

    if (reset) {
      this.series.geol = [];
    }

    const response = await axios({
      method: 'get',
      url: `${process.env.VUE_APP_API_BASE_URL}/api/perfil?tipo=eolica`,
      withCredentials: true,
      headers: {
        Authorization: "Bearer " + store.state.token,
        'Content-Type': 'application/json'
      },
      responseType: 'blob'
    });

    const arrayBuffer = await new Promise((resolve, reject) => {
      const fr = new FileReader();
      fr.onload = e => resolve(e.target.result);
      fr.onerror = err => reject(err);
      fr.readAsArrayBuffer(response.data);
    });

    const zip = await JSZip.loadAsync(arrayBuffer);
    const fileName = Object.keys(zip.files).find(f => f.endsWith('.json'));

    if (!fileName) return;

    const jsonContent = await zip.file(fileName).async("string");
    let nuevosDatos = JSON.parse(jsonContent);

    // normalizar como precios
    nuevosDatos = nuevosDatos.map(fila => {
      const out = { periodo: fila.periodo };
      Object.keys(fila).forEach(k => {
        if (k === 'periodo') return;
        out[String(k)] = fila[k];
      });
      return out;
    });

    if (reset || !this.series.geol?.length) {
      this.series.geol = nuevosDatos;
      return nuevosDatos;
    }

    
    const existentes = this.series.geol;
    const mapaExist = new Map(existentes.map(f => [f.periodo, { ...f }]));

    const isEmpty = v =>
      v === null || v === undefined || v === "" || Number.isNaN(v);

    for (const filaNueva of nuevosDatos) {
      const periodo = filaNueva.periodo;

      if (!mapaExist.has(periodo)) {
        mapaExist.set(periodo, { ...filaNueva });
        continue;
      }

      const filaExist = mapaExist.get(periodo);

      for (const key of Object.keys(filaNueva)) {
        if (key === "periodo") continue;

        if (!(key in filaExist) || isEmpty(filaExist[key])) {
          filaExist[key] = filaNueva[key];
        }
      }
    }

    // filtrar años válidos
    const years = this.yearsEol.map(String);

    this.series.geol = Array.from(mapaExist.values()).map(f => {
      const out = { periodo: f.periodo };
      for (const k of Object.keys(f)) {
        if (k === "periodo" || years.includes(k)) out[k] = f[k];
      }
      return out;
    });

    return this.series.geol;

  } catch (error) {
    console.error("Error al obtener perfil eólica:", error);
  }
},
    async obtener_demanda(tipo, start_year, end_year) {
        try {
            const response = await axios({
                method: 'get',
                url: `${process.env.VUE_APP_API_BASE_URL}/api/demanda?tipo=${tipo}&start_year=${start_year}&end_year=${end_year}`,
                withCredentials: true,
                headers: {
                    Authorization: "Bearer " + store.state.token,
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json'
                },
                responseType: 'blob'
            });

            const arrayBuffer = await new Promise((resolve, reject) => {
                const fileReader = new FileReader();
                fileReader.onload = e => resolve(e.target.result);
                fileReader.onerror = err => reject(err);
                fileReader.readAsArrayBuffer(response.data);
            });

            const zip = await JSZip.loadAsync(arrayBuffer);
            const fileName = Object.keys(zip.files).find(file => file.endsWith('.json'));

            if (fileName) {
                const jsonContent = await zip.file(fileName).async("string");
                //console.log("DEMANDA de tipo ", tipo, "JSON.parse(jsonContent): ", JSON.parse(jsonContent))
                this.demanda[tipo] = JSON.parse(jsonContent);
                //De momento se deja igual que la demanda base para casos de prueba
                this.demanda_lc[tipo]= JSON.parse(jsonContent);
                this.demanda_lc_zero[tipo]=JSON.parse(jsonContent)
                this.demanda_lc_zero[tipo].forEach(fila => {
                  fila.dH2VOb = 0;
                  fila.dH2VOp=0;
                });
                console.log(this.rows);
            } else {
                console.error("No se encontró un archivo JSON en el ZIP.");
            }

        } catch (error) {
            console.error("Error al obtener la demanda:", error);
        }
    },


    async actualizar_demandas(){
      let start_year = this.datos_generales.anio_inicio
      //let end_year = this.datos_generales.anio_fin
      await this.obtener_demanda("d1", start_year, 2100)
      await this.obtener_demanda("d2", start_year, 2100)      
      await this.obtener_demanda("d4", start_year, 2100) 
    },
    async generar_venta_ppa(anio_inicio,anio_fin){
      const datos=[]
      for (let anio = anio_inicio;anio<=anio_fin;anio++){
        datos.push({
          "anio":anio,
          "ppa1":40,
          "ppa2":60,
          "ppa3":150
        })
      }
      this.ppa_venta_excedente=datos
    },
    async generar_datos_anuales(anio_inicio,anio_fin){
      console.log("generando datos manuales")
      const datos=[];
      for (let anio = anio_inicio; anio <= anio_fin; anio++) {
        let corr=0;
        if(anio<=2030){
          corr=1;
        }
        else{
          corr=0
        }
        datos.push({
          anio: anio,
          emi: 25,
          ghg: 50,
          preciol: 20,
          res: 90,
          corr:corr,
        });
      }
      console.log("generando datos manuales ", datos)
      this.datos_anuales=datos
    },
    async generar_datos_economicos(anio_inicio,anio_fin){
      const datos = [];

      for (let anio = anio_inicio; anio <= anio_fin; anio++) {
        datos.push({
          anio: anio,
          impcomc: 2,
          ccomv: 0.02,
          pgdoe: 0.5
        });
      }
      console.log("Años : ", anio_inicio, " - ", anio_fin, " ", datos)
      this.datos_econ_hidrog=datos

    },

    async comprobar_nombre() {
          let nombre = this.datos_generales.nombre
          let username = store.state.usuarioNombre
          this.loading = true;
          try {
          // Hacer la solicitud axios y esperar la respuesta
          const response = await axios({
            method: 'get',
            url: process.env.VUE_APP_API_BASE_URL + "/api/comprobar-nombre?username=" + username + "&nombre=" + nombre,  
            withCredentials: true,                   
            headers: { 
              Authorization: "Bearer " + store.state.token,
              'Access-Control-Allow-Origin': '*',
              'Content-Type': 'application/json'                
            },      
          });

          this.loading = false; // Termina el loading
          let myObject = response.data;

          // Si la respuesta es 'NOK', muestra alerta y limpia el nombre
          if (myObject['response'] === "NOK") {
            Swal.fire(this.$t('mensajes.alerta_ya_existe_nombre'), this.$t('mensajes.accion_ya_existe_nombre'), "warning");
            this.datos_generales.nombre = "";
            console.log("Devuelve false");
            return false; // Devuelve 'false' si el nombre ya existe, para cancelar lanzar_simulacion
          }

          // Si no hay error, devuelve 'true' y se procede con lanzar simulacion
          console.log("Devuelve true");
          return true;

        } catch (error) {
          // Errores de axios
          this.loading = false;
          console.error("Error al comprobar el nombre:", error);
          return false; // Devuelve 'false' si hay un error
        }
    },



    exportData() {
      // Crear un archivo JSON para exportar los datos
      //const json = JSON.stringify(this.datos, null, 2); // Convertir `datos` a JSON con formato
      const json = JSON.stringify(this.agregar_datos(true), null, 2); // Convertir `datos` a JSON con formato

      const blob = new Blob([json], { type: "application/json" }); // Crear un blob
      const url = URL.createObjectURL(blob); // Crear una URL de objeto

      // Crear un enlace temporal para descargar
      const link = document.createElement("a");
      link.href = url;
      link.download = "backup.json"; // Nombre del archivo
      link.click();

      // Liberar la URL de objeto después de usarla
      URL.revokeObjectURL(url);
    },
    async guardarCasoBase(){
      console.log("Guardar caso base")
       const result = await Swal.fire({
            title: "¿Estás seguro?",
            html: `
            <p>Esto actualizará el caso base con los datos actuales.</p>
            <p><b>Importante:</b> los precios de mercado no se guardan en el caso base.</p>
          `,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Sí, actualizar",
            cancelButtonText: "Cancelar",
          });
      try {
          if (result.isConfirmed) {
            this.loading = true;

            if (this.$refs.hijoInputFotovoltaica?.sendaPCPV) {
              this.fotovoltaica.senda_pcpv = this.$refs.hijoInputFotovoltaica.sendaPCPV;
            }

            if (this.$refs.hijoInputEolica?.sendaPCEOL) {
              this.eolica.senda_pceol = this.$refs.hijoInputEolica.sendaPCEOL;
            }

  
            let datos_agregados = {}
              datos_agregados = this.agregar_datos(true)

              datos_agregados.fotovoltaica = {
                ...datos_agregados.fotovoltaica,
                senda_pcpv: this.normalizarSendaPrecioTransferenciaCasoBase(
                  datos_agregados.fotovoltaica?.senda_pcpv,
                  2025,
                  2100
                ),
              };

              datos_agregados.eolica = {
                ...datos_agregados.eolica,
                senda_pceol: this.normalizarSendaPrecioTransferenciaCasoBase(
                  datos_agregados.eolica?.senda_pceol,
                  2025,
                  2100
                ),
              };

              console.log("Datos agregados: ", datos_agregados)
            this.loading = true;
            this.mensaje_loading = "Actualizando caso base"
  
            // Crear un archivo ZIP con JSZip
            const zip = new JSZip();
            zip.file("data.json", JSON.stringify(datos_agregados));
  
            // Generar el archivo ZIP en formato blob
            // Nuevo algoritmo Deflate nivel 9
             const zipBlob = await zip.generateAsync({ 
            type: "blob",
              compression: "DEFLATE",
              compressionOptions: { level: 9 }

          });
            // Crear un objeto FormData para enviar el archivo ZIP
            const formData = new FormData();
            formData.append("file", zipBlob, "data.zip");
            
            // Enviar los datos al servidor            
            await axios({
              method: "post",
              url: process.env.VUE_APP_API_BASE_URL + "/api/cargar-caso-base/",
              data: formData,
              withCredentials: true,
              headers: {
                Authorization: "Bearer " + store.state.token,
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "multipart/form-data",
              },
              responseType: 'blob' // Asegura que recibimos un archivo binario
            })
            this.loading = false;
          }
      }
      catch(error){
        console.error("Error guardando caso base ", error)
      }
      finally {
        this.loading = false;
      }
      console.log("fin")
    },

    async saveData() {
      console.log("Save Data")
      try {
        this.loading = true;
        this.mensaje_loading = "Guardando en la nube...";

        // Agregar los datos
        const datos_agregados = this.agregar_datos(true);

        // Crear un archivo ZIP con JSZip
        const zip = new JSZip();
        zip.file("data.json", JSON.stringify(datos_agregados));

        // Generar el archivo ZIP en formato blob
        // Nuevo algoritmo Deflate nivel 9
             const zipBlob = await zip.generateAsync({ 
            type: "blob",
              compression: "DEFLATE",
              compressionOptions: { level: 9 }

          });
        // Crear un objeto FormData para enviar el archivo ZIP
        const formData = new FormData();
        formData.append("file", zipBlob, "data.zip");

        // Enviar los datos al servidor
        await axios({
          method: "post",
          url: process.env.VUE_APP_API_BASE_URL + "/api/guardar/",
          data: formData,
          withCredentials: true,
          headers: {
            Authorization: "Bearer " + store.state.token,
            "Content-Type": "multipart/form-data",
          },
          responseType: 'blob'
        });

        // Alerta de proceso correcto
        
        Swal.fire(this.$t('mensajes.simulacion_guardada_nube'));



      } catch (error) {
        console.error("Error al guardar los datos:", error);
        alert("Ha ocurrido un error al guardar los datos.");
      } finally {
        this.loading = false;
      }
    },




    importData() {

      
      //this.gen['poiv'] = 2
      //this.gen = {'poiv':1, 'poic':2}
      //this.gen = {...{'poiv':3, 'poic':2}}
      

      // Crear un input para seleccionar un archivo
      const input = document.createElement("input");
      input.type = "file";
      input.accept = "application/json";

      // Leer el archivo seleccionado
      input.addEventListener("change", (event) => {
        const file = event.target.files[0];
        if (file) {
          const reader = new FileReader();
          reader.onload = (e) => {
            try {
              const importedData = JSON.parse(e.target.result); // Parsear el JSON
              // pisa username con el usuario presente
              importedData.username = store.state.usuarioNombre;

              if (importedData.data) importedData.data.username = store.state.usuarioNombre;
              
              if(importedData.ejecucion.ANIO_PPA_INI) delete importedData.ejecucion.ANIO_PPA_INI;
              if(importedData.ejecucion.ANIO_PPA_FIN) delete importedData.ejecucion.ANIO_PPA_FIN;
              console.log("Import: ", importedData)
              console.log("PreImportar: ", {...this.ppa_precio_compra_matrix})
              this.capexEditadoManualmente = true;
              this.subvEditadoManualmente = true;
              this.importandoDatos = true;

              this.desagregar_datos(importedData);
              this.datosCasoBaseCargados = true;

              this.$nextTick(() => {
                this.importandoDatos = false;
              });
              console.log("dats[perfiles] :", importedData['perfiles'])
              console.log("dats[perfiles] 2:", this.perfiles)
              /* Para retrocompatibilidad */
              const test=false
              this.perfiles=importedData['perfiles']
              if (Array.isArray(importedData['perfiles']) && test){
                console.log("Hemos entrado")
                 // Inicializamos los dicts vacíos
                 const perfilesArray= importedData['perfiles']
                  const resultado  = {
                    PPA1: [],
                    PPA2: [],
                    PPA3: []
                  };
                  // Número total de periodos por año
                 perfilesArray.forEach(item => {
                  const obj1 = { periodo: item.periodo };
                  const obj2 = { periodo: item.periodo };
                  const obj3 = { periodo: item.periodo };

                  for (let anio = this.datos_generales.anio_inicio; anio <= this.datos_generales.anio_fin; anio++) {
                    obj1[anio] = item.ppa1;
                    obj2[anio] = item.ppa2;
                    obj3[anio] = item.ppa3;
                  }

                  resultado.PPA1.push(obj1);
                  resultado.PPA2.push(obj2);
                  resultado.PPA3.push(obj3);
                });
                  console.log("perfilesDict: ",resultado)
                  this.perfiles = resultado;
              
              }
              console.log("Perfiles actualizados")

              //console.log("2. Reparto Capex ", this.datos_economicos.reparto_capex)
              if (this.$refs.hijoOtrosCostes) this.$refs.hijoOtrosCostes.actualizarDatos()
              if (this.$refs.hijoPPAConf)this.$refs.hijoPPAConf.actualizarDatos()
              if (this.$refs.hijoPPAPerf)this.$refs.hijoPPAPerf.actualizarDatos()
              
              if (this.$refs.hijoInEjec)this.$refs.hijoInEjec.actualizarDatos()

              if (this.$refs.hijoPlantaElectrolisis)this.$refs.hijoPlantaElectrolisis.actualizarDatos()
              if (this.$refs.hijoInputAlmacenamiento)this.$refs.hijoInputAlmacenamiento.actualizarDatos()
              if (this.$refs.hijoInputBateria)this.$refs.hijoInputBateria.actualizarDatos()
              if (this.$refs.hijoInputFotovoltaica)this.$refs.hijoInputFotovoltaica.actualizarDatos()
              
              if (this.$refs.hijoInputEolica)this.$refs.hijoInputEolica.actualizarDatos()
              
               //console.log("4. Toca actualizar datos Economicos -> ", this.datos_economicos)

               
               setTimeout(() => {
                  // Todo el código que debe ejecutarse DESPUÉS de la espera va aquí.
                  //console.log('2. Continúa después de 2 segundos. fotovoltaica->');
                  //console.log("3. Toca actualizar fotovoltaica-> ", this.series.gpv)
              //if (this.$refs.hijoInputPerfilFotovoltaica)this.$refs.hijoInputPerfilFotovoltaica.actualizarDatos()
              //if (this.$refs.hijoInputPerfilEolica)this.$refs.hijoInputPerfilEolica.actualizarDatos()
                }, 2000);
                
                /* const toPu6 = v => {
                    let n = Number(v);
                    if (!Number.isFinite(n)) n = 0;
                    if (n > 1.1) n = n / 100; 
                    return Number(n.toFixed(6));
                  };
                const repImportado = importedData['datos_economicos']?.reparto_capex ?? [];
                //fozar a quedarse reparto capex:
                this.datos_economicos.reparto_capex = repImportado.map(it => {
                // Si ya viene en formato nuevo, úsalo tal cual
                if ('capexh2' in it || 'capexpv' in it || 'capexeol' in it) {
                  return {
                    ano: Number(it.ano),
                    capexh2:  toPu6(it.capexh2),
                    capexpv:  toPu6(it.capexpv),
                    capexeol: toPu6(it.capexeol),
                  };
                }
                // Legacy: replica 'valor' a las 3 columnas
                const v = toPu6(it.valor);
                return { ano: Number(it.ano), capexh2: v, capexpv: v, capexeol: v };
              }); */
              // hijoInputFotovoltaica
              // hijoInputPerfilFotovoltaica
              // ref="hijoInputEolica"
              // hijoInputPerfilEolica

              //hijoInputBateria
              console.log("Fin de Import")
            } catch (err) {
              console.error("Error al importar JSON:", err);
              alert("El archivo no es válido o tiene un formato incorrecto.");
            }
          };
          reader.readAsText(file); // Leer el contenido del archivo como texto
        }
      });

      // Simular un clic en el input
      input.click();
    },

    async descargar_resultados(sinHorarios = false) {
  this.loading = true;
  this.mensaje_loading = this.$t('mensajes.obteniendo_resultados');
  try {
    const response = await axios({
      method: 'get',
      url: `${process.env.VUE_APP_API_BASE_URL}/api/descargar-resultado/${this.id}`,
      responseType: 'blob',
      headers: { Authorization: 'Bearer ' + store.state.token },
      params: { horario: sinHorarios ? 0 : 1 }
    });

    const blob = new Blob([response.data], { type: 'application/zip' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;

    const sufijo = sinHorarios ? '_sin_horarios' : '';
    a.download = `informe_completo_${this.id}${sufijo}.zip`;

    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  } catch (err) {
    console.error('Error al descargar el archivo:', err);
  } finally {
    this.loading = false;
  }
},

 

    async obtener_entradas(id) {
          

          let response = await axios({
              method: 'get',
              url: process.env.VUE_APP_API_BASE_URL + "/api/descargar-entrada/" + id,
              withCredentials: true,
              headers: {
                  Authorization: "Bearer " + store.state.token,
                  'Access-Control-Allow-Origin': '*',
                  'Content-Type': 'application/json'
              },
              responseType: 'blob' // Asegura que recibimos un archivo binario
          })
          //.then((response) => {
              this.loading = false;

              // Crear un objeto FileReader para leer el blob
              const fileReader = new FileReader();

              fileReader.onload = (event) => {
                  const arrayBuffer = event.target.result;

                  // Usar JSZip para descomprimir el archivo
                  JSZip.loadAsync(arrayBuffer).then((zip) => {
                      // Asumimos que el archivo JSON está en la raíz del ZIP
                      const fileName = Object.keys(zip.files).find(file => file.endsWith('.json'));

                      if (fileName) {
                          zip.file(fileName).async("string").then((jsonContent) => {
                              
                              //console.log(JSON.stringify(jsonContent))
                              //this.datos = JSON.parse(jsonContent);
                              const importedData=JSON.parse(jsonContent)
                              this.desagregar_datos(importedData);
                              // Para retrocompatibilidad
                              if (Array.isArray(importedData['perfiles'])){
                                this.perfiles = importedData['perfiles'];
                              }

                              console.log(this.rows);
                          }).catch((err) => {
                              console.error("Error leyendo el archivo JSON del ZIP:", err);
                          });
                      } else {
                          console.error("No se encontró un archivo JSON en el ZIP.");
                      }
                  }).catch((err) => {
                      console.error("Error descomprimiendo el archivo ZIP:", err);
                  });
              };

              // Leer el blob como ArrayBuffer
              fileReader.readAsArrayBuffer(response.data);
          //})
          //.catch((error) => {
          //    this.loading = false;
          //    console.error("Error al obtener los precios:", error);
          //});
    },

    async obtener_resultado_anual(id){
      
        
        let response = await axios(
            {
                method: 'get',
                url: process.env.VUE_APP_API_BASE_URL + '/api/descargar-resultado-anual/' + id,    
                withCredentials: false,                   
                headers: { 
                  Authorization: "Bearer " + store.state.token,
                  'Access-Control-Allow-Origin': '*',
                  'Content-Type': 'application/json'                
                },      
            }
        )
        //.then((response) => {                
            let myObject = response.data;            
            this.resultado.anual = myObject    
            console.log("REsultado anual: ", this.resultado.anual)      
        //})



    },


    async obtener_resultado_variables(id){
      
        
        let response = await axios(
            {
                method: 'get',
                url: process.env.VUE_APP_API_BASE_URL + '/api/descargar-resultado-variables/' + id,    
                withCredentials: false,                   
                headers: { 
                  Authorization: "Bearer " + store.state.token,
                  'Access-Control-Allow-Origin': '*',
                  'Content-Type': 'application/json'                
                },      
            }
        )
        //.then((response) => {                
            let myObject = response.data;            
            this.resultado = myObject    
            console.log("Resultado : ", this.resultado)
            if (typeof this.resultado === 'string') {
              try {
                console.log("Es string")
                this.resultado= JSON.parse(this.resultado); // Intenta parsear el string
              } catch (e) {
                console.error('Error al parsear JSON:', e);
              }
            }
            this.valores_diagrama = this.resultado.diagrama          
            //console.log(JSON.stringify(this.resultado_variables))    
            this.resumenFlujosCaja = this.resultado.resumen_flujos_caja;
            this.datosSalAn2 = this.resultado.datos_sal_an2;
            this.datosSalAn = this.resultado.datos_sal_an;

            console.log("resumenFlujosCaja:", this.resumenFlujosCaja);
            console.log("datosSalAn2:", this.datosSalAn2);
            console.log("datosSalAn:", this.datosSalAn);       
        //})



    },




   async leerJsonDesdeZipBlob(blob) {
  const arrayBuffer = await blob.arrayBuffer();
  const zip = await JSZip.loadAsync(arrayBuffer);
  const fileName = Object.keys(zip.files).find(file => file.endsWith(".json"));

  if (!fileName) {
    throw new Error("No se encontró un archivo JSON en el ZIP.");
  }

  const jsonContent = await zip.file(fileName).async("string");
  return JSON.parse(jsonContent);
},

async obtener_caso_base() {
  try {
    const response = await axios({
      method: 'get',
      url: process.env.VUE_APP_API_BASE_URL + "/api/descargar-caso-base/",
      withCredentials: true,
      headers: {
        Authorization: "Bearer " + store.state.token,
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json'
      },
      responseType: 'blob'
    });

    const datos = await this.leerJsonDesdeZipBlob(response.data);
    this.desagregar_datos(datos);

    return datos;

  } catch (error) {
    console.error("Error al obtener el caso base:", error);
    throw error;
  }
},


    async recuperar_simulacion_guardada() {
        
        try {
            const response = await axios({
                method: 'get',
                url: process.env.VUE_APP_API_BASE_URL + "/api/recuperar-simulacion-guardada/" + this.uuid + "/",
                withCredentials: true,
                headers: {
                    Authorization: "Bearer " + store.state.token,
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json'
                },
                responseType: 'blob'
            });

            const fileReader = new FileReader();

            fileReader.onload = async (event) => {
                const arrayBuffer = event.target.result;

                try {
                    const zip = await JSZip.loadAsync(arrayBuffer);
                    const fileName = Object.keys(zip.files).find(file => file.endsWith('.json'));

                    if (fileName) {
                        const jsonContent = await zip.file(fileName).async("string");
                        this.desagregar_datos(JSON.parse(jsonContent));
                        console.log(this.rows);
                    } else {
                        console.error("No se encontró un archivo JSON en el ZIP.");
                    }
                } catch (zipError) {
                    console.error("Error descomprimiendo o leyendo el archivo ZIP:", zipError);
                } finally {
                    //this.loading = false;
                    console.error("Finally.");
                }
            };

            fileReader.readAsArrayBuffer(response.data);

        } catch (error) {
            //this.loading = false;
            console.error("Error al obtener los precios:", error);
        }
    },




    validar_datos() {

      const schema = yup.object().shape({          
          nombre: yup.string().required("The simulation must have a name."),
          anio_inicio: yup
            .number()
            .required()
            .integer("The starting year must be an integer.")
            .min(2025, "The starting year must be greater than or equal to 2025."),
          anio_fin: yup
            .number()
            .required("The end year is required.")
            .integer("The final year must be an integer.")
            .test(
              "is-greater-than-start",
              "The end year must be strictly greater than the start year.",
              function (value) {
                const { anio_inicio } = this.parent;
                return value > anio_inicio; // Verifica que sea mayor estrictamente
              }
            ),
         
            electrolizador: yup.object().shape({
              pmin: yup
                .number()
                .required("Electrolyzer minimum value is required.")
                .positive("Electrolyzer minimum value must be positive.")
                .min(0, "Electrolyzer minimum value must be at least 0.")
                .max(1, "Electrolyzer minimum value must be a percentage between 0 and 1."),
              degrad: yup
                .number()
                .required("Electrolyzer performance is required.")
                .positive("Electrolyzer performance must be positive.")
                .min(0, "Electrolyzer performance must be at least 0.")
                .max(1, "Electrolyzer performance must be a percentage between 0 and 1."),
             
              cnag: yup
                .number()
                .required("Water consumption is required.")
                .positive("Water consumption must be positive."),
              pcag: yup
                .number()
                .required("Water price is required.")
                .positive("Water price must be positive."),            
              capexf: yup
                .number()
                .required("Electrolyzer fixed CAPEX is required.")
                .positive("Electrolyzer fixed CAPEX must be positive."),
              capexv: yup
                .number()
                .required("Electrolyzer variable CAPEX is required.")
                .positive("Electrolyzer variable CAPEX must be positive."),
                /* Revisar mensajes de error y si 'opex pertenece aqui:' */
                /* opex: yup
                .number()
                .required("Electrolyzer OPEX is required.")
                .min(0, "Electrolyzer OPEX must be at least 0.")
                .max(1, "Electrolyzer OPEX must be a percentage between 0 and 1."), */
              opexf: yup
                .number()
                .required("Electrolyzer OPEXF is required.")
                .positive("Electrolyzer OPEXF must be positive"),
                opexv: yup
                .number()
                .required("Electrolyzer OPEXV is required.")
                .positive("Electrolyzer OPEXV must be positive"),
              capexr: yup
                .number()
                .required("Stacks revamping CAPEX is required.")
                .positive("Stacks revamping CAPEX must be positive."),
              vutil: yup
                .number()
                .required("Stacks life is required.")
                .positive("Stacks life must be positive."),
              pelfija: yup
                .number()
                .required("Electrolyzer fixed electricity cost is required.")
                .positive("Electrolyzer fixed electricity cost must be positive."),
            }),
            planta_electrolisis: yup.object().shape({
               cauxmn: yup
                .number()
                .required("BOP minimum consumption is required.")
                .min(0, "BOP minimum consumption must be positive.")
                .max(1, "BOP minimum consumption must be a percentage between 0 and 1."),
              cauxmx: yup
                .number()
                .required("BOP maximum consumption is required.")
                .min(0, "BOP maximum consumption must be positive.")
                .max(1, "BOP maximum consumption must be a percentage between 0 and 1."),
            }),
            almacenamiento: yup.object().shape({
              pdia: yup
                .number()
                .required("Static losses are required.")
                .positive("Static losses must be positive.")
                .min(0, "Static losses must be at least 0.")
                .max(1, "Static losses must be a percentage between 0 and 1."),
              piny: yup
                .number()
                .required("Injection losses are required.")
                .positive("Injection losses must be positive.")
                .min(0, "Injection losses must be at least 0.")
                .max(1, "Injection losses must be a percentage between 0 and 1."),
              pext: yup
                .number()
                .required("Extraction losses are required.")
                .positive("Extraction losses must be positive.")
                .min(0, "Extraction losses must be at least 0.")
                .max(1, "Extraction losses must be a percentage between 0 and 1."),
              cele: yup
                .number()
                .required("Internal value is required.")
                .positive("This value must be positive."), // Internally used
              capexf: yup
                .number()
                .required("Storage fixed CAPEX is required.")
                .min(0, "Storage fixed CAPEX must be >= 0."),              
              capexv: yup
                .number()
                .required("Storage variable CAPEX is required.")
                .min(0, "Storage variable CAPEX must be >= 0."),
              calmfija: yup
                .number()
                .required("Internal value is required.")
                .min(0, "Internal value must be >= 0."),
            }),
            bateria: yup.object().shape({
              pmax: yup
                .number()
                .required("Battery maximum value is required.")
                .positive("Battery maximum value must be positive."),
              capac: yup
                .number()
                .required("Battery capacity is required.")
                .positive("Battery capacity must be positive."),
              rend: yup
                .number()
                .required("Battery performance is required.")
                .min(0, "Battery performance must be at least 0.")
                .max(100, "Battery performance must be a percentage between 0 and 100."),
              capexf: yup
                .number()
                .required("Battery fixed CAPEX is required.")
                .min(0,"Battery fixed CAPEX must be positive."), // Adjusted per suggestion
              capexv: yup
                .number()
                .required("Battery variable CAPEX is required.")
                .min(0,"Battery variable CAPEX must be positive."),
              opexf: yup
                .number()
                .required("Battery OPEXF is required.")
                .positive("Battery OPEXF must be positive"),
              opexv: yup
              .number()
              .required("Battery OPEXV is required.")
              .positive("Battery OPEXV must be positive"),
              degrad: yup
                .number()
                .required("Battery degradation is required.")
                .min(0, "Battery degradation must be at least 0.")
                .max(100, "Battery degradation must be a percentage between 0 and 1."),
              vutil: yup
                .number()
                .required("Battery life year is required.")
                .positive("Battery life year must be positive."),
              reempu: yup
                .number()
                .required("Battery revamping CAPEX is required.")
                .positive("Battery revamping CAPEX must be positive.")
                .min(0, "Battery revamping CAPEX must be at least 0.")
                .max(1, "Battery revamping CAPEX must be a percentage between 0 and 1."),
            }),
            fotovoltaica: yup.object().shape({
              poi: yup
                .number()
                .required("POI value is required.")
                .positive("POI value must be positive."),
              capexf: yup
                .number()
                .required("Solar PV fixed CAPEX is required.")
                .min(0,"Solar PV fixed CAPEX must be positive."), // Adjusted per suggestion
              capexv: yup
                .number()
                .required("Solar PV variable CAPEX is required.")
                .min(0,"Solar PV variable CAPEX must be positive."),
              opex: yup
                .number()
                .required("Solar PV OPEX is required.")
                .min(0, "Solar PV OPEX must be at least 0.")
                .max(1, "Solar PV OPEX must be a percentage between 0 and 1."),
              degrad: yup
                .number()
                .required("Solar PV degradation is required.")
                .min(0, "Solar PV degradation must be at least 0.")
                .max(1, "Solar PV degradation must be a percentage between 0 and 1."),
            }),
            eolica: yup.object().shape({
              poi: yup
                .number()
                .required("POI value is required.")
                .positive("POI value must be positive."),
              capexf: yup
                .number()
                .required("Solar PV fixed CAPEX is required.")
                .min(0,"Solar PV fixed CAPEX must be positive."), // Adjusted per suggestion
              capexv: yup
                .number()
                .required("Solar PV variable CAPEX is required.")
                .min(0,"Solar PV variable CAPEX must be positive."),
              opex: yup
                .number()
                .required("Solar PV OPEX is required.")
                .min(0, "Solar PV OPEX must be at least 0.")
                .max(1, "Solar PV OPEX must be a percentage between 0 and 1."),
            }),

            ppa_configuracion: yup.array().of(
              yup.object().shape({
                ppa: yup.string().required(),
                capmax: yup.number().required().min(0),
                pcio: yup.number().required().positive(),
                horas: yup.number().required().integer().min(0),
                cppafija: yup.number().required().min(0),
              })
            ),
            perfiles: yup.array().of(
                yup.object().shape({
                  periodo: yup.number()
                    .required('El campo "periodo" es obligatorio.')
                    .integer('El "periodo" debe ser un número entero.')
                    .positive('El "periodo" debe ser un valor positivo.'),                  
                  ppa1: yup.number()
                    .required('El campo "ppa1" es obligatorio.')
                    .min(0, 'El "ppa1" debe ser mayor o igual a 0.')
                    .max(1, 'El "ppa1" debe ser menor o igual a 1.'),                  
                  ppa2: yup.number()
                    .required('El campo "ppa2" es obligatorio.')
                    .min(0, 'El "ppa2" debe ser mayor o igual a 0.')
                    .max(1, 'El "ppa2" debe ser menor o igual a 1.'),                 
                  ppa3: yup.number()
                    .required('El campo "ppa3" es obligatorio.')
                    .min(0, 'El "ppa3" debe ser mayor o igual a 0.')
                    .max(1, 'El "ppa3" debe ser menor o igual a 1.'),
                })
              ).required('El campo "perfiles" es obligatorio.')
              .min(8760, 'El array "perfiles" debe tener al menos 8760 elementos.'),          

            demanda: yup.object().test(
                'at-least-one-array-not-empty',
                'At least one array in "demanda" must have elements.',
                (value) => {
                  if (!value) return false;
                  // Comprobar si al menos un array tiene elementos
                  return Object.values(value).some((array) => Array.isArray(array) && array.length > 0);
                }
              ).shape({
                d1: yup.array().of(
                  yup.object().shape({
                    id: yup
                      .number()
                      .required()
                      .integer()
                      .min(yup.ref("$anio_inicio"), ({ min }) => `Demanda min: El año debe ser mayor o igual a ${min}.`)
                      .max(yup.ref("$anio_fin"), ({ max }) => `Demanda max: El año debe ser menor o igual a ${max}.`),                  
                    dH2Ob: yup.number().required('dH2Ob is required.'),
                    pcH2Ob: yup.number().required('pcH2Ob is required.'),
                    dH2Op: yup.number().required('dH2Op is required.'),
                    pcH2Op: yup.number().required('pcH2Op is required.'),
                  })
                ).optional(),
                d2: yup.array().of(
                  yup.object().shape({
                    id: yup
                      .number()
                      .required()
                      .integer()
                      .min(yup.ref("$anio_inicio"), ({ min }) => `Demanda min: El año debe ser mayor o igual a ${min}.`)
                      .max(yup.ref("$anio_fin"), ({ max }) => `Demanda max: El año debe ser menor o igual a ${max}.`),
                    dH2Ob: yup.number().required('dH2Ob is required.'),
                    pcH2Ob: yup.number().required('pcH2Ob is required.'),
                    dH2Op: yup.number().required('dH2Op is required.'),
                    pcH2Op: yup.number().required('pcH2Op is required.'),
                  })
                ).optional(),
                d4: yup.array().of(
                  yup.object().shape({
                    id: yup
                      .number()
                      .required()
                      .integer()
                      .min(yup.ref("$anio_inicio"), ({ min }) => `Demanda min: El año debe ser mayor o igual a ${min}.`)
                      .max(yup.ref("$anio_fin"), ({ max }) => `Demanda max: El año debe ser menor o igual a ${max}.`),
                    dH2Ob: yup.number().required('dH2Ob is required.'),
                    pcH2Ob: yup.number().required('pcH2Ob is required.'),
                    dH2Op: yup.number().required('dH2Op is required.'),
                    pcH2Op: yup.number().required('pcH2Op is required.'),
                  })
                ).optional(),
              }),

            series: yup.object().shape({
                  pcmd: yup.array()
                    .of(
                      yup.object().shape({
                        periodo: yup.number().required('El campo "periodo" es obligatorio.'),                      
                      })
                    )
                    .required('El campo "pcmd" es obligatorio.')
                    .min(8760, 'El array "pcmd" debe tener al menos 8760 elementos.'),
                  gpv: yup.array()
                    .of(
                      yup.object().shape({
                        periodo: yup.number().required('El campo "periodo" es obligatorio.'),                      
                      })
                    )
                    .required('El campo "gpv" es obligatorio.')
                    .min(8760, 'El array "gpv" debe tener al menos 8760 elementos.'),
                  geol: yup.array()
                    .of(
                      yup.object().shape({
                        periodo: yup.number().required('El campo "periodo" es obligatorio.'),                      
                      })
                    )
                    .required('El campo "geol" es obligatorio.')
                    .min(8760, 'El array "geol" debe tener al menos 8760 elementos.'),
                }),

            ejecucion: yup.object().shape({
                "Set p": yup.string()
                  .matches(/^\/p\d+\*p\d+\/$/, 'El formato de "Set p" debe ser "/p<number>*p<number>/".')
                  .required('El campo "Set p" es obligatorio.'),
                "Set d": yup.string()
                  .matches(/^\/d\d+\*d\d+\/$/, 'El formato de "Set d" debe ser "/d<number>*d<number>/".')
                  .required('El campo "Set d" es obligatorio.'),
                "Set a": yup.string()
                  .matches(/^\/\d+\*\d+\/;$/, 'El formato de "Set a" debe ser "/<number>*<number>/;".')
                  .required('El campo "Set a" es obligatorio.'),
                "Set m": yup.string()
                  .matches(/^\/m\d+\*m\d+\/;$/, 'El formato de "Set m" debe ser "/m<number>*m<number>/;".')
                  .required('El campo "Set m" es obligatorio.'),
                "OPC_EJEC": yup.number()
                  .required('El campo "OPC_EJEC" es obligatorio.')
                  .oneOf([0, 1, 2], 'El valor de "OPC_EJEC" debe ser 0, 1 o 2.'),
                "OPC_MIP": yup.number()
                  .required('El campo "OPC_MIP" es obligatorio.')
                  .oneOf([0, 1], 'El valor de "OPC_MIP" debe ser 0 o 1.'),
                "OPC_MCDO": yup.number()
                  .required('El campo "OPC_MCDO" es obligatorio.')
                  .oneOf([0, 1], 'El valor de "OPC_MCDO" debe ser 0 o 1.'),
                "OPC_PV": yup.number()
                  .required('El campo "OPC_PV" es obligatorio.')
                  .oneOf([0, 1], 'El valor de "OPC_PV" debe ser 0 o 1.'),
                "OPC_EOL": yup.number()
                  .required('El campo "OPC_EOL" es obligatorio.')
                  .oneOf([0, 1], 'El valor de "OPC_EOL" debe ser 0 o 1.'),
                "OPCDEM_A": yup.number()
                  .required('El campo "OPCDEM_A" es obligatorio.')
                  .oneOf([0, 1], 'El valor de "OPCDEM_A" debe ser 0 o 1.'),
                "OPCDEM_M": yup.number()
                  .required('El campo "OPCDEM_M" es obligatorio.')
                  .oneOf([0, 1], 'El valor de "OPCDEM_M" debe ser 0 o 1.'),
                "OPCDEM_D": yup.number()
                  .required('El campo "OPCDEM_D" es obligatorio.')
                  .oneOf([0, 1], 'El valor de "OPCDEM_D" debe ser 0 o 1.'),
                "TASA_DCTO": yup.number()
                  .required('El campo "TASA_DCTO" es obligatorio.')
                  .min(0, 'La "TASA_DCTO" debe ser un valor positivo.')
                  .max(1, 'La "TASA_DCTO" debe estar entre 0 y 1.'),
                "TASA_INFL": yup.number()
                  .required('El campo "TASA_INFL" es obligatorio.')
                  .min(0, 'La "TASA_INFL" debe ser un valor positivo.')
                  .max(1, 'La "TASA_INFL" debe estar entre 0 y 1.'),
                /* "LIMIT_MCDO": yup.number()
                  .required('El campo "LIMIT_MCDO" es obligatorio.')
                  .positive('El "LIMIT_MCDO" debe ser un valor positivo.'), */
                "OPT_PPA": yup.number()
                  .required('El campo "OPT_PPA" es obligatorio.')
                  .oneOf([0, 1], 'El valor de "OPT_PPA" debe ser 0 o 1.'),
                "OPC_EL": yup.number()
                  .required('El campo "OPC_EL" es obligatorio.')
                  .oneOf([0, 1], 'El valor de "OPC_EL" debe ser 0 o 1.'),
                "OPT_ALM": yup.number()
                  .required('El campo "OPT_ALM" es obligatorio.')
                  .oneOf([0, 1], 'El valor de "OPT_ALM" debe ser 0 o 1.'),
              }),


          
          resultado: yup.array(), // No hay especificaciones para validar
        });

      return schema



    },
    actualizarSubvCapex() {
      if (this.importandoDatos) {
  console.log("actualizarSubvcapex bloqueado durante importación");
  return;
}
      if (this.deshabilitar_subcapex>0){
        console.log("actualizarSubvcapex deshabilitado")
        this.deshabilitar_subcapex-=1
        return
      }
      console.log("Actualizar subvcapex")
      if (this.id_simulacion != null) {
        console.log("NO tocar subvcapex, visualizando simulación");
        return;
      }

      const inicio = parseInt(this.datos_economicos.anio_inicio_capex);
      const cod = parseInt(this.datos_generales.anio_inicio);
      const anio_fin = parseInt(this.datos_generales.anio_fin);

      if (!inicio || !cod || inicio > anio_fin) {
        this.datos_economicos.subvcapex = [];
        return;
      }

      const lista_anios_capex = Array.from(
        { length: anio_fin - inicio + 1 },
        (_, i) => inicio + i
      );
      if (this.subvEditadoManualmente) {
        console.log("Actualizar subvcapex conservando valores manuales/importados por año");

        this.aplicarSubvencionesPorAnio(
          this.datos_economicos.subvcapex || [],
          this.datos_economicos.subvh2v || [],
          this.anioInicioSubvActual || inicio
        );

        return;
      }
      
      //console.log("inicio ", inicio, " anio_fin ", anio_fin)
      this.guardarCacheSubvencionesSiProcede();

const subvAnterior = this.datos_economicos.subvcapex || [];
const subvH2vAnterior = this.datos_economicos.subvh2v || [];

this.datos_economicos.subvcapex = lista_anios_capex.map((anio, idx) => {
  const fallback =
    subvAnterior[idx] !== undefined
      ? subvAnterior[idx]
      : (anio === inicio || anio === cod ? 1 : 0);

  return this.obtenerSubvencionPorAnio("subvcapex", anio, fallback);
});

this.datos_economicos.subvh2v = lista_anios_capex.map((anio, idx) => {
  const fallback = subvH2vAnterior[idx] !== undefined ? subvH2vAnterior[idx] : 0;

  return this.obtenerSubvencionPorAnio("subvh2v", anio, fallback);
});
    },
 esRepartoCapexCero(rep) {
  if (!Array.isArray(rep) || rep.length === 0) return true;

  // legacy: { ano, valor }
  if ('valor' in (rep[0] || {})) {
    return rep.every(r => !(Number(r.valor) > 0));
  }

  // nuevo: { ano, capexh2, capexpv, capexeol }
  const sum = k => rep.reduce((s, r) => s + (Number(r[k]) || 0), 0);
  return sum('capexh2') === 0 && sum('capexpv') === 0 && sum('capexeol') === 0;
},

async init_datos_economicos() {
  const rep = this.datos_economicos.reparto_capex;
  const debeForzar = this.esRepartoCapexCero(rep);
  this.RepartoConsistente({ forzar: debeForzar });
},

    obtenerFechaHoraActual() {
      const ahora = new Date();

      const opciones = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
        timeZone: 'Europe/Madrid'
      };

      const formateado = new Intl.DateTimeFormat('sv-SE', opciones).format(ahora);

      // `sv-SE` da formato ISO-like: YYYY-MM-DD HH:mm:ss (aunque separado con coma, reemplazamos)
      return formateado.replace(',', '');
    },




    agregar_datos( esLanzarSim){

      const toPu6 = v => {
  let n = Number(v);
  if (!Number.isFinite(n)) n = 0;
  if (n > 1.1) n = n / 100; 
  return Number(n.toFixed(6));
};

      let datos = {}
      datos['id'] = this.datos_generales['id']
      datos['nombre'] = this.datos_generales['nombre']
      datos['anio_inicio'] = this.datos_generales['anio_inicio']
      datos['anio_fin'] = this.datos_generales['anio_fin']
      datos['mes_inicio'] = this.datos_generales['mes_inicio']
      datos['anio_solar'] =this.datos_generales['anio_inicio_solar']
      datos['anio_eol'] =this.datos_generales['anio_inicio_eolica']
      datos['mes_inicio_solar'] =this.datos_generales['mes_inicio_solar']
      datos['mes_inicio_eolica'] =this.datos_generales['mes_inicio_eolica']
      datos['usarDucto']=this.usarDucto
      datos['usarConexion']=this.usarConexion
      datos['usarTube']=this.usarTube
      datos['uuid'] = this.datos_generales['uuid']
      datos['last_update'] = ""
      datos['username'] = this.datos_generales['username']

      datos['electrolizador'] = this.electrolizador
      datos['electrolizador_rend'] = this.electrolizador_rend
      datos['electrolizador_degrad']=this.electrolizador_degrad
      datos['planta_electrolisis'] = this.planta_electrolisis
      datos['almacenamiento'] = this.almacenamiento
      datos['bateria'] = this.bateria
      datos['fotovoltaica'] = {
        ...this.fotovoltaica,
        senda_pcpv: this.normalizarSendaPrecioTransferencia(
          this.fotovoltaica?.senda_pcpv,
          this.yearsPV
        ),
      }

      datos['eolica'] = {
        ...this.eolica,
        senda_pceol: this.normalizarSendaPrecioTransferencia(
          this.eolica?.senda_pceol,
          this.yearsEol
        ),
      }
      datos['ppa_configuracion'] = this.ppa_configuracion
      datos['ppa_precio_compra_matrix'] = this.ppa_precio_compra_matrix
      datos['ppa_venta_excedente'] = this.ppa_venta_excedente
      datos['perfiles'] = this.perfiles
      datos['demanda'] = this.demanda
      //Si se está llamando desde lanzar_sim, demanda_lc dependerá
      if (esLanzarSim){
        datos['demanda_lc']=this.demandaLCActual
      }
      //Si no es lanzar_sim, se está guardando caso base
      else{
        datos['demanda_lc']=this.demanda_lc
      }
      datos['series'] = {
        ...this.series,
        gpv: this.nuevaSerieFotovoltaica(
          this.series.gpv,
          this.datos_generales['anio_inicio_solar'],
          this.datos_generales['anio_fin']
        ),
        geol: this.nuevaSerieEolica(
          this.series.geol,
          this.datos_generales['anio_inicio_eolica'],
          this.datos_generales['anio_fin']
        ),
      }

      datos['ejecucion'] = this.ejecucion
      datos['gen'] = this.gen
      datos['peajes']=this.peajes
      //console.log("AGREGANDO  ", this.datos_economicos)
      // Convertimos reparto_capex a p.u.
      datos['datos_economicos'] = {
      ...this.datos_economicos,
     reparto_capex: (this.datos_economicos.reparto_capex || []).map(item => {
    const base = (k) => (item[k] !== undefined ? item[k] : item.valor); // legacy fallback
    return {
      ano: parseInt(item.ano),
      capexh2:  toPu6(base('capexh2')),
      capexpv:  toPu6(base('capexpv')),
      capexeol: toPu6(base('capexeol')),
    };
  }),
  subvcapex: this.datos_economicos.subvcapex,
  subvh2v: this.datos_economicos.subvh2v
};
      
      datos['curvas_generales']= this.curvas
      datos['costes_generales']=this.costes
      datos['conf_costes'] = this.conf_costes
      //Calcular Indices con los que enviar datos:
      /* const primer_index=this.datos_generales.anio_inicio-2025
      const last_index=this.datos_generales.anio_fin-2025+1 */
      datos['datos_anuales']=this.datos_anuales//.slice(primer_index,last_index)
      datos['datos_econ_hidrog']=this.datos_econ_hidrog //.slice(primer_index,last_index)
      datos['demanda_inflaciones']=this.demanda_inflaciones

      console.log("[AGREGAR_DATOS] this.electrolizador_degrad =", JSON.stringify(this.electrolizador_degrad, null, 2));

      console.log("[AGREGAR_DATOS] datos['electrolizador_rend'] =", JSON.stringify(datos['electrolizador_rend'], null, 2));
      console.log("[AGREGAR_DATOS] this.electrolizador_rend =", JSON.stringify(this.electrolizador_rend, null, 2));
      return datos
    },

    desagregar_datos(datos) {

      const toPu6 = v => {
      let n = Number(v);
      if (!Number.isFinite(n)) n = 0;
      if (n > 1.1) n = n / 100;   // si viene en %
      return Number(n.toFixed(6));
    };
      //alert(JSON.stringify(datos['almacenamiento']))
      console.error("Importando 1", );
      this.datos_generales['id'] = datos['id']
      this.datos_generales['nombre'] = datos['nombre']
      //Si se va a cambiar algun año, se deshabilita subcapex para que no se sobreescriba
      if(this.datos_generales['anio_inicio']!=datos['anio_inicio'] ) this.deshabilitar_subcapex+=1
      if(this.datos_generales['anio_fin'] != datos['anio_fin']) this.deshabilitar_subcapex+=1
      if(this.datos_economicos['anio_inicio_capex'] != datos['datos_economicos']['anio_inicio_capex']) this.deshabilitar_subcapex+=1
      //if(  this.datos_generales['mes_inicio']!=datos['mes_inicio'])  this.deshabilitar_subcapex+=1

    
      this.datos_generales['anio_inicio'] = datos['anio_inicio']
      this.datos_generales['anio_fin'] = datos['anio_fin']

      //SI no existen los años en el caso, por retrocompatibilidad se asigna el del año inicial, para compatibilidad con el grid
      this.datos_generales['anio_inicio_solar'] = datos['anio_solar'] || datos['anio_inicio']
      this.datos_generales['anio_inicio_eolica'] = datos['anio_eol'] || datos['anio_inicio']

      this.datos_generales['mes_inicio']=datos['mes_inicio'] 

      this.datos_generales['mes_inicio_solar']=datos['mes_inicio_solar'] || 1
      this.datos_generales['mes_inicio_eolica']=datos['mes_inicio_eolica'] || 1

      this.usarDucto=datos['usarDucto']
      this.usarConexion=datos['usarConexion']
      this.usarTube=datos['usarTube']

      this.datos_generales['uuid'] = datos['uuid']
      this.datos_generales['last_update'] = datos['last_update']
      this.datos_generales['username'] = datos['username']


      console.error("Importando 2", );
      Object.assign(this.electrolizador,datos['electrolizador'])
      this.electrolizador_rend=[]
      Object.assign(this.electrolizador_rend, datos['electrolizador_rend']);
      const degradacionAntigua =
        datos?.electrolizador?.degrad != null
          ? Number(datos.electrolizador.degrad) * 100
          : 0.21;
      const degradacionCasoBase = [
        { id: 1, tramo: 15000, degradacion: degradacionAntigua },
        { id: 2, tramo: 30000, degradacion: degradacionAntigua },
        { id: 3, tramo: 40000, degradacion: degradacionAntigua },
        { id: 4, tramo: 60000, degradacion: degradacionAntigua },
        { id: 5, tramo: 80000, degradacion: degradacionAntigua },
        { id: 6, tramo: 122712, degradacion: degradacionAntigua }
      ];
      const nuevaDegradacion = Array.isArray(datos['electrolizador_degrad'])
        ? datos['electrolizador_degrad'].map((item, index) => ({
            id: item.id ?? index + 1,
            tramo: Number(item.tramo),
            degradacion: Number(item.degradacion)
          }))
        : degradacionCasoBase;
      this.electrolizador_degrad = [];
      console.log(" Elec degrad: ", datos['electrolizador_degrad']);
      Object.assign(this.electrolizador_degrad, nuevaDegradacion);
      console.log("Elec degrad local: ", this.electrolizador_degrad);

      Object.assign(this.planta_electrolisis, datos['planta_electrolisis']);
      Object.assign(this.almacenamiento,datos['almacenamiento'])
      Object.assign(this.bateria,datos['bateria'])
      Object.assign(this.fotovoltaica, datos['fotovoltaica'])
        this.fotovoltaica.senda_pcpv = this.normalizarSendaPrecioTransferencia(
          datos['fotovoltaica']?.senda_pcpv,
          this.yearsPV
        )

        Object.assign(this.eolica, datos['eolica'])
        this.eolica.senda_pceol = this.normalizarSendaPrecioTransferencia(
          datos['eolica']?.senda_pceol,
          this.yearsEol
        )
      console.log("fotovoltaica.pcppapv tras importar:", this.fotovoltaica.pcppapv)
      Object.assign(this.series, datos['series']);
      this.series.geol = this.nuevaSerieEolica(
        this.series.geol,
        datos['anio_eol'] || datos['anio_inicio'],
        datos['anio_fin']
      );
      this.series.gpv = this.nuevaSerieFotovoltaica(
        this.series.gpv,
        datos['anio_solar'] || datos['anio_inicio'],
        datos['anio_fin']
      );
      console.log("eolica.pcppaeol tras importar:", this.eolica.pcppaeol)
     

      Object.assign(this.ppa_configuracion,datos['ppa_configuracion'])
      Object.assign(this.ppa_venta_excedente,datos['ppa_venta_excedente'])
      console.log("Aqui matriz compra local pre",{...this.ppa_precio_compra_matrix})
      
      // Legacy, tiene el problema de si no existe 'ppa_precio_compra_matrix'
      // Object.assign(this.ppa_precio_compra_matrix,datos['ppa_precio_compra_matrix'])

      // Toca hacer el merge por completo por retrocompabilidad, teniendo en cuenta si existe 'ppa_precio_compra_matrix'
      // Retrocompatibilidad por la nueva columna 'Activo'
      const map = new Map();
      //Revisar si existen ppa_precio_compra en los datos a importar
        const nuevosDatos = Array.isArray(datos?.ppa_precio_compra_matrix)
      ? datos.ppa_precio_compra_matrix
      : [];
        for (const item of [...this.ppa_precio_compra_matrix, ...nuevosDatos]) {
          map.set(item.anio, { ...map.get(item.anio), ...item });
        }

      const result = [...map.values()];
      this.ppa_precio_compra_matrix=result
      console.log("AQUI matriz compra local post ",{...this.ppa_precio_compra_matrix} )
      console.log("Perfiles Aqui: ", {...datos['perfiles']})
      Object.assign(this.perfiles,datos['perfiles'])
      console.log("Perfiles Asignado: ", {...this.perfiles})
      Object.assign(this.demanda,datos['demanda'])
      Object.assign(this.demanda_lc,datos['demanda_lc'])
      console.log("datos de demadna_lc", datos['demanda_lc'])
      const claves = Object.keys(datos);
      console.log(claves);  // ["nombre", "edad", "ciudad"]
       console.error("Importando 2.1", );
       //console.log("Datos series fotovoltaica-> ", datos['series'])
      Object.assign(this.series,datos['series'])
      console.log("Ejecucion leida: ", datos['ejecucion'])
      Object.assign(this.ejecucion, datos['ejecucion'])
       console.log("AQUI Ejecucion local: ", this.ejecucion)
      Object.assign(this.gen, datos['gen'])
      //console.log("Datos economicos fotovoltaica-> ", datos['datos_economicos'])
      Object.assign(this.datos_economicos, datos['datos_economicos'])    
      //Darle el formato sobre 100
      //  Normaliza a p.u. al importar
     const repImportado = datos['datos_economicos']?.reparto_capex ?? [];
this.datos_economicos.reparto_capex = repImportado.map(it => {
  // Si ya viene en formato nuevo, úsalo tal cual
  if ('capexh2' in it || 'capexpv' in it || 'capexeol' in it) {
    return {
      ano: Number(it.ano),
      capexh2:  toPu6(it.capexh2),
      capexpv:  toPu6(it.capexpv),
      capexeol: toPu6(it.capexeol),
    };
  }
  // Legacy: replica 'valor' a las 3 columnas
  const v = toPu6(it.valor);
  return { ano: Number(it.ano), capexh2: v, capexpv: v, capexeol: v };
});

      console.log("Reparto: ", this.datos_economicos.reparto_capex)
      console.error("Importando 2.1.2", );
            const subvcapexImportado = Array.isArray(datos['datos_economicos']?.subvcapex)
        ? [...datos['datos_economicos'].subvcapex]
        : [];

      const subvh2vImportado = Array.isArray(datos['datos_economicos']?.subvh2v)
        ? [...datos['datos_economicos'].subvh2v]
        : [];

      const anioInicioCapexImportado = Number(
        datos['datos_economicos']?.anio_inicio_capex || datos['anio_inicio']
      );

      console.log("Subvenciones importadas:", subvcapexImportado);
      console.log("Subvenciones H2V importadas:", subvh2vImportado);

      this.aplicarSubvencionesPorAnio(
        subvcapexImportado,
        subvh2vImportado,
        anioInicioCapexImportado
      );
      this.subvEditadoManualmente = true;
      this.guardarCacheSubvencionesSiProcede(true);

      console.log("Subvenciones locales tras aplicar:", this.datos_economicos.subvcapex);
      console.log("Subvenciones H2V locales tras aplicar:", this.datos_economicos.subvh2v);
      console.log("Cache subvenciones tras importar:", this._cacheSubvenciones);
      console.error("Importando 2.2", );
      Object.assign(this.curvas, datos['curvas_generales'])
      this.costes = this.nuevosCostes(datos['costes_generales']);
      console.error("Importando 4", );
      Object.assign(this.peajes, datos['peajes'])
      //asignar solo los años correspondientes
      console.log("data: ", datos['datos_anuales'])
      const mergedData = this.datos_anuales.map(item => {
        const match = datos['datos_anuales'].find(d => d.anio === item.anio);
        return match ? match : item;
      });
        console.error("Importando 4.1", mergedData);
      Object.assign(this.datos_anuales, mergedData)
      
      const mergedData2 = this.datos_econ_hidrog.map(item => {
        const match = datos['datos_econ_hidrog'].find(d => d.anio === item.anio);
        return match ? match : item;
      });
        console.error("Importando 4.2", );
      Object.assign(this.datos_econ_hidrog, mergedData2)
      console.error("Importando 5", );
      console.log("Costes: ", this.costes)
      Object.assign(this.conf_costes, datos['conf_costes'])

      Object.assign(this.demanda_inflaciones,datos['demanda_inflaciones'])

      const { anio_inicio, anio_fin } = this.datos_generales;
      const num_anios = anio_fin - anio_inicio + 1;

      this.ppa_venta = Array.from({ length: num_anios }, (_, i) => ({
        anio: anio_inicio + i,
        pcppapv: this.fotovoltaica.pcppapv?.[i] ?? 0,
        pcppaeol: this.eolica.pcppaeol?.[i] ?? 0
      }));
    },
    obtenerTablasPorDefecto() {
      let nextId = 1;
      return [
        { nombre: 'Electrolizador', unidad: 'MW', filas: [
          { id: nextId++, unidad: '1', capex: '500', opex: '10' },
          { id: nextId++, unidad: '2', capex: '950', opex: '20' },
          { id: nextId++, unidad: '3', capex: '1400', opex: '35' },
          { id: nextId++, unidad: '4', capex: '1800', opex: '50' },
        ]},
        { nombre: 'BOP', unidad: 'MW', filas: [
          { id: nextId++, unidad: '1', capex: '200', opex: '5' },
          { id: nextId++, unidad: '2', capex: '400', opex: '8' },
          { id: nextId++, unidad: '3', capex: '600', opex: '12' },
          { id: nextId++, unidad: '4', capex: '800', opex: '15' },
        ]},
        { nombre: 'Planta solar fotovoltaica', unidad: 'MW', filas: [
          { id: nextId++, unidad: '1', capex: '300', opex: '3' },
          { id: nextId++, unidad: '2', capex: '600', opex: '6' },
          { id: nextId++, unidad: '3', capex: '900', opex: '9' },
          { id: nextId++, unidad: '4', capex: '1200', opex: '12' },
        ]},
        { nombre: 'Planta eólica', unidad: 'MW', filas: [
          { id: nextId++, unidad: '1', capex: '350', opex: '7' },
          { id: nextId++, unidad: '2', capex: '700', opex: '14' },
          { id: nextId++, unidad: '3', capex: '1050', opex: '21' },
          { id: nextId++, unidad: '4', capex: '1400', opex: '28' },
        ]},
        { nombre: 'Batería', unidad: 'MW', filas: [
          { id: nextId++, unidad: '0.5', capex: '250', opex: '4' },
          { id: nextId++, unidad: '1', capex: '500', opex: '8' },
          { id: nextId++, unidad: '1.5', capex: '750', opex: '12' },
          { id: nextId++, unidad: '2', capex: '1000', opex: '16' },
        ]},
        { nombre: 'Almacenamiento de hidrógeno', unidad: 'tonH2', filas: [
          { id: nextId++, unidad: '10', capex: '300', opex: '6' },
          { id: nextId++, unidad: '20', capex: '600', opex: '12' },
          { id: nextId++, unidad: '30', capex: '900', opex: '18' },
          { id: nextId++, unidad: '40', capex: '1200', opex: '24' },
        ]},
        { nombre: 'Ducto', unidad: 'km', filas: [
          { id: nextId++, unidad: '1', capex: '100', opex: '2' },
          { id: nextId++, unidad: '2', capex: '180', opex: '3.5' },
          { id: nextId++, unidad: '3', capex: '250', opex: '5' },
          { id: nextId++, unidad: '4', capex: '320', opex: '6.5' },
        ]},
       /* { nombre: 'Conexión eléctrica', unidad: 'km', filas: [
          { id: nextId++, unidad: '1', capex: '120', opex: '2.5' },
          { id: nextId++, unidad: '2', capex: '240', opex: '5' },
          { id: nextId++, unidad: '3', capex: '360', opex: '7.5' },
          { id: nextId++, unidad: '4', capex: '480', opex: '10' },
        ]},*/
        { nombre: 'Tube-tráiler', unidad: 'Número', filas: [
          { id: nextId++, unidad: '1', capex: '80', opex: '1.5' },
          { id: nextId++, unidad: '2', capex: '160', opex: '3' },
          { id: nextId++, unidad: '3', capex: '240', opex: '4.5' },
          { id: nextId++, unidad: '4', capex: '320', opex: '6' },
        ]},
      ];
    },


    async obtener_curvas_generales() {
        try {
            const response = await axios({
                method: 'get',
                url: process.env.VUE_APP_API_BASE_URL + "/api/descargar-curvas-generales/",
                withCredentials: true,
                headers: {
                    Authorization: "Bearer " + store.state.token,
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json'
                },
                responseType: 'blob'
            });

            const arrayBuffer = await new Promise((resolve, reject) => {
                const fileReader = new FileReader();
                fileReader.onload = () => resolve(fileReader.result);
                fileReader.onerror = reject;
                fileReader.readAsArrayBuffer(response.data);
            });

            const zip = await JSZip.loadAsync(arrayBuffer);
            const fileName = Object.keys(zip.files).find(file => file.endsWith('.json'));

            if (!fileName) {
                throw new Error("No se encontró un archivo JSON en el ZIP.");
            }

            const jsonContent = await zip.file(fileName).async("string");
            this.curvas = JSON.parse(jsonContent);
            
            console.log(this.curvas);

        } catch (error) {
            console.error("Error al obtener las costes:", error);
        }
    },
    

    async obtener_costes_generales() {
        try {
            const response = await axios({
                method: 'get',
                url: process.env.VUE_APP_API_BASE_URL + "/api/descargar-costes-generales/",
                withCredentials: true,
                headers: {
                    Authorization: "Bearer " + store.state.token,
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json'
                },
                responseType: 'blob'
            });

            const arrayBuffer = await new Promise((resolve, reject) => {
                const fileReader = new FileReader();
                fileReader.onload = () => resolve(fileReader.result);
                fileReader.onerror = reject;
                fileReader.readAsArrayBuffer(response.data);
            });

            const zip = await JSZip.loadAsync(arrayBuffer);
            const fileName = Object.keys(zip.files).find(file => file.endsWith('.json'));

            if (!fileName) {
                throw new Error("No se encontró un archivo JSON en el ZIP.");
            }

            const jsonContent = await zip.file(fileName).async("string");
            this.costes = JSON.parse(jsonContent);
            
            console.log(this.costes);

        } catch (error) {
            console.error("Error al obtener las curvas:", error);
        }
    },
    aniosCapex(ini, fin) {
    ini = parseInt(ini); fin = parseInt(fin);
    if (!ini || !fin || ini > fin) return [];
    return Array.from({ length: fin - ini + 1 }, (_, i) => ini + i);
  },

  repartoEquitativo(anios,limitePV, limiteEOL) {
    //console.log("Reparto capex repartoEquitativo")
    const aniosActivosPV = anios.filter(a => a <= limitePV).length;
    const aniosActivosEOL = anios.filter(a => a <= limiteEOL).length;
    
    const basePV = aniosActivosPV > 0 ? 1 / aniosActivosPV : 0;
    const baseEOL = aniosActivosEOL > 0 ? 1 / aniosActivosEOL : 0;
  const n = Math.max(1, anios.length);
  const base = 1 / n;
  const rep = anios.map(ano => ({ ano, 
    capexh2:base, 
    capexpv:ano <= limitePV ? basePV : NaN, 
    capexeol:ano <= limiteEOL ? baseEOL : NaN }));
  const fix = (k)=> { 
    const reparto_activo = rep.filter(r => !isNaN(r[k]));
        
        // Solo corregimos si hay elementos activos
        if (reparto_activo.length > 0) {
            const sumaActual = reparto_activo.reduce((s, r) => s + (Number(r[k]) || 0), 0);
            const diff = 1 - sumaActual; 
            
            // Encuentra el último año activo y le aplica la diferencia
            // Usamos find para obtener el objeto en el array principal
            const ultimo_activo = rep.find(r => r.ano === reparto_activo[reparto_activo.length - 1].ano);
            ultimo_activo[k] += diff; 
        }

  };
  fix('capexh2'); // H2 usa todos los años
  fix('capexpv');
  fix('capexeol');
  return rep;
},

  RepartoConsistente({ forzar = false } = {}) {
    //console.log("Reparto capex consistente, ", forzar, " ", this.capexEditadoManualmente)
  if (this.id != null) return; // sólo vista

  const anio_capex = this.datos_economicos.anio_inicio_capex;
  const anio_corte = this.datos_generales.anio_inicio;
  const anio_pv = this.datos_generales.anio_inicio_solar;
  const anio_eol= this.datos_generales.anio_inicio_eolica;
  const aniosEsperados = this.aniosCapex(anio_capex, anio_corte);

  let reparto = Array.isArray(this.datos_economicos.reparto_capex) ? [...this.datos_economicos.reparto_capex] : [];

  // % → p.u. (lógica original), sólo si venía legacy
  if (reparto.length && ('valor' in reparto[0]) && !this._repartoPuConvertido &&
      reparto.some(r => (parseFloat(r.valor) || 0) > 1.1)) {
    reparto = reparto.map(r => ({ ...r, valor: (parseFloat(r.valor) || 0) / 100 }));
    this._repartoPuConvertido = true;
  }

  // LEGACY → NUEVO (replica perfil a 3 columnas)
  if (reparto.length && ('valor' in reparto[0])) {
    reparto = reparto.map(r => ({
      ano: r.ano,
      capexh2:  parseFloat(r.valor)||0,
      capexpv:  parseFloat(r.valor)||0,
      capexeol: parseFloat(r.valor)||0,
    }));
  }

  const aniosActuales = reparto.map(r => r.ano);
  const cambianAnios =
    aniosActuales.length !== aniosEsperados.length ||
    aniosEsperados.some((a,i)=>a!==aniosActuales[i]);

  const aniosActualesPV= this.datos_economicos.reparto_capex.filter(r => !isNaN(r.capexpv)).length
  const aniosActualesEOL=  this.datos_economicos.reparto_capex.filter(r => !isNaN(r.capexeol)).length
  const cambianAniosPV=aniosActualesPV!=(anio_pv+1-anio_capex);
  const cambianAniosEOL=aniosActualesEOL!=(anio_eol+1-anio_capex);
  //console.log("Reparto capex-> cambianAnios",cambianAnios , " aniosActualesPV -> ",aniosActualesPV ,"aniosActualesEOL ",aniosActualesEOL," cambianAniosPV ",cambianAniosPV," cambianAniosEOL ",cambianAniosEOL)
  if (forzar || ((cambianAnios || cambianAniosPV || cambianAniosEOL) && !this.capexEditadoManualmente)) {
    this.datos_economicos.reparto_capex = this.repartoEquitativo(aniosEsperados,anio_pv,anio_eol);
  } else {
    const byAno = new Map(reparto.map(r => [r.ano, r]));
    this.datos_economicos.reparto_capex = aniosEsperados.map(a => {
      const r = byAno.get(a) || {};
      return {
        ano: a,
        capexh2:  Number(r.capexh2)  || 0,
        capexpv:  Number(r.capexpv)  || 0,
        capexeol: Number(r.capexeol) || 0,
      };
    });
  }

  // Subvención: conservar valores por año, no por índice
this.guardarCacheSubvencionesSiProcede();

const anio_fin = this.datos_generales.anio_fin;
const subvYears = this.aniosCapex(anio_capex, anio_fin);

const prev = Array.isArray(this.datos_economicos.subvcapex)
  ? this.datos_economicos.subvcapex
  : [];

this.datos_economicos.subvcapex = subvYears.map((anio, i) => {
  const fallback = prev[i] ?? 0;
  return this.obtenerSubvencionPorAnio("subvcapex", anio, fallback);
});

const prevH2v = Array.isArray(this.datos_economicos.subvh2v)
  ? this.datos_economicos.subvh2v
  : [];

this.datos_economicos.subvh2v = subvYears.map((anio, i) => {
  const fallback = prevH2v[i] ?? 0;
  return this.obtenerSubvencionPorAnio("subvh2v", anio, fallback);
});
  //console.log("This. reparto capex -> ", this.datos_economicos.reparto_capex)
},
  async obtener_series_h2(id) {
    if (!id && id !== 0) {
      console.warn('cargarSeriesH2: simId vacío, no se hace la petición');
      return;
    }
    this.loadingSeries = true;
    try {
      const response = await axios({
        method: 'get',
        url: `${process.env.VUE_APP_API_BASE_URL}/api/descargar-series-h2/${id}`,
        withCredentials: true,
        headers: {
          Authorization: "Bearer " + store.state.token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json'
        },
        responseType: 'json'
      });

      const data = response.data || {};
      const entrante = Array.isArray(data.anual) ? data.anual : [];

      if (!this.datos_anuales?.length) {
        await this.generar_datos_anuales(this.anio_inicio, this.anio_fin);
      }

      const basePorAnio = new Map(this.datos_anuales.map(r => [r.anio, { ...r }]));

      const ALLOW = [
        'anio', 'emi', 'ghg', 'preciol', /* fuera 'res' */ 'corr',
        'HEQ_EL', 'HEQ_ELV', 'HEQ_ELL', 'E_MCDV', 'E_ELEC'
      ];

      for (const r of entrante) {
        const yRaw = r.anio ?? r.year ?? r.Year ?? r.ANIO ?? r.Anio;
        const y = Number(yRaw);
        if (!Number.isFinite(y)) continue;

        const target = basePorAnio.get(y) || {
          anio: y,
          emi: 25,
          ghg: 50,
          res: 90,        
          preciol: 20,
          corr: y <= 2030 ? 1 : 0,
          // valores por defecto de HEQ
          HEQ_EL:  0,
          HEQ_ELV: 0,
          HEQ_ELL: 0
        };

        for (const k of ALLOW) {
          if (k in r && r[k] != null) target[k] = r[k];
        }
        basePorAnio.set(y, target);
      }

      this.datos_anuales = Array.from(basePorAnio.values()).sort((a, b) => a.anio - b.anio);

      // --------- SOLO PARA EL GRÁFICO ----------
        const ENERGY = [
          'E_MCDV','E_ELEC','E_MCDL','EH2_PV','EH2_EOL',
          'EH2_PPA1','EH2_PPA2','EH2_PPA3',
          'EH2_ppa1','EH2_ppa2','EH2_ppa3'
        ];
        const HEQ = ['HEQ_EL','HEQ_ELV','HEQ_ELL'];
        const RES_KEYS = ['RES', 'RES_%', 'RES (%)']; 

        const mapGraf = new Map(this.datos_anuales.map(r => [Number(r.anio), { ...r }]));

        for (const r of entrante) {
          const y = Number(r.anio ?? r.year ?? r.Year ?? r.ANIO ?? r.Anio);
          if (!Number.isFinite(y)) continue;

          const tgt = { ...(mapGraf.get(y) || { anio: y }) };

          // Copiar energías
          for (const k of ENERGY) {
            if (k in r && r[k] != null) {
              const v = r[k];
              tgt[k] = (typeof v === 'string' && v.trim() !== '' && !isNaN(v)) ? Number(v) : v;
            }
          }

          // Copiar HEQ_*
          for (const k of HEQ) {
            if (k in r && r[k] != null) {
              const v = r[k];
              tgt[k] = (typeof v === 'string' && v.trim() !== '' && !isNaN(v)) ? Number(v) : v;
            }
          }

          //  COPIAR RES 
          for (const rk of RES_KEYS) {
            if (rk in r && r[rk] != null && r[rk] !== '') {
              tgt.res = r[rk];        // lo normaliza el hijo
              break;
            }
          }
          // Si no viene, usar el por defecto
          if (tgt.res == null) {
            const base = basePorAnio.get(y);
            if (base && base.res != null) tgt.res = base.res;
          }

          mapGraf.set(y, tgt);
        }

        this.datos_anuales_graf = Array.from(mapGraf.values()).sort((a,b)=>a.anio-b.anio);
      // -----------------------------------------

        // horario 
        this.datos_temporales = Array.isArray(data.horario) ? data.horario : [];
      } catch (e) {
        console.error("Error al obtener series H2:", e);
        this.datos_temporales = [];
      } finally {
        this.loadingSeries = false;
      }
    },



nodes(mostrarResultados) {
  const isResults = mostrarResultados === true

  const formatNumber = value => {
    const n = Number(value ?? 0)
    return Number.isFinite(n)
      ? n.toLocaleString('es-ES', { maximumFractionDigits: 2 })
      : '0'
  }

  const sectionWidth = isResults ? '850px' : '590px'

  const electricidadSection = {
    x: 20,
    y: 20,
    width: sectionWidth,
    height: isResults ? '480px' : '290px'
  }

  const hidrogenoSection = {
    x: 20,
    y: isResults ? 520 : 320,
    width: sectionWidth,
    height: isResults ? '520px' : '325px'
  }

  const demandaSection = {
    x: 20,
    y: isResults ? 1060 : 660,
    width: sectionWidth,
    height: isResults ? '260px' : '170px'
  }

  const boardElectricidadStyle = {
    width: isResults ? '770px' : '535px',
    height: isResults ? '420px' : '240px',
    background: '#F0D1B8',
    border: '2px solid #d8a983',
    borderRadius: '16px',
    boxShadow: 'inset 0 0 14px rgba(0,0,0,0.10), 0 6px 14px rgba(36,73,70,0.10)'
  }

  const boardHidrogenoStyle = {
    width: isResults ? '770px' : '550px',
    height: isResults ? '450px' : '280px',
    background: 'linear-gradient(135deg, #93c47d, #d9ead3)',
    border: '2px solid #8ab873',
    borderRadius: '16px',
    boxShadow: 'inset 0 0 14px rgba(0,0,0,0.10), 0 6px 14px rgba(36,73,70,0.10)'
  }

  const boardDemandaStyle = {
    width: isResults ? '500px' : '260px',
    height: isResults ? '200px' : '120px',
    background: 'linear-gradient(135deg, #ffd966, #fff2cc)',
    border: '2px solid #e6c34f',
    borderRadius: '16px',
    boxShadow: 'inset 0 0 14px rgba(0,0,0,0.10), 0 6px 14px rgba(36,73,70,0.10)'
  }

  const sectionStyle = {
    backgroundColor: 'rgba(255, 255, 255, 0.18)',
    border: '1px solid rgba(49, 99, 95, 0.16)',
    borderRadius: '16px'
  }

  const cellStyle = {
    background: 'transparent',
    border: 'none',
    padding: 0
  }

  const tradeGroupStyle = {
    width: isResults ? '350px' : '235px',
    height: isResults ? '200px' : '116px',

    background: `
      linear-gradient(
        135deg,
        #f7f8f8 0%,
        #cfd3d4 18%,
        #ffffff 34%,
        #aeb5b8 52%,
        #eceeee 70%,
        #9fa7aa 100%
      )
    `,

    border: '2px solid rgba(255, 255, 255, 0.85)',
    borderRadius: '16px',

    boxShadow: `
      inset 0 2px 3px rgba(255,255,255,0.85),
      inset 0 -8px 14px rgba(0,0,0,0.18),
      inset 8px 0 16px rgba(255,255,255,0.25),
      inset -8px 0 16px rgba(0,0,0,0.10),
      0 8px 16px rgba(36,73,70,0.22)
    `,

    fontFamily: '"Orbitron", sans-serif',
    fontSize: isResults ? '11px' : '10px',
    fontWeight: 900,
    color: '#182f32',
    textTransform: 'uppercase',
    paddingTop: '4px'
  }

  const cell = ({
    id,
    parentNode,
    x,
    y,
    active,
    image,
    title,
    kind = 'cell-electricidad',
    html = '',
    sourcePositions = [],
    targetPositions = [],
    moduleTarget = null
  }) => {
    const hasHandles = sourcePositions.length > 0 || targetPositions.length > 0

    return {
      id,
      label: title,
      position: { x, y },
      parentNode,
      type: 'custom',
      style: cellStyle,
      draggable: false,
      zIndex: 100,
      data: {
        image: active ? image : '',
        title: active ? title : '',
        html: active ? html : '',
        bgColor: 'transparent',
        templateCell: true,
        emptyCell: !active,
        noHandles: !hasHandles,
        sourcePositions,
        targetPositions,

        moduleTarget: active ? moduleTarget : null,
        clickable: active && !!moduleTarget,

        showResult: isResults,

        cellClass: active
          ? `${kind}${isResults ? ' cell-results' : ''}`
          : `cell-empty${isResults ? ' cell-results' : ''}`
      }
    }
  }

  const totalPPACompra =
    Number(this.valores_diagrama?.PC_PPA1 ?? 0) +
    Number(this.valores_diagrama?.PC_PPA2 ?? 0) +
    Number(this.valores_diagrama?.PC_PPA3 ?? 0)

  const out = [
    {
      id: 'electricidad',
      data: { label: this.$t('diagrama.nodos.electricidad') },
      position: { x: electricidadSection.x, y: electricidadSection.y },
      style: {
        ...sectionStyle,
        background: '#F0E8DE',
        height: electricidadSection.height,
        width: electricidadSection.width
      }
    },

    {
      id: 'hidrogeno',
      data: { label: this.$t('diagrama.nodos.hidrogeno') },
      position: { x: hidrogenoSection.x, y: hidrogenoSection.y },
      style: {
        ...sectionStyle,
        background: '#E0F0C6',
        height: hidrogenoSection.height,
        width: hidrogenoSection.width
      }
    },

    {
      id: 'demanda',
      data: { label: this.$t('diagrama.nodos.demanda') },
      position: { x: demandaSection.x, y: demandaSection.y },
      style: {
        ...sectionStyle,
        background: '#FFFCD5',
        height: demandaSection.height,
        width: demandaSection.width
      }
    },

    {
      id: 'board_electricidad',
      data: { label: '' },
      position: { x: 40, y: 42 },
      parentNode: 'electricidad',
      style: boardElectricidadStyle,
      draggable: false
    },

    {
      id: 'venta',
      data: { label: this.$t('diagrama.nodos.venta') || 'Venta' },
      position: {
        x: isResults ? 40 : 14,
        y: isResults ? 35 : 16
      },
      parentNode: 'board_electricidad',
      style: tradeGroupStyle,
      draggable: false
    },

    {
      id: 'compra',
      data: { label: this.$t('diagrama.nodos.compra') || 'Compra' },
      position: {
        x: isResults ? 400 : 286,
        y: isResults ? 35 : 16
      },
      parentNode: 'board_electricidad',
      style: tradeGroupStyle,
      draggable: false
    },

    {
      id: 'board_hidrogeno',
      data: { label: '' },
      position: {
        x: isResults ? 40 : 20,
        y: isResults ? 48 : 35
      },
      parentNode: 'hidrogeno',
      style: boardHidrogenoStyle,
      draggable: false
    },

    {
      id: 'board_demanda',
      data: { label: '' },
      position: {
        x: isResults ? 175 : 165,
        y: isResults ? 45 : 35
      },
      parentNode: 'demanda',
      style: boardDemandaStyle,
      draggable: false
    },

    // ELECTRICIDAD

    cell({
  id: 'solar',
  parentNode: 'board_electricidad',
  x: isResults ? 70 : 28,
  y: isResults ? 285 : 145,
  active: this.ejecucion.OPC_PV !== 0,
  image: imgSolar,
  title: this.$t('diagrama.nodos.solar'),
  kind: 'cell-electricidad cell-electricidad-top halo-cyan',
  html: isResults ? `${formatNumber(this.valores_diagrama?.PI_PV)} MW` : '',
  sourcePositions: ['top','right','left', 'bottom'],
  moduleTarget: 'solar'
}),
    cell({
  id: 'eolica',
  parentNode: 'board_electricidad',
  x: isResults ? 245 : 146,
  y: isResults ? 285 : 145,
  active: this.ejecucion.OPC_EOL !== 0,
  image: imgEolica,
  title: this.$t('diagrama.nodos.eolica'),
  kind: 'cell-electricidad cell-electricidad-top halo-green',
  html: isResults ? `${formatNumber(this.valores_diagrama?.PI_EOL)} MW` : '',
  sourcePositions: ['top', 'right', 'bottom'],
  moduleTarget: 'eolica'
}),

    cell({
  id: 'bateria',
  parentNode: 'board_electricidad',
  x: isResults ? 420 : 296,
  y: isResults ? 285 : 145,
  active: this.ejecucion.OPC_BAT !== 0,
  image: imgbateria,
  title: this.$t('diagrama.nodos.bess'),
  kind: 'cell-electricidad cell-electricidad-top halo-cyan',
  html: isResults ? `${formatNumber(this.valores_diagrama?.PI_BAT)} MW` : '',
  sourcePositions: ['right', 'bottom'],
   moduleTarget: 'bateria'
}),

   cell({
  id: 'conexion',
  parentNode: 'board_electricidad',
  x: isResults ? 595 : 410,
  y: isResults ? 285 : 145,
  active: true,
  image: imgConexion,
  title: this.$t('diagrama.nodos.conexion_electrica'),
  kind: 'cell-electricidad cell-electricidad-top halo-blue',
  html: isResults
    ? `${this.$t('diagrama.nodos.poi_c')}<br>${formatNumber(this.valores_diagrama?.POI_C)} MW`
    : '',
  sourcePositions: ['top','right','left', 'bottom'],
  targetPositions: ['top','right','left', 'bottom'],
  moduleTarget: 'planta_electrolisis'
}),

    cell({
      id: 'ppas_compra',
      parentNode: 'compra',
      x: isResults ? 22 : 12,
      y: isResults ? 30 : 22,
      active: this.ejecucion.OPC_PPA !== 0,
      image: imgPPA,
      title: 'Contratos PPA',
      kind: 'cell-electricidad',
      html: isResults ? `${formatNumber(totalPPACompra)} MW` : '',
      moduleTarget: 'ppa_compra'
      
    }),

   cell({
  id: 'grid_compra',
  parentNode: 'compra',
  x: isResults ? 185 : 124,
  y: isResults ? 30 : 22,
  active: this.ejecucion.OPC_MCDO !== 3,
  image: imgGrid,
  title: 'Red eléctrica',
  kind: 'cell-electricidad',
  html: isResults ? `${formatNumber(this.valores_diagrama?.POI_C)} MW` : '',
  sourcePositions: ['top','right','left', 'bottom'],
  moduleTarget: 'mercado'
}),

    cell({
      id: 'ppas_venta',
      parentNode: 'venta',
      x: isResults ? 22 : 12,
      y: isResults ? 30 : 22,
      active: this.ejecucion.OPC_PPA !== 0,
      image: imgPPA,
      title: 'Contratos PPA',
      kind: 'cell-electricidad',
      html: isResults ? 'Activa' : '',
      moduleTarget: 'ppa_venta'
       
    }),

    cell({
  id: 'grid_venta',
  parentNode: 'venta',
  x: isResults ? 185 : 124,
  y: isResults ? 30 : 22,
  active: this.ejecucion.OPC_MCDO !== 3,
  image: imgGrid1,
  title: 'Red eléctrica',
  kind: 'cell-electricidad',
  html: isResults ? 'Activa' : '',
  targetPositions: ['bottom'],
   moduleTarget: 'mercado'
}),
    // HIDRÓGENO

    cell({
  id: 'agua',
  parentNode: 'board_hidrogeno',
  x: isResults ? 35 : 22,
  y: isResults ? 155 : 105,
  active: true,
  image: imgAgua,
  title: this.$t('diagrama.nodos.agua'),
  kind: 'cell-hidrogeno',
  html: isResults ? 'Suministro' : '',
  sourcePositions: ['right'],
  moduleTarget: 'electrolizador'
}),

    cell({
  id: 'electrolizador',
  parentNode: 'board_hidrogeno',
  x: isResults ? 245 : 175,
  y: isResults ? 155 : 105,
  active: true,
  image: imgElectrolizador,
  title: this.$t('diagrama.nodos.electrolizador'),
  kind: 'cell-hidrogeno',
  html: isResults
    ? `${formatNumber(this.valores_diagrama?.PI_EL)} MW<br>${formatNumber(this.valores_diagrama?.HEQ ?? this.valores_diagrama?.HFUN)} h`
    : '',
  sourcePositions: ['right', 'bottom'],
  targetPositions: ['top', 'left'],
  moduleTarget: 'electrolizador'
}),

    cell({
  id: 'almacen',
  parentNode: 'board_hidrogeno',
  x: isResults ? 500 : 350,
  y: isResults ? 60 : 40,
  active: this.ejecucion.OPC_ALM !== 0,
  image: imgAlmacen,
  title: this.$t('diagrama.nodos.almacen'),
  kind: 'cell-hidrogeno',
  html: isResults ? `${formatNumber(this.valores_diagrama?.CAP_ALM)} ton H₂` : '',
  sourcePositions: ['right'],
  targetPositions: ['left'],
  moduleTarget: 'almacenamiento'
}),

   cell({
  id: 'camion',
  parentNode: 'board_hidrogeno',
  x: isResults ? 435 : 315,
  y: isResults ? 295 : 185,
  active: this.usarTube,
  image: imgCamion,
  title: this.$t('diagrama.nodos.camion'),
  kind: 'cell-hidrogeno',
  html: isResults ? 'Camión' : '',
  sourcePositions: ['bottom'],
  targetPositions: ['top'],
  moduleTarget: 'planta_electrolisis'
}),

  cell({
  id: 'tubo',
  parentNode: 'board_hidrogeno',
  x: isResults ? 605 : 435,
  y: isResults ? 295 : 185,
  active: this.usarDucto,
  image: imgTubo,
  title: this.$t('diagrama.nodos.tubo'),
  kind: 'cell-hidrogeno',
  html: isResults ? 'Gasoducto' : '',
  sourcePositions: ['bottom'],
  targetPositions: ['top', 'right'],
  moduleTarget: 'planta_electrolisis'
}),

    // DEMANDA

    cell({
  id: 'demanda1',
  parentNode: 'board_demanda',
  x: isResults ? 55 : 22,
  y: isResults ? 28 : 18,
  active: true,
  image: imgDemanda1,
  title: this.$t('diagrama.nodos.demanda1'),
  kind: 'cell-demanda',
  html: isResults ? 'H₂ verde' : '',
  targetPositions: ['top'],
  moduleTarget: 'datos_anuales'
}),
   cell({
  id: 'demanda2',
  parentNode: 'board_demanda',
  x: isResults ? 275 : 140,
  y: isResults ? 28 : 18,
  active: true,
  image: imgDemanda2,
  title: this.$t('diagrama.nodos.demanda2'),
  kind: 'cell-demanda',
  html: isResults ? 'H₂ bajo carbono' : '',
  targetPositions: ['top', 'right'],
  moduleTarget: 'demanda'
}),
  ]

  if (isResults) {
    out.push({
      id: 'resultados_globales',
     position: { x: 885, y: 20 },
style: {
  width: '360px'
},
      draggable: false,
      type: 'custom',
      data: {
        html: `
          <div class="results-table-wrapper">
            <div class="results-table-title">${this.$t('diagrama.nodos.resultados')}</div>

            <table class="results-card-table">
              <thead>
                <tr>
                  <th>Indicador</th>
                  <th>Valor</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>LCOH (pre-tax)</td>
                  <td>${formatNumber(this.valores_diagrama?.LCOH)} EUR/kg/h₂</td>
                </tr>
                <tr>
                  <td>NPV (pre-tax)</td>
                  <td>${formatNumber(this.valores_diagrama?.NPV)} MEUR</td>
                </tr>
                <tr>
                  <td>TIR (pre-tax)</td>
                  <td>${formatNumber(this.valores_diagrama?.TIR)} %</td>
                </tr>
                <tr>
                  <td>${this.$t('diagrama.nodos.demanda_no_suministrada')}</td>
                  <td>${formatNumber(this.valores_diagrama?.HNS)} Ton</td>
                </tr>
              </tbody>
            </table>
          </div>
        `,
        bgColor: '#ffffff',
        noBorder: true,
        noHandles: true,
        resultsCard: true
      }
    })
  }

  return out
},

edges() {
  const edgeStyle = {
    stroke: '#56A197',
    strokeWidth: 5,
    strokeDasharray: '6 6',
    filter: 'drop-shadow(0 0 6px rgba(96, 214, 201, 0.75))'
  }

  const markerEnd = {
    type: 'arrowclosed',
    color: '#56A197',
    width: 6,
    height: 6
  }

  const edge = ({
    id,
    source,
    target,
    sourceHandle,
    targetHandle,
    active = true,
    type = 'smoothstep'
  }) => {
    if (!active) return null

    return {
      id,
      source,
      target,
      sourceHandle,
      targetHandle,
      animated: true,
      type,
      style: edgeStyle,
      markerEnd,
      zIndex: 1000
    }
  }

  return [
    // Fotovoltaica -> Red eléctrica de VENTA
    edge({
  id: 'solar-grid-venta',
  source: 'solar',
  target: 'grid_venta',
  sourceHandle: 'top',
  targetHandle: 'bottom',
  type: 'straight',
  active: this.ejecucion.OPC_PV !== 0 && this.ejecucion.OPC_MCDO !== 3
}),

    edge({
  id: 'eolica-conexion-bottom',
  source: 'eolica',
  target: 'conexion',
  sourceHandle: 'bottom',
  targetHandle: 'bottom',
  type: 'step',
  active: this.ejecucion.OPC_EOL !== 0
}),

// Baterías -> Conexión eléctrica 
edge({
  id: 'bateria-conexion-bottom',
  source: 'bateria',
  target: 'conexion',
  sourceHandle: 'bottom',
  targetHandle: 'bottom',
  type: 'step',
  active: this.ejecucion.OPC_BAT !== 0
}),

    // Red eléctrica de COMPRA -> Conexión eléctrica
    edge({
      id: 'grid-compra-conexion',
      source: 'grid_compra',
      target: 'conexion',
      sourceHandle: 'bottom',
      targetHandle: 'top',
      type: 'straight',
      active: this.ejecucion.OPC_MCDO !== 3
    }),

    // Fotovoltaica -> Conexión eléctrica 
    edge({
      id: 'solar-conexion-bottom',
      source: 'solar',
      target: 'conexion',
      sourceHandle: 'bottom',
      targetHandle: 'bottom',
      type: 'step',
      active: this.ejecucion.OPC_PV !== 0
    }),
    // Eólica -> Grid venta 
    edge({
      id: 'eolica-grid-venta',
      source: 'eolica',
      target: 'grid_venta',
      sourceHandle: 'top',
      targetHandle: 'bottom',
      type: 'straight',
      active: this.ejecucion.OPC_EOL !== 0
    }),

    // Conexión eléctrica -> Electrolizador
    edge({
      id: 'conexion-electrolizador',
      source: 'conexion',
      target: 'electrolizador',
      sourceHandle: 'bottom',
      targetHandle: 'top',
      type: 'smoothstep'
    }),

    // Agua -> Electrolizador
    edge({
      id: 'agua-electrolizador',
      source: 'agua',
      target: 'electrolizador',
      sourceHandle: 'right',
      targetHandle: 'left',
      type: 'straight'
    }),

    // Electrolizador -> Almacenamiento
    edge({
      id: 'electrolizador-almacen',
      source: 'electrolizador',
      target: 'almacen',
      sourceHandle: 'right',
      targetHandle: 'left',
      type: 'smoothstep',
      active: this.ejecucion.OPC_ALM !== 0
    }),

    // Electrolizador -> Tube-trailers
    edge({
      id: 'electrolizador-camion',
      source: 'electrolizador',
      target: 'camion',
      sourceHandle: 'right',
      targetHandle: 'left',
      type: 'smoothstep',
      active: this.usarTube
    }),

    // Electrolizador -> Gasoducto
    edge({
      id: 'electrolizador-tubo',
      source: 'electrolizador',
      target: 'tubo',
      sourceHandle: 'right',
      targetHandle: 'top',
      type: 'smoothstep',
      active: this.usarDucto
    }),

    // Almacenamiento -> Gasoducto 
    edge({
      id: 'almacen-tubo',
      source: 'almacen',
      target: 'tubo',
      sourceHandle: 'right',
      targetHandle: 'right',
      type: 'smoothstep',
      active: this.ejecucion.OPC_ALM !== 0 && this.usarDucto
    }),
    // Almacenamiento -> camiones
    edge({
      id: 'almacen-camion',
      source: 'almacen',
      target: 'camion',
      sourceHandle: 'right',
      targetHandle: 'right',
      type: 'smoothstep',
      active: this.ejecucion.OPC_ALM !== 0 && this.usarDucto
    }),

    // Tube-trailers -> Demanda H2 RFNBO
    edge({
      id: 'camion-demanda1',
      source: 'camion',
      target: 'demanda1',
      sourceHandle: 'bottom',
      targetHandle: 'top',
      type: 'smoothstep',
      active: this.usarTube
    }),

    // Gasoducto -> Demanda H2 no RFNBO
    edge({
      id: 'tubo-demanda2',
      source: 'tubo',
      target: 'demanda2',
      sourceHandle: 'bottom',
      targetHandle: 'top',
      type: 'smoothstep',
      active: this.usarDucto
    })
  ].filter(Boolean)
},

filtradoDiagrama(mostrarResultados) {
  const nodes = this.nodes(mostrarResultados)
  const edges = this.edges()

  const visibles = new Set(nodes.map(n => n.id))

  const edgesFiltradas = edges.filter(e =>
    visibles.has(e.source) && visibles.has(e.target)
  )

  return {
    nodes,
    edges: edgesFiltradas
  }
},
    async obtener_cargos_peajes() {
      try {
        const pais = this.peajes.pais === 1 ? "ES" : "PT";
        const anio = new Date().getFullYear();

        const response = await axios({
          method: "get",
          url: process.env.VUE_APP_API_BASE_URL + `/api/descargar-cargos-peajes/?pais=${pais}&anio=${anio}`,
          withCredentials: true,
          headers: {
            Authorization: "Bearer " + store.state.token,
            "Content-Type": "application/json",
          },
          responseType: "json",
        });

        const data = response.data;
        if (!data || data.status !== "ok") return;


        this.peajes_raw = {
          PeajeTene: data.peaje?.energia ?? [],
          PeajeTpot: data.peaje?.potencia ?? [],
          CargoTene: data.cargo?.energia ?? [],
          CargoTpot: data.cargo?.potencia ?? [],
        };


        this.actualizarPeajesDesdeRaw();

      } catch (e) {
        console.error("Error obtener_cargos_peajes padre:", e);
      }
    },
actualizarPeajesDesdeRaw() {
  const tarifaID = this.peajes.tarifa; // 1..6
  const grupo_tarifario = ["2.0TD","3.0TD","6.1TD","6.2TD","6.3TD","6.4TD"];
  const t = grupo_tarifario[tarifaID - 1];
  const key = "Grupo tarifario";

  const vacio = { [key]: t, t1:0,t2:0,t3:0,t4:0,t5:0,t6:0 };

  const elec_p = (this.peajes_raw.PeajeTene.find(r => r[key]===t) || vacio);
  const pot_p  = (this.peajes_raw.PeajeTpot.find(r => r[key]===t) || vacio);
  const elec_c = (this.peajes_raw.CargoTene.find(r => r[key]===t) || vacio);
  const pot_c  = (this.peajes_raw.CargoTpot.find(r => r[key]===t) || vacio);

  this.peajes.energia_p  = Object.fromEntries(Object.entries(elec_p).filter(([k])=>k!==key));
  this.peajes.potencia_p = Object.fromEntries(Object.entries(pot_p ).filter(([k])=>k!==key));
  this.peajes.energia_c  = Object.fromEntries(Object.entries(elec_c).filter(([k])=>k!==key));
  this.peajes.potencia_c = Object.fromEntries(Object.entries(pot_c ).filter(([k])=>k!==key));
},
    

  },


  async mounted(){
   // console.log("Componente Simulacion Mounted")
     this.prevTab2 = String(this.tab2);
    if (this.uuid == null){

      if (this.id != null){      
        
        console.log("Leer entradas")
        console.log("Leer resultados")

        this.loading = true;
        await this.obtener_entradas(this.id)
        //await this.obtener_resultado_anual(this.id)
        await this.obtener_resultado_variables(this.id)
        //await this.obtener_resultado_economico(this.id)

        //Crear las demandas con ceros:
        this.demanda_lc_zero=this.demanda_lc

        
        this.loading = false;
        
      }  else {
  console.log("Nueva simulación ligera");

  this.loading = true;
  this.mensaje_loading = "Preparando nueva simulación...";

  // Mantener solo estructuras ligeras para que los hijos no fallen
  await this.generar_datos_anuales(this.datos_generales.anio_inicio, 2100);
  await this.generar_datos_economicos(this.datos_generales.anio_inicio, 2100);

  // Esto sí lo dejaría porque viene de tablas externas/Excel de peajes
  await this.obtener_cargos_peajes();

  // Dejar vacíos los datos pesados
  this.series.pcmd = [];
  this.series.gpv = [];
  this.series.geol = [];

  this.demanda = {
    d1: [],
    d2: [],
    d4: [],
  };

  this.demanda_lc = {
    d1: [],
    d2: [],
    d4: [],
  };

  this.demanda_lc_zero = {
    d1: [],
    d2: [],
    d4: [],
  };

  this.datosCasoBaseCargados = false;

  // Mantener nombre/uuid/usuario correctos
  this.datos_generales.nombre = this.$t('simulacion.nombre_defecto');
  this.datos_generales.uuid = uuidv4();
  this.datos_generales.username = store.state.usuarioNombre;

  this.loading = false;
}

      this.mountedReady = true;

     await this.obtener_series_h2(this.id);
      

      console.log("Datos temporales generados:", this.datos_temporales);
      if (this.id == null) {
        //console.log("ACtualizar subvcapex")
          this.actualizarSubvCapex();
      }

    
    } else {
      // Recuperar la simulacion guardada (similar a a hacer un import)

      this.loading = true;
      this.mensaje_loading = this.$t('mensajes.obteniendo_simulacion_guardada');
      await this.recuperar_simulacion_guardada()
      this.loading = false;
    }
    



  },
  computed: {
    // esPerfilesPPALegacy(){
    //   console.log("Recalculando EsperfilesLegacy")
    //   const value=Array.isArray(this.perfiles) &&
    //           this.perfiles?.length > 0 &&
    //           'periodo' in this.perfiles[0] &&
    //           'ppa1' in this.perfiles[0] &&
    //           'ppa2' in this.perfiles[0] &&
    //           'ppa3' in this.perfiles[0];
    //   console.log("Value: EsperfilesLegacy ",value)
    //   return value
    // },

  yearsSim() {
    const ini = Number(this.datos_generales.anio_inicio);
    const fin = Number(this.datos_generales.anio_fin);
    if (!Number.isFinite(ini) || !Number.isFinite(fin) || fin < ini) return [];
    return Array.from({ length: fin - ini + 1 }, (_, i) => ini + i);
  },
  yearsEol(){

    const ini = Number(this.datos_generales.anio_inicio_eolica);
    const fin = Number(this.datos_generales.anio_fin);
    if (!Number.isFinite(ini) || !Number.isFinite(fin) || fin < ini) return [];
    return Array.from({ length: fin - ini + 1 }, (_, i) => ini + i);
  },
  yearsPV(){
    const ini = Number(this.datos_generales.anio_inicio_solar);
    const fin = Number(this.datos_generales.anio_fin);
    if (!Number.isFinite(ini) || !Number.isFinite(fin) || fin < ini) return [];
    return Array.from({ length: fin - ini + 1 }, (_, i) => ini + i);
  },


   usarFVfija: {
    get() { return Number(this.ejecucion?.OPC_PCPPAPV) === 1 },
    set(v) { this.ejecucion.OPC_PCPPAPV = v ? 1 : 0 }
  },
  usarEOfija: {
    get() { return Number(this.ejecucion?.OPC_PCPPAEOL) === 1 },
    set(v) { this.ejecucion.OPC_PCPPAEOL = v ? 1 : 0 }
  },
  mostrarTabPPAs() {
    const offGrid = Number(this.ejecucion?.OPC_MCDO) === 3;
    const sinPPAs = Number(this.ejecucion?.OPC_PPA) === 0;
    const eoFija  = Number(this.usarEOfija) === 1;
    const fvFija  = Number(this.usarFVfija) === 1;

    // ocultar si off-grid o si es sin PPAs y ambos switches apagados
    return !(offGrid || (sinPPAs && !eoFija && !fvFija));
  },


    ppa_venta_filtrada() {
    return this.ppa_venta.filter(fila =>
      fila.anio >= this.datos_generales.anio_inicio &&
      fila.anio <= this.datos_generales.anio_fin
    );
  },
  showDescargarIn(){
    return this.$store.state.company===1;
  },
  tablasConfiguracion() {
    console.log('[Simulacion] Tablas desde Vuex:', this.$store.getters.getTablasConfiguracion);
    return this.$store.getters.getTablasConfiguracion;

    
  },
   resumen_flujos_caja() {
    return this.resultado?.economico?.flujos_caja || [];
  },

  datosSalAn2() {
     return this.resultado?.datos_sal_an2 || [];
    
  },
  datosSalAn2Total() {
     return this.resultado?.datos_sal_an2_total || [];
    
  },
  datosSalAn() {
     return this.resultado?.datos_sal_an|| [];
    
  },

  diagramaConResultados() {
    return this.filtradoDiagrama(true);
  },
  diagramaSinResultados() {
    return this.filtradoDiagrama(false);
  },



  demandaLCActual: {
    get() {
      return this.ejecucion.OPC_MCDO==3
        ? this.demanda_lc_zero // solo lectura
        : this.demanda_lc;     // editable
    },
    set(val) {
        // Emitir solo si está editable
      
        this.$emit("update:demanda_lc", val);
    }
  },

  datosModeloParaBarrido() {
    return this.agregar_datos(true);
  }
  

},
};
</script>

<style scoped>
.ml-4 {
  margin-left: 50px;
}
.mt-4 {
  margin-top: 50px;
}
.custom-container {
    padding-left: 0px; /* Ajusta el padding izquierdo */
    padding-right: 0px; /* Ajusta el padding derecho */
}

.animated-btn {
  transition: transform 0.2s, box-shadow 0.2s;
}

.animated-btn:hover {
  transform: scale(1.1); /* Aumenta ligeramente el tamaño */
  box-shadow: 0px 4px 20px rgba(0, 0, 255, 0.4); /* Sombra azul */
}


</style>
